unit PrjFormAusgangsLoesung;

interface

uses
  System.SysUtils,
  System.Classes,
  JS,
  Web,
  WEBLib.Graphics,
  WEBLib.Controls,
  WEBLib.Forms,
  WEBLib.Dialogs,
  PrjFormDefault,
  Vcl.Graphics,
  Vcl.StdCtrls,
  Vcl.Controls,
  WEBLib.StdCtrls,
  Vcl.Imaging.GIFImg,
  PrjClassHBMDataAccess,
  WEBLib.ExtCtrls,
  WEBLib.ComCtrls,
  Types,
  Vcl.Grids,
  WEBLib.Grids, WEBLib.DBCtrls, Data.DB, WEBLib.DB, XData.Web.JsonDataset, XData.Web.Dataset, XData.Web.Connection;

type
  TPrjFormsAusgangsLoesung = class(TPrjFormsDefault)
    PageControl: TPageControl;
    pgPageInvestition: TTabSheet;
    pgPageAusstattung: TTabSheet;
    pgPageBilanz: TTabSheet;
    pnInvestitionsgueter: TPanel;
    pnAusstattung: TPanel;
    La1_Stat1: TLabel;
    La1_Stat2: TLabel;
    La1_Stat3: TLabel;
    WebLabel18: TLabel;
    WebLabel19: TLabel;
    La1_Inst1: TLabel;
    lblAbteilung1: TLabel;
    lblAbteilung2: TLabel;
    lblAbteilung3: TLabel;
    La1_Inst2: TLabel;
    La1_Inst3: TLabel;
    La1_Inst4: TLabel;
    La1_Inst5: TLabel;
    La1_Inst6: TLabel;
    WebLabel29: TLabel;
    WebLabel1: TLabel;
    WebLabel2: TLabel;
    WebLabel3: TLabel;
    LF1_WahlLeistung1Abt1: TDBEdit;
    LF1_WahlLeistung2Abt1: TDBEdit;
    LF1_WahlLeistung3Abt1: TDBEdit;
    LF1_ArztAbt1: TDBEdit;
    LF1_PflegeAbt1: TDBEdit;
    LF1_Inst1Pers: TDBEdit;
    LF1_WahlLeistung1Abt2: TDBEdit;
    LF1_WahlLeistung2Abt2: TDBEdit;
    LF1_WahlLeistung3Abt2: TDBEdit;
    LF1_ArztAbt2: TDBEdit;
    LF1_PflegeAbt2: TDBEdit;
    LF1_WahlLeistung1Abt3: TDBEdit;
    LF1_WahlLeistung2Abt3: TDBEdit;
    LF1_WahlLeistung3Abt3: TDBEdit;
    LF1_ArztAbt3: TDBEdit;
    LF1_PflegeAbt3: TDBEdit;
    LF1_Inst2Pers: TDBEdit;
    LF1_Inst3Pers: TDBEdit;
    LF1_Inst4Pers: TDBEdit;
    LF1_Inst5Pers: TDBEdit;
    LF1_Inst6Pers: TDBEdit;
    LF1_StartInd: TDBEdit;
    pnBilanz: TPanel;
    pnAktiva: TPanel;
    WebLabel6: TLabel;
    WebLabel12: TLabel;
    WebLabel31: TLabel;
    WebLabel32: TLabel;
    WebLabel33: TLabel;
    WebLabel34: TLabel;
    WebLabel38: TLabel;
    WebLabel39: TLabel;
    WebLabel40: TLabel;
    WebLabel9: TLabel;
    WebLabel10: TLabel;
    WebLabel11: TLabel;
    WebLabel41: TLabel;
    WebLabel42: TLabel;
    RFE_UmlaufVer: TDBEdit;
    RFE_ForderLuL: TDBEdit;
    RFE_ForderKHG: TDBEdit;
    RFE_KassenBes: TDBEdit;
    RFE_MedBedarf: TDBEdit;
    RFE_Lebensmtl: TDBEdit;
    RFE_Imobilien: TDBEdit;
    RFE_MedtechAnl: TDBEdit;
    RFE_Einrichtng: TDBEdit;
    RFE_AnlageVer: TDBEdit;
    pnPassiva: TPanel;
    WebLabel43: TLabel;
    WebLabel44: TLabel;
    WebLabel48: TLabel;
    WebLabel49: TLabel;
    WebLabel50: TLabel;
    WebLabel51: TLabel;
    WebLabel55: TLabel;
    WebLabel56: TLabel;
    WebLabel61: TLabel;
    WebLabel62: TLabel;
    WebLabel63: TLabel;
    WebLabel64: TLabel;
    WebLabel65: TLabel;
    WebLabel57: TLabel;
    RFE_Rueckstell: TDBEdit;
    RFE_UeberzKrd: TDBEdit;
    RFE_KurzfrKrd: TDBEdit;
    RFE_LangfrKrd: TDBEdit;
    RFE_PensRuckst: TDBEdit;
    RFE_Verbindli: TDBEdit;
    RFE_KapRueck: TDBEdit;
    RFE_GewRueck: TDBEdit;
    RFE_GewinnVort: TDBEdit;
    RFE_EigenKap: TDBEdit;
    RFE_GezeichKap: TDBEdit;
    RFE_VerbndlKHG: TDBEdit;
    pnLeftNavigation: TPanel;
    lblPeriode: TLabel;
    lblAbteilung: TLabel;
    lblKrankenhaus: TLabel;
    btnClose: TButton;
    btnSave: TButton;
    spedPeriode: TSpinEdit;
    btnPrint: TButton;
    btnCancel: TButton;
    brnHelp: TButton;
    spedAbteilung: TSpinEdit;
    spedKrankenhaus: TSpinEdit;
    strGridInvestGueter: TStringGrid;
    WebLabel5: TLabel;
    lblArztAbteilung1: TLabel;
    lblArztAbteilung2: TLabel;
    lblArztAbteilung3: TLabel;
    XDataWebConnection1: TXDataWebConnection;
    XDataWebDataSetStartingSolution: TXDataWebDataSet;
    StartingSolutionDataSource: TDataSource;
    RFE_BilSumAkt: TEdit;
    RFE_BilSumPas: TEdit;
    StartingInvestmentWebDataSource: TDataSource;
    XDataWebDataSetStartingInvestment: TXDataWebDataSet;
    StartingDefaultsDataSource: TDataSource;
    XDataWebDataSetStartingDefaults: TXDataWebDataSet;
    pgDefaultData: TTabSheet;
    pnStartingDefaults: TPanel;
    WebLabel4: TLabel;
    WebDBEdit1: TDBEdit;
    WebLabel7: TLabel;
    WebDBEdit2: TDBEdit;
    WebLabel8: TLabel;
    WebDBEdit3: TDBEdit;
    WebLabel13: TLabel;
    WebDBEdit4: TDBEdit;
    WebLabel14: TLabel;
    WebDBEdit5: TDBEdit;
    WebLabel15: TLabel;
    WebDBEdit6: TDBEdit;
    WebLabel16: TLabel;
    procedure btnCancelClick(Sender: TObject);
    procedure btnCloseClick(Sender: TObject);
    procedure btnSaveClick(Sender: TObject);
    procedure RFE_AnlageVerExit(Sender: TObject);
    procedure StartingInvestmentWebDataSourceDataChange(Sender: TObject; Field: TField);
    procedure StartingSolutionDataSourceDataChange(Sender: TObject; Field: TField);
    procedure strGridInvestGueterCanEditCell(Sender: TObject; ACol, ARow: Integer; var CanEdit: Boolean);
    procedure strGridInvestGueterSetEditText(Sender: TObject; ACol, ARow: LongInt; const Value: string);
    procedure XDataWebDataSetStartingDefaultsAfterOpen(DataSet: TDataSet);
    procedure XDataWebDataSetStartingInvestmentAfterOpen(DataSet: TDataSet);
    procedure XDataWebDataSetStartingSolutionAfterOpen(DataSet: TDataSet);
  strict private
    function DrawGridPG1InvestGueter: Boolean;

    [Async]
    function CalculateBilanzSummePG3: Boolean; async;
    [Async]
    function SaveGridPG1InvestGueter: Boolean; async; virtual;
    [Async]
    function SaveData: Boolean; async;
  private
    FDataChanged: Boolean;
    { Private-Deklarationen }
  public
    [Async]
    function Done: Boolean; async; override;
    [Async]
    function Init: Boolean; async; override;

    function ToggleGUI: boolean; virtual;
    { Public-Deklarationen }
  protected
    procedure SetMenuEnable(value: boolean); override;
  published
    property DataChanged: Boolean read FDataChanged write FDataChanged default false;
  protected procedure LoadDFMValues; override; end;

var
  PrjFormsAusgangsLoesung: TPrjFormsAusgangsLoesung;

implementation

{$R *.dfm}

uses
  wxBaseClassWebTools,
  PrjClassHelperClasses,
  PrjFormMain,
  HBMWebData;


procedure TPrjFormsAusgangsLoesung.btnCancelClick(Sender: TObject);
begin
  DataChanged := false;
  close;
end;

procedure TPrjFormsAusgangsLoesung.btnCloseClick(Sender: TObject);
begin
  close;
end;

procedure TPrjFormsAusgangsLoesung.btnSaveClick(Sender: TObject);
begin
  SaveData;
  Self.DrawGridPG1InvestGueter;
  ToggleGUI;
end;

function TPrjFormsAusgangsLoesung.CalculateBilanzSummePG3: Boolean;
begin
  result := true;
  try

    XDataWebDataSetStartingSolution.FieldByName('Hbss_Assets_Fixed').AsFloat := XDataWebDataSetStartingSolution.FieldByName('Hbss_Assets_Buildings').AsFloat +
                                                                                XDataWebDataSetStartingSolution.FieldByName('Hbss_Assets_Med_Systems').AsFloat +
                                                                                XDataWebDataSetStartingSolution.FieldByName('Hbss_Assets_Facilities').AsFloat;


    XDataWebDataSetStartingSolution.FieldByName('Hbss_Curr_Assets').AsFloat := XDataWebDataSetStartingSolution.FieldByName('Hbss_Curr_Assets_Med_Needs').AsFloat +
                                                                               XDataWebDataSetStartingSolution.FieldByName('Hbss_Curr_Assets_Supplies').AsFloat +
                                                                               XDataWebDataSetStartingSolution.FieldByName('Hbss_Curr_Assets_Receivables').AsFloat +
                                                                               XDataWebDataSetStartingSolution.FieldByName('Hbss_Curr_Assets_Receivables_Khg').AsFloat +
                                                                               XDataWebDataSetStartingSolution.FieldByName('Hbss_Curr_Assets_Cash_Balance').AsFloat;

    XDataWebDataSetStartingSolution.FieldByName('Hbss_Curr_Equity').AsFloat := XDataWebDataSetStartingSolution.FieldByName('Hbss_Curr_Equity_Signed_Capital').AsFloat +
                                                                               XDataWebDataSetStartingSolution.FieldByName('Hbss_Curr_Equity_Capital_Reserves').AsFloat +
                                                                               XDataWebDataSetStartingSolution.FieldByName('Hbss_Curr_Equity_Provit_Reserves').AsFloat +
                                                                               XDataWebDataSetStartingSolution.FieldByName('Hbss_Curr_Equity_Retain_Earnings').AsFloat;

    XDataWebDataSetStartingSolution.FieldByName('Hbss_Accruals').AsFloat := XDataWebDataSetStartingSolution.FieldByName('HBSS_ACCRUALS_PENSION').AsFloat;

    XDataWebDataSetStartingSolution.FieldByName('Hbss_Accounts_Payable').AsFloat := XDataWebDataSetStartingSolution.FieldByName('Hbss_Accounts_Payable_Overdrft_Credit').AsFloat +
                                                                                    XDataWebDataSetStartingSolution.FieldByName('Hbss_Accounts_Payable_Short_Credit').AsFloat +
                                                                                    XDataWebDataSetStartingSolution.FieldByName('Hbss_Accounts_Payable_Medium_Credit').AsFloat +
                                                                                    XDataWebDataSetStartingSolution.FieldByName('Hbss_Accounts_Payable_Khg').AsFloat;

    RFE_BilSumAkt.Text  := Str_F_to_Str( XDataWebDataSetStartingSolution.FieldByName('Hbss_Assets_Fixed').AsFloat +
                                         XDataWebDataSetStartingSolution.FieldByName('Hbss_Curr_Assets').AsFloat
                                        , 4, 0);

    RFE_BilSumPas.Text  := Str_F_to_Str( XDataWebDataSetStartingSolution.FieldByName('Hbss_Curr_Equity').AsFloat +
                                         XDataWebDataSetStartingSolution.FieldByName('Hbss_Accruals').AsFloat +
                                         XDataWebDataSetStartingSolution.FieldByName('Hbss_Accounts_Payable').AsFloat
                                        , 4, 0);
  except
    wxBaseWriteLog.Write('Exception raised in TPrjFormsAusgangsLoesung.CalculateBilanzSummePG3', slError);
    result := false;
  end;
end;

function TPrjFormsAusgangsLoesung.Done: Boolean;
begin
  Result := true;
  try
    if DataChanged then
    begin
      wxBaseWriteLog.Write('TPrjFormsAusgangsLoesung.Done -> Transmitting data',slDebug);
      WaitMessage.Show;

      XDataWebDataSetStartingSolution.Cancel;
      XDataWebDataSetStartingSolution.Close;
      XDataWebDataSetStartingSolution.Connection  := PrjFormsMain.XDataWebConnectionMain;

      XDataWebDataSetStartingSolution.QueryString := '$filter=(HBSS_SIMULATION_ID eq ' + DataAccess.AktuelleSimulation.toString  + ')';
      await(XDataWebDataSetStartingSolution.Load);

      WaitMessage.Hide;
      wxBaseWriteLog.Write('TPrjFormsAusgangsLoesung.Done -> Transmitting data finished',slDebug);
    end;
  except
    wxBaseWriteLog.Write('Exception raised in TPrjFormsAusgangsLoesung.Done', slError);
    Result := false;
  end;
end;

function TPrjFormsAusgangsLoesung.DrawGridPG1InvestGueter: Boolean;
var LCol     : Integer;
var LRow     : integer;
var LSumme   : double;
begin
  try
    strGridInvestGueter.RowCount   := XDataWebDataSetStartingInvestment.RecordCount + 2;
    strGridInvestGueter.Cells[0,0] := 'Name';
    strGridInvestGueter.Cells[1,0] := 'Beschaffungsperiode (Per.)';
    strGridInvestGueter.Cells[2,0] := 'Beschaffungswert (TEUR)';
    strGridInvestGueter.Cells[3,0] := 'Restlaufzeit (Per.)';
    strGridInvestGueter.Cells[4,0] := 'Restbuchwert (TEUR)';
    strGridInvestGueter.Cells[5,0] := 'Sonstige fixe Kosten (TEUR)';
    strGridInvestGueter.Cells[6,0] := 'Kapazität (Einh.)';
    while not XDataWebDataSetStartingInvestment.Eof do
    begin
      LRow                               := XDataWebDataSetStartingInvestment.FieldByName('Hbsi_Institute_Id').AsInteger;
      strGridInvestGueter.Cells[0, LRow] := XDataWebDataSetStartingInvestment.FieldByName('Hbsi_Institute_Name').AsString;
      strGridInvestGueter.Cells[1, LRow] := Str_F_to_Str(XDataWebDataSetStartingInvestment.FieldByName('Hbsi_Procurement_Period').AsFloat, 4, 0);
      strGridInvestGueter.Cells[2, LRow] := Str_F_to_Str(XDataWebDataSetStartingInvestment.FieldByName('Hbsi_Procurement_Value').AsFloat, 6, 0);
      strGridInvestGueter.Cells[3, LRow] := Str_F_to_Str(XDataWebDataSetStartingInvestment.FieldByName('Hbsi_Remaining_Time').AsFloat, 4, 0);
      strGridInvestGueter.Cells[4, LRow] := Str_F_to_Str(XDataWebDataSetStartingInvestment.FieldByName('Hbsi_Amortized_Cost').AsFloat, 6, 0);
      strGridInvestGueter.Cells[5, LRow] := Str_F_to_Str(XDataWebDataSetStartingInvestment.FieldByName('Hbsi_Misc_Fixed_Costs').AsFloat, 6, 0);
      strGridInvestGueter.Cells[6, LRow] := Str_F_to_Str(XDataWebDataSetStartingInvestment.FieldByName('Hbsi_Capacity').AsFloat, 6, 0);
      XDataWebDataSetStartingInvestment.Next;
    end;
    strGridInvestGueter.Cells[0, strGridInvestGueter.RowCount - 1] := 'Summe';
    strGridInvestGueter.CellElements[0, strGridInvestGueter.RowCount - 1].style.SetProperty('text-align','left');
    strGridInvestGueter.CellElements[0, 0].style.SetProperty('text-align','left');

    for LCol := 1 to (strGridInvestGueter.ColCount - 1) do
    begin
      LSumme := 0;
      for LRow := 1 to (strGridInvestGueter.RowCount - 2) do
      begin
        LSumme := LSumme + StrToFloatDef(strGridInvestGueter.Cells[LCol,LRow],0);
        strGridInvestGueter.CellElements[0, LRow].style.SetProperty('text-align','left');
      end;
      strGridInvestGueter.Cells[LCol,strGridInvestGueter.RowCount - 1] := FormatFloat('0',LSumme);
      strGridInvestGueter.CellElements[LCol, strGridInvestGueter.RowCount - 1].style.setProperty('background-color', ColorToGridPropertyHex(clLime));
    end;
  except
    wxBaseWriteLog.Write('Exception raised in TPrjFormsAusgangsLoesung.DrawGridPG1InvestGueter',slDebug);
    Result := false;
  end;
end;

function TPrjFormsAusgangsLoesung.SaveGridPG1InvestGueter: Boolean;
var LRow           : integer;
var LSearchOptions : TLocateOptions;
begin
  try
    LRow            := 1;
    LSearchOptions  := [];
    for LRow := 1 to strGridInvestGueter.RowCount - 2 do
    begin
      if XDataWebDataSetStartingInvestment.Locate('Hbsi_Institute_Name', strGridInvestGueter.Cells[0, LRow], LSearchOptions ) then
      begin
        if not (XDataWebDataSetStartingInvestment.State in [dsEdit]) then
          XDataWebDataSetStartingInvestment.Edit;
        if XDataWebDataSetStartingInvestment.State in [dsEdit] then
        begin
          XDataWebDataSetStartingInvestment.FieldByName('Hbsi_Procurement_Period').AsFloat  := StrToFloat(strGridInvestGueter.Cells[1, LRow]);
          XDataWebDataSetStartingInvestment.FieldByName('Hbsi_Procurement_Value').AsFloat   := StrToFloat(strGridInvestGueter.Cells[2, LRow]);
          XDataWebDataSetStartingInvestment.FieldByName('Hbsi_Remaining_Time').AsFloat      := StrToFloat(strGridInvestGueter.Cells[3, LRow]);
          XDataWebDataSetStartingInvestment.FieldByName('Hbsi_Amortized_Cost').AsFloat      := StrToFloat(strGridInvestGueter.Cells[4, LRow]);
          XDataWebDataSetStartingInvestment.FieldByName('Hbsi_Misc_Fixed_Costs').AsFloat    := StrToFloat(strGridInvestGueter.Cells[5, LRow]);
          XDataWebDataSetStartingInvestment.FieldByName('Hbsi_Capacity').AsFloat            := StrToFloat(strGridInvestGueter.Cells[6, LRow]);
          XDataWebDataSetStartingInvestment.Post;
        end else
        begin
          wxBaseWriteLog.Write('XDataWebDataSetStartingInvestment.State not in state [dsEdit]',slDebug);
        end;
      end;
    end;
    XDataWebDataSetStartingInvestment.ApplyUpdates;
    DataChanged := False;
    ToggleGUI;

  except
    wxBaseWriteLog.Write('Exception raised in TPrjFormsAusgangsLoesung.SaveGridPG1InvestGueter',slError);
    Result := false;
  end;
end;

function TPrjFormsAusgangsLoesung.Init: Boolean;
begin
  try
    WaitMessage.Show;
    Result          := true;
    DataChanged     := False;
    btnSave.Enabled := DataChanged;

    spedPeriode.Value       := DataModule.HBMDefaultData.AktuellePeriode;
    spedAbteilung.MinValue  := 1;
    spedAbteilung.MaxValue  := 3;
    spedAbteilung.Value     := 1;
    spedKrankenhaus.Value   := DataModule.HBMDefaultData.AktuellesUnternehmen;

    XDataWebDataSetStartingSolution.Cancel;
    XDataWebDataSetStartingSolution.Close;
    XDataWebDataSetStartingSolution.Connection  := PrjFormsMain.XDataWebConnectionMain;
    XDataWebDataSetStartingSolution.QueryString := '$filter=(HBSS_SIMULATION_ID eq ' + DataAccess.AktuelleSimulation.toString  + ')';
    await(XDataWebDataSetStartingSolution.Load);

    XDataWebDataSetStartingInvestment.Cancel;
    XDataWebDataSetStartingInvestment.Close;
    XDataWebDataSetStartingInvestment.Connection  := PrjFormsMain.XDataWebConnectionMain;
    XDataWebDataSetStartingInvestment.QueryString := '$filter=(Hbsi_Simulation_Id eq ' + DataAccess.AktuelleSimulation.toString  + ')';
    await(XDataWebDataSetStartingInvestment.Load);

    XDataWebDataSetStartingDefaults.Cancel;
    XDataWebDataSetStartingDefaults.Close;
    XDataWebDataSetStartingDefaults.Connection  := PrjFormsMain.XDataWebConnectionMain;
    XDataWebDataSetStartingDefaults.QueryString := '$filter=(HBDF_SIMULATION_ID eq ' + DataAccess.AktuelleSimulation.toString  + ')';

    await(XDataWebDataSetStartingDefaults.Load);

    lblAbteilung1.Caption := Abteilungen.FindAssignment(1).FContent;
    lblAbteilung2.Caption := Abteilungen.FindAssignment(2).FContent;
    lblAbteilung3.Caption := Abteilungen.FindAssignment(3).FContent;

    lblArztAbteilung1.Caption := Abteilungen.FindAssignment(1).FContent;
    lblArztAbteilung2.Caption := Abteilungen.FindAssignment(2).FContent;
    lblArztAbteilung3.Caption := Abteilungen.FindAssignment(3).FContent;


    PageControl.ActivePageIndex := 0;

    WaitMessage.Hide;
  except
    wxBaseWriteLog.Write('Exception in Method TPrjFormsAusgangsLoesung.Init',slDebug);
    result := false;
  end;
end;

procedure TPrjFormsAusgangsLoesung.RFE_AnlageVerExit(Sender: TObject);
begin
  CalculateBilanzSummePG3;
end;

function TPrjFormsAusgangsLoesung.SaveData: Boolean;
begin
  Result      := true;
  try
    if DataChanged then
    begin
      await(SaveGridPG1InvestGueter);
      await(Self.CalculateBilanzSummePG3);

      XDataWebDataSetStartingSolution.Post;
      XDataWebDataSetStartingSolution.ApplyUpdates;
      XDataWebDataSetStartingSolution.Edit;

      XDataWebDataSetStartingDefaults.Post;
      XDataWebDataSetStartingDefaults.ApplyUpdates;
      XDataWebDataSetStartingDefaults.Edit;

      DataChanged := false;
      ToggleGUI;
    end;


//    SetAPg2BilAkt(BAMedTech,GetMedAnl());
//
//    SetAPg1Zimmer(1, StatTypD (1), StrToInt(LF1_WahlLeistung1Abt1.Text));
//    SetAPg1Zimmer(1, StatTypD (2), StrToInt(LF1_WahlLeistung2Abt1.Text));
//    SetAPg1Zimmer(1, StatTypD (3), StrToInt(LF1_WahlLeistung3Abt1.Text));
//
//    SetAPg1Zimmer(2, StatTypD (1), StrToInt(LF1_WahlLeistung1Abt2.Text));
//    SetAPg1Zimmer(2, StatTypD (2), StrToInt(LF1_WahlLeistung2Abt2.Text));
//    SetAPg1Zimmer(2, StatTypD (3), StrToInt(LF1_WahlLeistung3Abt2.Text));
//
//    SetAPg1Zimmer(3, StatTypD (1), StrToInt(LF1_WahlLeistung1Abt3.Text));
//    SetAPg1Zimmer(3, StatTypD (2), StrToInt(LF1_WahlLeistung2Abt3.Text));
//    SetAPg1Zimmer(3, StatTypD (3), StrToInt(LF1_WahlLeistung3Abt3.Text));
//
//    SetAPg1PersA(1, DienstATyp(0), StrToInt(LF1_ArztAbt1.Text));
//    SetAPg1PersA(1, DienstATyp(1), StrToInt(LF1_PflegeAbt1.Text));
//
//    SetAPg1PersA(2, DienstATyp(0), StrToInt(LF1_ArztAbt2.Text));
//    SetAPg1PersA(2, DienstATyp(1), StrToInt(LF1_PflegeAbt2.Text));
//
//    SetAPg1PersA(3, DienstATyp(0), StrToInt(LF1_ArztAbt3.Text));
//    SetAPg1PersA(3, DienstATyp(1), StrToInt(LF1_PflegeAbt3.Text));
//
//    SetAPg1PersI(1,StrToInt(LF1_Inst1Pers.Text));
//    SetAPg1PersI(2,StrToInt(LF1_Inst2Pers.Text));
//    SetAPg1PersI(3,StrToInt(LF1_Inst3Pers.Text));
//    SetAPg1PersI(4,StrToInt(LF1_Inst4Pers.Text));
//    SetAPg1PersI(5,StrToInt(LF1_Inst5Pers.Text));
//    SetAPg1PersI(6,StrToInt(LF1_Inst6Pers.Text));
//    SetAPg1StartInd(StrToInt(LF1_StartInd.Text));
//
//    SetAPg2BilAkt(BAAnlVerm,StrToFloat(RFE_AnlageVer.Text));
//    SetAPg2BilAkt(BAGebaudX,StrToFloat(RFE_Imobilien.Text));
//    SetAPg2BilAkt(BAMedTech,StrToFloat(RFE_MedtechAnl.Text));
//    SetAPg2BilAkt(BAEinrich,StrToFloat(RFE_Einrichtng.Text));
//    SetAPg2BilAkt(BAUmlVerm,StrToFloat(RFE_UmlaufVer.Text));
//    SetAPg2BilAkt(BAMediBed,StrToFloat(RFE_MedBedarf.Text));
//    SetAPg2BilAkt(BALebensm,StrToFloat(RFE_Lebensmtl.Text));
//    SetAPg2BilAkt(BAFordLuL,StrToFloat(RFE_ForderLuL.Text));
//    SetAPg2BilAkt(BAFordKHG,StrToFloat(RFE_ForderKHG.Text));
//    SetAPg2BilAkt(BAKassenB,StrToFloat(RFE_KassenBes.Text));
//    SetAPg2BilAkt(BABilSumm,StrToFloat(RFE_BilSumAkt.Text));
//
//    SetAPg2BilPas(BPEigKapi,StrToFloat(RFE_EigenKap.Text));
//    SetAPg2BilPas(BPGezKapi,StrToFloat(RFE_GezeichKap.Text));
//    SetAPg2BilPas(BPKapRckl,StrToFloat(RFE_KapRueck.Text));
//    SetAPg2BilPas(BPGewRckl,StrToFloat(RFE_GewRueck.Text));
//    SetAPg2BilPas(BPGewVort,StrToFloat(RFE_GewinnVort.Text));
//    SetAPg2BilPas(BPRuckstl,StrToFloat(RFE_Rueckstell.Text));
//    SetAPg2BilPas(BPPensRck,StrToFloat(RFE_PensRuckst.Text));
//    SetAPg2BilPas(BPVerbndl,StrToFloat(RFE_Verbindli.Text));
//    SetAPg2BilPas(BPUeberzK,StrToFloat(RFE_UeberzKrd.Text));
//    SetAPg2BilPas(BPKurzfrK,StrToFloat(RFE_KurzfrKrd.Text));
//    SetAPg2BilPas(BPLangfrK,StrToFloat(RFE_LangfrKrd.Text));
//    SetAPg2BilPas(BPVerbKHG,StrToFloat(RFE_VerbndlKHG.Text));
//    SetAPg2BilPas(BPBilSumm,StrToFloat(RFE_BilSumPas.Text));
  except
    result := false;
    wxBaseWriteLog.Write('Exception raised in TPrjFormsAusgangsLoesung.SaveData while saving data',slDebug);
  end;
  DataChanged := Result;
end;

procedure TPrjFormsAusgangsLoesung.SetMenuEnable(value: boolean);
begin
//
end;

procedure TPrjFormsAusgangsLoesung.StartingInvestmentWebDataSourceDataChange(Sender: TObject; Field: TField);
begin
  DataChanged     := true;
  ToggleGUI;
end;

procedure TPrjFormsAusgangsLoesung.StartingSolutionDataSourceDataChange(Sender: TObject; Field: TField);
begin
  DataChanged     := true;
  ToggleGUI;
end;

procedure TPrjFormsAusgangsLoesung.strGridInvestGueterCanEditCell(Sender: TObject; ACol, ARow: Integer; var CanEdit: Boolean);
begin
  CanEdit := (ARow >= 1) and (ARow < strGridInvestGueter.RowCount - 1);
end;

procedure TPrjFormsAusgangsLoesung.strGridInvestGueterSetEditText(Sender: TObject; ACol, ARow: LongInt; const Value: string);
begin
  DataChanged := true;
  ToggleGUI;
end;

procedure TPrjFormsAusgangsLoesung.XDataWebDataSetStartingInvestmentAfterOpen(DataSet: TDataSet);
begin
  if not XDataWebDataSetStartingInvestment.IsEmpty then
  begin
    XDataWebDataSetStartingInvestment.Edit;
    Self.DrawGridPG1InvestGueter;
    DataChanged := false;
    ToggleGUI;
  end else
  begin
    wxBaseWriteLog.Write('no records found for Table [' + XDataWebDataSetStartingInvestment.EntitySetName + ']', slDebug);
  end;
end;

procedure TPrjFormsAusgangsLoesung.XDataWebDataSetStartingSolutionAfterOpen(DataSet: TDataSet);
begin
  if not XDataWebDataSetStartingSolution.IsEmpty then
  begin
    XDataWebDataSetStartingSolution.Edit;
    Self.CalculateBilanzSummePG3;
    DataChanged := false;
    ToggleGUI;
  end else
  begin
    wxBaseWriteLog.Write('no records found for Table [' + XDataWebDataSetStartingSolution.EntitySetName + ']', slDebug);
  end;
end;

function TPrjFormsAusgangsLoesung.ToggleGUI: boolean;
begin
  Result := true;
  try
    btnSave.Enabled := DataChanged;
  except
    Result := false;
    wxBaseWriteLog.Write('Exception raised in TPrjFormsAusgangsLoesung.SetUpPage3 while setting up data',slDebug);
  end;

end;

procedure TPrjFormsAusgangsLoesung.XDataWebDataSetStartingDefaultsAfterOpen(DataSet: TDataSet);
begin
  if not XDataWebDataSetStartingDefaults.IsEmpty then
  begin
    XDataWebDataSetStartingDefaults.Edit;
    DataChanged := false;
    ToggleGUI;
  end else
  begin
    wxBaseWriteLog.Write('no records found for Table [' + XDataWebDataSetStartingDefaults.EntitySetName + ']', slDebug);
  end;
end;

procedure TPrjFormsAusgangsLoesung.LoadDFMValues;
begin
  inherited LoadDFMValues;

  PageControl := TPageControl.Create('ausgangsLoesungPageControl');
  pgPageInvestition := TTabSheet.Create('pgPageInvestition');
  pnInvestitionsgueter := TPanel.Create('pnInvestitionsgueter');
  strGridInvestGueter := TStringGrid.Create(Self);
  pgPageAusstattung := TTabSheet.Create('pgPageAusstattung');
  pnAusstattung := TPanel.Create('pnAusstattung');
  La1_Stat1 := TLabel.Create('wahlleistungEinsLabel');
  La1_Stat2 := TLabel.Create('wahlleistungZweiLabel');
  La1_Stat3 := TLabel.Create('normalLabel');
  WebLabel18 := TLabel.Create('aerzteLabel');
  WebLabel19 := TLabel.Create('pflegeLabel');
  La1_Inst1 := TLabel.Create('intensivLabel');
  lblAbteilung1 := TLabel.Create('einsHeadline');
  lblAbteilung2 := TLabel.Create('zweiHeadline');
  lblAbteilung3 := TLabel.Create('dreiHeadline');
  La1_Inst2 := TLabel.Create('zentralLabel');
  La1_Inst3 := TLabel.Create('anaesthesieLabel');
  La1_Inst4 := TLabel.Create('radiologieLabel');
  La1_Inst5 := TLabel.Create('laborLabel');
  La1_Inst6 := TLabel.Create('waeschereiLabel');
  WebLabel29 := TLabel.Create('diverseStartLabel');
  WebLabel1 := TLabel.Create('zimmerDerAbteilungLabel');
  WebLabel2 := TLabel.Create('personalDerAbteilungLabel');
  WebLabel3 := TLabel.Create('personalDerInstituteLabel');
  WebLabel5 := TLabel.Create('diverseStartInputLabel');
  lblArztAbteilung1 := TLabel.Create('einsPersonalHeadline');
  lblArztAbteilung2 := TLabel.Create('zweiPersonalHeadline');
  lblArztAbteilung3 := TLabel.Create('dreiPersonalHeadline');
  LF1_WahlLeistung1Abt1 := TDBEdit.Create('wahlleistungEinsEinsInput');
  LF1_WahlLeistung2Abt1 := TDBEdit.Create('wahlleistungZweiEinsInput');
  LF1_WahlLeistung3Abt1 := TDBEdit.Create('normalEinsInput');
  LF1_ArztAbt1 := TDBEdit.Create('aerzteEinsInput');
  LF1_PflegeAbt1 := TDBEdit.Create('pflegeEinsInput');
  LF1_Inst1Pers := TDBEdit.Create('intensivInput');
  LF1_WahlLeistung1Abt2 := TDBEdit.Create('wahlleistungEinsZweiInput');
  LF1_WahlLeistung2Abt2 := TDBEdit.Create('wahlleistungZweiZweiInput');
  LF1_WahlLeistung3Abt2 := TDBEdit.Create('normalZweiInput');
  LF1_ArztAbt2 := TDBEdit.Create('aerzteZweiInput');
  LF1_PflegeAbt2 := TDBEdit.Create('pflegeZweiInput');
  LF1_WahlLeistung1Abt3 := TDBEdit.Create('wahlleistungEinsDreiInput');
  LF1_WahlLeistung2Abt3 := TDBEdit.Create('wahlleistungZweiDreiInput');
  LF1_WahlLeistung3Abt3 := TDBEdit.Create('normalDreiInput');
  LF1_ArztAbt3 := TDBEdit.Create('aerzteDreiInput');
  LF1_PflegeAbt3 := TDBEdit.Create('pflegeDreiInput');
  LF1_Inst2Pers := TDBEdit.Create('zentralInput');
  LF1_Inst3Pers := TDBEdit.Create('anaesthesieInput');
  LF1_Inst4Pers := TDBEdit.Create('radiologieInput');
  LF1_Inst5Pers := TDBEdit.Create('laborInput');
  LF1_Inst6Pers := TDBEdit.Create('waeschereiInput');
  LF1_StartInd := TDBEdit.Create('diverseStartInput');
  pgPageBilanz := TTabSheet.Create('pgPageBilanz');
  pnBilanz := TPanel.Create('pnBilanz');
  pnAktiva := TPanel.Create('pnAktiva');
  WebLabel6 := TLabel.Create('bilanzsummeAktivaLabel');
  WebLabel12 := TLabel.Create('umlaufvermoegenLabel');
  WebLabel31 := TLabel.Create('kassenbestandLabel');
  WebLabel32 := TLabel.Create('fordNachKHGLabel');
  WebLabel33 := TLabel.Create('forderungenAusLiefLabel');
  WebLabel34 := TLabel.Create('forderungenLabel');
  WebLabel38 := TLabel.Create('lebensmittelLabel');
  WebLabel39 := TLabel.Create('medBedarfLabel');
  WebLabel40 := TLabel.Create('vorraeteLabel');
  WebLabel9 := TLabel.Create('medTechAnlagenLabel');
  WebLabel10 := TLabel.Create('grundstueckeLabel');
  WebLabel11 := TLabel.Create('sachanlagenLabel');
  WebLabel41 := TLabel.Create('einrichtungenLabel');
  WebLabel42 := TLabel.Create('anlagevermoegenLabel');
  RFE_UmlaufVer := TDBEdit.Create('umlaufvermoegenInput');
  RFE_ForderLuL := TDBEdit.Create('forderungenAusLiefInput');
  RFE_ForderKHG := TDBEdit.Create('fordNachKHGInput');
  RFE_KassenBes := TDBEdit.Create('kassenbestandInput');
  RFE_MedBedarf := TDBEdit.Create('medBedarfInput');
  RFE_Lebensmtl := TDBEdit.Create('lebensmittelInput');
  RFE_Imobilien := TDBEdit.Create('grundstueckeInput');
  RFE_MedtechAnl := TDBEdit.Create('medTechAnlagenInput');
  RFE_Einrichtng := TDBEdit.Create('einrichtungenInput');
  RFE_AnlageVer := TDBEdit.Create('anlagevermoegenInput');
  RFE_BilSumAkt := TEdit.Create('bilanzsummeAktivaInput');
  pnPassiva := TPanel.Create('pnPassiva');
  WebLabel43 := TLabel.Create('bilanzsummePassivaLabel');
  WebLabel44 := TLabel.Create('rueckstellungLabel');
  WebLabel48 := TLabel.Create('mittelfristigLabel');
  WebLabel49 := TLabel.Create('kurzfristigLabel');
  WebLabel50 := TLabel.Create('ueberziehungskreditLabel');
  WebLabel51 := TLabel.Create('verbindlichkeitenKreditinstLabel');
  WebLabel55 := TLabel.Create('verbindlichkeitenLabel');
  WebLabel56 := TLabel.Create('rueckstellungenPensionenLabel');
  WebLabel61 := TLabel.Create('gewinnRuecklagenLabel');
  WebLabel62 := TLabel.Create('kapitalRuecklagenLabel');
  WebLabel63 := TLabel.Create('gezeichnetesKapitalLabel');
  WebLabel64 := TLabel.Create('bilanzgewinnVerlustLabel');
  WebLabel65 := TLabel.Create('eigenkapitalLabel');
  WebLabel57 := TLabel.Create('verbindlichkeitenKHGLabel');
  RFE_Rueckstell := TDBEdit.Create('rueckstellungInput');
  RFE_UeberzKrd := TDBEdit.Create('ueberziehungskreditInput');
  RFE_KurzfrKrd := TDBEdit.Create('kurzfristigInput');
  RFE_LangfrKrd := TDBEdit.Create('mittelfristigInput');
  RFE_PensRuckst := TDBEdit.Create('rueckstellungenPensionenInput');
  RFE_Verbindli := TDBEdit.Create('verbindlichkeitenInput');
  RFE_KapRueck := TDBEdit.Create('kapitalRuecklagenInput');
  RFE_GewRueck := TDBEdit.Create('gewinnRuecklagenInput');
  RFE_GewinnVort := TDBEdit.Create('bilanzgewinnVerlustInput');
  RFE_EigenKap := TDBEdit.Create('eigenkapitalInput');
  RFE_GezeichKap := TDBEdit.Create('gezeichnetesKapitalInput');
  RFE_VerbndlKHG := TDBEdit.Create('verbindlichkeitenKHGInput');
  RFE_BilSumPas := TEdit.Create('bilanzsummePassivaInput');
  pgDefaultData := TTabSheet.Create('pgDefaultData');
  pnStartingDefaults := TPanel.Create('pnStartingDefaults');
  WebLabel4 := TLabel.Create('verwaltungAbteilungLabel');
  WebLabel7 := TLabel.Create('verwaltungInstituteLabel');
  WebLabel8 := TLabel.Create('patientenManagementAbteilungenLabel');
  WebLabel13 := TLabel.Create('rationalisierungAbteilungenLabel');
  WebLabel14 := TLabel.Create('patientenManagementInstituteLabel');
  WebLabel15 := TLabel.Create('rationalisierungInstituteLabel');
  WebLabel16 := TLabel.Create('defaultDataHeadline');
  WebDBEdit1 := TDBEdit.Create('verwaltungAbteilungInput');
  WebDBEdit2 := TDBEdit.Create('verwaltungInstituteInput');
  WebDBEdit3 := TDBEdit.Create('patientenManagementAbteilungenInput');
  WebDBEdit4 := TDBEdit.Create('rationalisierungAbteilungenInput');
  WebDBEdit5 := TDBEdit.Create('patientenManagementInstituteInput');
  WebDBEdit6 := TDBEdit.Create('rationalisierungInstituteInput');
  pnLeftNavigation := TPanel.Create('PanelNAVDefault');
  lblPeriode := TLabel.Create('LabelNAVPeriode');
  lblAbteilung := TLabel.Create('LabelNAVAbteilung');
  lblKrankenhaus := TLabel.Create('LabelNAVKrankenhaus');
  btnClose := TButton.Create('btnNAVBack');
  btnSave := TButton.Create('btnNAVSave');
  spedPeriode := TSpinEdit.Create('SpinEdNAVPeriode');
  btnPrint := TButton.Create('btnNAVPrint');
  btnCancel := TButton.Create('btnNAVCancel');
  brnHelp := TButton.Create('btnNAVHelp');
  spedAbteilung := TSpinEdit.Create('SpinEdNAVAbteilung');
  spedKrankenhaus := TSpinEdit.Create('SpinEdNAVKrankenhaus');
  XDataWebConnection1 := TXDataWebConnection.Create(Self);
  XDataWebDataSetStartingSolution := TXDataWebDataSet.Create(Self);
  StartingSolutionDataSource := TDataSource.Create(Self);
  StartingInvestmentWebDataSource := TDataSource.Create(Self);
  XDataWebDataSetStartingInvestment := TXDataWebDataSet.Create(Self);
  StartingDefaultsDataSource := TDataSource.Create(Self);
  XDataWebDataSetStartingDefaults := TXDataWebDataSet.Create(Self);

  WaitMessage.BeforeLoadDFMValues;
  PageControl.BeforeLoadDFMValues;
  pgPageInvestition.BeforeLoadDFMValues;
  pnInvestitionsgueter.BeforeLoadDFMValues;
  strGridInvestGueter.BeforeLoadDFMValues;
  pgPageAusstattung.BeforeLoadDFMValues;
  pnAusstattung.BeforeLoadDFMValues;
  La1_Stat1.BeforeLoadDFMValues;
  La1_Stat2.BeforeLoadDFMValues;
  La1_Stat3.BeforeLoadDFMValues;
  WebLabel18.BeforeLoadDFMValues;
  WebLabel19.BeforeLoadDFMValues;
  La1_Inst1.BeforeLoadDFMValues;
  lblAbteilung1.BeforeLoadDFMValues;
  lblAbteilung2.BeforeLoadDFMValues;
  lblAbteilung3.BeforeLoadDFMValues;
  La1_Inst2.BeforeLoadDFMValues;
  La1_Inst3.BeforeLoadDFMValues;
  La1_Inst4.BeforeLoadDFMValues;
  La1_Inst5.BeforeLoadDFMValues;
  La1_Inst6.BeforeLoadDFMValues;
  WebLabel29.BeforeLoadDFMValues;
  WebLabel1.BeforeLoadDFMValues;
  WebLabel2.BeforeLoadDFMValues;
  WebLabel3.BeforeLoadDFMValues;
  WebLabel5.BeforeLoadDFMValues;
  lblArztAbteilung1.BeforeLoadDFMValues;
  lblArztAbteilung2.BeforeLoadDFMValues;
  lblArztAbteilung3.BeforeLoadDFMValues;
  LF1_WahlLeistung1Abt1.BeforeLoadDFMValues;
  LF1_WahlLeistung2Abt1.BeforeLoadDFMValues;
  LF1_WahlLeistung3Abt1.BeforeLoadDFMValues;
  LF1_ArztAbt1.BeforeLoadDFMValues;
  LF1_PflegeAbt1.BeforeLoadDFMValues;
  LF1_Inst1Pers.BeforeLoadDFMValues;
  LF1_WahlLeistung1Abt2.BeforeLoadDFMValues;
  LF1_WahlLeistung2Abt2.BeforeLoadDFMValues;
  LF1_WahlLeistung3Abt2.BeforeLoadDFMValues;
  LF1_ArztAbt2.BeforeLoadDFMValues;
  LF1_PflegeAbt2.BeforeLoadDFMValues;
  LF1_WahlLeistung1Abt3.BeforeLoadDFMValues;
  LF1_WahlLeistung2Abt3.BeforeLoadDFMValues;
  LF1_WahlLeistung3Abt3.BeforeLoadDFMValues;
  LF1_ArztAbt3.BeforeLoadDFMValues;
  LF1_PflegeAbt3.BeforeLoadDFMValues;
  LF1_Inst2Pers.BeforeLoadDFMValues;
  LF1_Inst3Pers.BeforeLoadDFMValues;
  LF1_Inst4Pers.BeforeLoadDFMValues;
  LF1_Inst5Pers.BeforeLoadDFMValues;
  LF1_Inst6Pers.BeforeLoadDFMValues;
  LF1_StartInd.BeforeLoadDFMValues;
  pgPageBilanz.BeforeLoadDFMValues;
  pnBilanz.BeforeLoadDFMValues;
  pnAktiva.BeforeLoadDFMValues;
  WebLabel6.BeforeLoadDFMValues;
  WebLabel12.BeforeLoadDFMValues;
  WebLabel31.BeforeLoadDFMValues;
  WebLabel32.BeforeLoadDFMValues;
  WebLabel33.BeforeLoadDFMValues;
  WebLabel34.BeforeLoadDFMValues;
  WebLabel38.BeforeLoadDFMValues;
  WebLabel39.BeforeLoadDFMValues;
  WebLabel40.BeforeLoadDFMValues;
  WebLabel9.BeforeLoadDFMValues;
  WebLabel10.BeforeLoadDFMValues;
  WebLabel11.BeforeLoadDFMValues;
  WebLabel41.BeforeLoadDFMValues;
  WebLabel42.BeforeLoadDFMValues;
  RFE_UmlaufVer.BeforeLoadDFMValues;
  RFE_ForderLuL.BeforeLoadDFMValues;
  RFE_ForderKHG.BeforeLoadDFMValues;
  RFE_KassenBes.BeforeLoadDFMValues;
  RFE_MedBedarf.BeforeLoadDFMValues;
  RFE_Lebensmtl.BeforeLoadDFMValues;
  RFE_Imobilien.BeforeLoadDFMValues;
  RFE_MedtechAnl.BeforeLoadDFMValues;
  RFE_Einrichtng.BeforeLoadDFMValues;
  RFE_AnlageVer.BeforeLoadDFMValues;
  RFE_BilSumAkt.BeforeLoadDFMValues;
  pnPassiva.BeforeLoadDFMValues;
  WebLabel43.BeforeLoadDFMValues;
  WebLabel44.BeforeLoadDFMValues;
  WebLabel48.BeforeLoadDFMValues;
  WebLabel49.BeforeLoadDFMValues;
  WebLabel50.BeforeLoadDFMValues;
  WebLabel51.BeforeLoadDFMValues;
  WebLabel55.BeforeLoadDFMValues;
  WebLabel56.BeforeLoadDFMValues;
  WebLabel61.BeforeLoadDFMValues;
  WebLabel62.BeforeLoadDFMValues;
  WebLabel63.BeforeLoadDFMValues;
  WebLabel64.BeforeLoadDFMValues;
  WebLabel65.BeforeLoadDFMValues;
  WebLabel57.BeforeLoadDFMValues;
  RFE_Rueckstell.BeforeLoadDFMValues;
  RFE_UeberzKrd.BeforeLoadDFMValues;
  RFE_KurzfrKrd.BeforeLoadDFMValues;
  RFE_LangfrKrd.BeforeLoadDFMValues;
  RFE_PensRuckst.BeforeLoadDFMValues;
  RFE_Verbindli.BeforeLoadDFMValues;
  RFE_KapRueck.BeforeLoadDFMValues;
  RFE_GewRueck.BeforeLoadDFMValues;
  RFE_GewinnVort.BeforeLoadDFMValues;
  RFE_EigenKap.BeforeLoadDFMValues;
  RFE_GezeichKap.BeforeLoadDFMValues;
  RFE_VerbndlKHG.BeforeLoadDFMValues;
  RFE_BilSumPas.BeforeLoadDFMValues;
  pgDefaultData.BeforeLoadDFMValues;
  pnStartingDefaults.BeforeLoadDFMValues;
  WebLabel4.BeforeLoadDFMValues;
  WebLabel7.BeforeLoadDFMValues;
  WebLabel8.BeforeLoadDFMValues;
  WebLabel13.BeforeLoadDFMValues;
  WebLabel14.BeforeLoadDFMValues;
  WebLabel15.BeforeLoadDFMValues;
  WebLabel16.BeforeLoadDFMValues;
  WebDBEdit1.BeforeLoadDFMValues;
  WebDBEdit2.BeforeLoadDFMValues;
  WebDBEdit3.BeforeLoadDFMValues;
  WebDBEdit4.BeforeLoadDFMValues;
  WebDBEdit5.BeforeLoadDFMValues;
  WebDBEdit6.BeforeLoadDFMValues;
  pnLeftNavigation.BeforeLoadDFMValues;
  lblPeriode.BeforeLoadDFMValues;
  lblAbteilung.BeforeLoadDFMValues;
  lblKrankenhaus.BeforeLoadDFMValues;
  btnClose.BeforeLoadDFMValues;
  btnSave.BeforeLoadDFMValues;
  spedPeriode.BeforeLoadDFMValues;
  btnPrint.BeforeLoadDFMValues;
  btnCancel.BeforeLoadDFMValues;
  brnHelp.BeforeLoadDFMValues;
  spedAbteilung.BeforeLoadDFMValues;
  spedKrankenhaus.BeforeLoadDFMValues;
  XDataWebConnection1.BeforeLoadDFMValues;
  XDataWebDataSetStartingSolution.BeforeLoadDFMValues;
  StartingSolutionDataSource.BeforeLoadDFMValues;
  StartingInvestmentWebDataSource.BeforeLoadDFMValues;
  XDataWebDataSetStartingInvestment.BeforeLoadDFMValues;
  StartingDefaultsDataSource.BeforeLoadDFMValues;
  XDataWebDataSetStartingDefaults.BeforeLoadDFMValues;
  try
    Width := 1937;
    Height := 1011;
    WaitMessage.Picture.LoadFromFile('PrjFormAusgangsLoesung.WaitMessage.Picture.gif');
    PageControl.SetParentComponent(Self);
    PageControl.Name := 'PageControl';
    PageControl.Left := 0;
    PageControl.Top := 0;
    PageControl.Width := 1937;
    PageControl.Height := 1011;
    PageControl.ElementClassName := 'tabs tabs-boxed justify-start order-first rounded-none';
    PageControl.Align := alClient;
    PageControl.ChildOrder := 2;
    PageControl.ElementTabClassName := 'tabs';
    PageControl.ElementTabActiveClassName := 'tab-active tab';
    PageControl.ElementTabItemClassName := 'tab px-2';
    PageControl.ElementFont := efCSS;
    PageControl.TabIndex := 2;
    PageControl.TabOrder := 1;
    pgPageInvestition.SetParentComponent(PageControl);
    pgPageInvestition.Name := 'pgPageInvestition';
    pgPageInvestition.Left := 0;
    pgPageInvestition.Top := 20;
    pgPageInvestition.Width := 1937;
    pgPageInvestition.Height := 991;
    pgPageInvestition.ElementClassName := 'h-full w-full overflow-auto flex flex-col p-4 gap-4';
    pgPageInvestition.Caption := 'Investitionsg'#252'ter';
    pgPageInvestition.ElementFont := efCSS;
    pnInvestitionsgueter.SetParentComponent(pgPageInvestition);
    pnInvestitionsgueter.Name := 'pnInvestitionsgueter';
    pnInvestitionsgueter.Left := 0;
    pnInvestitionsgueter.Top := 0;
    pnInvestitionsgueter.Width := 1937;
    pnInvestitionsgueter.Height := 991;
    pnInvestitionsgueter.Align := alClient;
    pnInvestitionsgueter.TabOrder := 0;
    strGridInvestGueter.SetParentComponent(pnInvestitionsgueter);
    strGridInvestGueter.Name := 'strGridInvestGueter';
    strGridInvestGueter.Left := 50;
    strGridInvestGueter.Top := 98;
    strGridInvestGueter.Width := 989;
    strGridInvestGueter.Height := 403;
    strGridInvestGueter.ColCount := 7;
    strGridInvestGueter.DefaultColAlignment := taCenter;
    strGridInvestGueter.RowCount := 11;
    strGridInvestGueter.Options := [goFixedVertLine,goFixedHorzLine,goVertLine,goHorzLine,goRangeSelect,goColSizing,goEditing,goFixedRowDefAlign];
    strGridInvestGueter.TabOrder := 0;
    SetEvent(strGridInvestGueter, Self, 'OnSetEditText', 'strGridInvestGueterSetEditText');
    strGridInvestGueter.ElementFont := efCSS;
    strGridInvestGueter.ElementPosition := epRelative;
    strGridInvestGueter.FixedFont.Charset := DEFAULT_CHARSET;
    strGridInvestGueter.FixedFont.Color := clWindowText;
    strGridInvestGueter.FixedFont.Height := -18;
    strGridInvestGueter.FixedFont.Name := 'Segoe UI';
    strGridInvestGueter.FixedFont.Style := [];
    strGridInvestGueter.RangeEdit.Max := 100.00000000000000000;
    strGridInvestGueter.RangeEdit.Step := 1.00000000000000000;
    strGridInvestGueter.HeightStyle := ssAuto;
    strGridInvestGueter.HeightPercent := 100.00000000000000000;
    strGridInvestGueter.WidthStyle := ssAuto;
    strGridInvestGueter.WidthPercent := 100.00000000000000000;
    SetEvent(strGridInvestGueter, Self, 'OnCanEditCell', 'strGridInvestGueterCanEditCell');
    pgPageAusstattung.SetParentComponent(PageControl);
    pgPageAusstattung.Name := 'pgPageAusstattung';
    pgPageAusstattung.Left := 0;
    pgPageAusstattung.Top := 20;
    pgPageAusstattung.Width := 1937;
    pgPageAusstattung.Height := 991;
    pgPageAusstattung.ElementClassName := 'h-full w-full overflow-auto flex flex-col p-4 gap-4';
    pgPageAusstattung.Caption := 'Ausstattung';
    pgPageAusstattung.ChildOrder := 1;
    pgPageAusstattung.ElementFont := efCSS;
    pnAusstattung.SetParentComponent(pgPageAusstattung);
    pnAusstattung.Name := 'pnAusstattung';
    pnAusstattung.Left := 0;
    pnAusstattung.Top := 0;
    pnAusstattung.Width := 1937;
    pnAusstattung.Height := 1009;
    pnAusstattung.Align := alTop;
    pnAusstattung.TabOrder := 0;
    La1_Stat1.SetParentComponent(pnAusstattung);
    La1_Stat1.Name := 'La1_Stat1';
    La1_Stat1.Left := 600;
    La1_Stat1.Top := 126;
    La1_Stat1.Width := 178;
    La1_Stat1.Height := 29;
    La1_Stat1.Caption := 'Wahlleistung 1';
    La1_Stat1.ElementFont := efCSS;
    La1_Stat1.Font.Charset := DEFAULT_CHARSET;
    La1_Stat1.Font.Color := clWindowText;
    La1_Stat1.Font.Height := -24;
    La1_Stat1.Font.Name := 'Tahoma';
    La1_Stat1.Font.Style := [fsBold];
    La1_Stat1.HeightStyle := ssAuto;
    La1_Stat1.HeightPercent := 100.00000000000000000;
    La1_Stat1.ParentFont := False;
    La1_Stat1.WidthPercent := 100.00000000000000000;
    La1_Stat2.SetParentComponent(pnAusstattung);
    La1_Stat2.Name := 'La1_Stat2';
    La1_Stat2.Left := 600;
    La1_Stat2.Top := 172;
    La1_Stat2.Width := 178;
    La1_Stat2.Height := 29;
    La1_Stat2.Caption := 'Wahlleistung 2';
    La1_Stat2.ElementFont := efCSS;
    La1_Stat2.Font.Charset := DEFAULT_CHARSET;
    La1_Stat2.Font.Color := clWindowText;
    La1_Stat2.Font.Height := -24;
    La1_Stat2.Font.Name := 'Tahoma';
    La1_Stat2.Font.Style := [fsBold];
    La1_Stat2.HeightStyle := ssAuto;
    La1_Stat2.HeightPercent := 100.00000000000000000;
    La1_Stat2.ParentFont := False;
    La1_Stat2.WidthPercent := 100.00000000000000000;
    La1_Stat3.SetParentComponent(pnAusstattung);
    La1_Stat3.Name := 'La1_Stat3';
    La1_Stat3.Left := 600;
    La1_Stat3.Top := 217;
    La1_Stat3.Width := 88;
    La1_Stat3.Height := 29;
    La1_Stat3.Caption := 'Normal';
    La1_Stat3.ElementFont := efCSS;
    La1_Stat3.Font.Charset := DEFAULT_CHARSET;
    La1_Stat3.Font.Color := clWindowText;
    La1_Stat3.Font.Height := -24;
    La1_Stat3.Font.Name := 'Tahoma';
    La1_Stat3.Font.Style := [fsBold];
    La1_Stat3.HeightStyle := ssAuto;
    La1_Stat3.HeightPercent := 100.00000000000000000;
    La1_Stat3.ParentFont := False;
    La1_Stat3.WidthPercent := 100.00000000000000000;
    WebLabel18.SetParentComponent(pnAusstattung);
    WebLabel18.Name := 'WebLabel18';
    WebLabel18.Left := 600;
    WebLabel18.Top := 295;
    WebLabel18.Width := 282;
    WebLabel18.Height := 29;
    WebLabel18.Caption := #196'rztliches Fachpersonal';
    WebLabel18.ElementFont := efCSS;
    WebLabel18.Font.Charset := DEFAULT_CHARSET;
    WebLabel18.Font.Color := clWindowText;
    WebLabel18.Font.Height := -24;
    WebLabel18.Font.Name := 'Tahoma';
    WebLabel18.Font.Style := [fsBold];
    WebLabel18.HeightStyle := ssAuto;
    WebLabel18.HeightPercent := 100.00000000000000000;
    WebLabel18.ParentFont := False;
    WebLabel18.WidthPercent := 100.00000000000000000;
    WebLabel19.SetParentComponent(pnAusstattung);
    WebLabel19.Name := 'WebLabel19';
    WebLabel19.Left := 600;
    WebLabel19.Top := 340;
    WebLabel19.Width := 75;
    WebLabel19.Height := 29;
    WebLabel19.Caption := 'Pflege';
    WebLabel19.ElementFont := efCSS;
    WebLabel19.Font.Charset := DEFAULT_CHARSET;
    WebLabel19.Font.Color := clWindowText;
    WebLabel19.Font.Height := -24;
    WebLabel19.Font.Name := 'Tahoma';
    WebLabel19.Font.Style := [fsBold];
    WebLabel19.HeightStyle := ssAuto;
    WebLabel19.HeightPercent := 100.00000000000000000;
    WebLabel19.ParentFont := False;
    WebLabel19.WordWrap := True;
    WebLabel19.WidthPercent := 100.00000000000000000;
    La1_Inst1.SetParentComponent(pnAusstattung);
    La1_Inst1.Name := 'La1_Inst1';
    La1_Inst1.Left := 600;
    La1_Inst1.Top := 417;
    La1_Inst1.Width := 99;
    La1_Inst1.Height := 29;
    La1_Inst1.Caption := 'Intensiv';
    La1_Inst1.ElementFont := efCSS;
    La1_Inst1.Font.Charset := DEFAULT_CHARSET;
    La1_Inst1.Font.Color := clWindowText;
    La1_Inst1.Font.Height := -24;
    La1_Inst1.Font.Name := 'Tahoma';
    La1_Inst1.Font.Style := [fsBold];
    La1_Inst1.HeightStyle := ssAuto;
    La1_Inst1.HeightPercent := 100.00000000000000000;
    La1_Inst1.ParentFont := False;
    La1_Inst1.WordWrap := True;
    La1_Inst1.WidthPercent := 100.00000000000000000;
    lblAbteilung1.SetParentComponent(pnAusstattung);
    lblAbteilung1.Name := 'lblAbteilung1';
    lblAbteilung1.Left := 896;
    lblAbteilung1.Top := 86;
    lblAbteilung1.Width := 15;
    lblAbteilung1.Height := 29;
    lblAbteilung1.Caption := '1';
    lblAbteilung1.ElementFont := efCSS;
    lblAbteilung1.Font.Charset := DEFAULT_CHARSET;
    lblAbteilung1.Font.Color := clWindowText;
    lblAbteilung1.Font.Height := -24;
    lblAbteilung1.Font.Name := 'Tahoma';
    lblAbteilung1.Font.Style := [fsBold];
    lblAbteilung1.HeightStyle := ssAuto;
    lblAbteilung1.HeightPercent := 100.00000000000000000;
    lblAbteilung1.ParentFont := False;
    lblAbteilung1.WordWrap := True;
    lblAbteilung1.WidthPercent := 100.00000000000000000;
    lblAbteilung2.SetParentComponent(pnAusstattung);
    lblAbteilung2.Name := 'lblAbteilung2';
    lblAbteilung2.Left := 1101;
    lblAbteilung2.Top := 86;
    lblAbteilung2.Width := 15;
    lblAbteilung2.Height := 29;
    lblAbteilung2.Caption := '2';
    lblAbteilung2.ElementFont := efCSS;
    lblAbteilung2.Font.Charset := DEFAULT_CHARSET;
    lblAbteilung2.Font.Color := clWindowText;
    lblAbteilung2.Font.Height := -24;
    lblAbteilung2.Font.Name := 'Tahoma';
    lblAbteilung2.Font.Style := [fsBold];
    lblAbteilung2.HeightStyle := ssAuto;
    lblAbteilung2.HeightPercent := 100.00000000000000000;
    lblAbteilung2.ParentFont := False;
    lblAbteilung2.WordWrap := True;
    lblAbteilung2.WidthPercent := 100.00000000000000000;
    lblAbteilung3.SetParentComponent(pnAusstattung);
    lblAbteilung3.Name := 'lblAbteilung3';
    lblAbteilung3.Left := 1296;
    lblAbteilung3.Top := 86;
    lblAbteilung3.Width := 15;
    lblAbteilung3.Height := 29;
    lblAbteilung3.Caption := '3';
    lblAbteilung3.ElementFont := efCSS;
    lblAbteilung3.Font.Charset := DEFAULT_CHARSET;
    lblAbteilung3.Font.Color := clWindowText;
    lblAbteilung3.Font.Height := -24;
    lblAbteilung3.Font.Name := 'Tahoma';
    lblAbteilung3.Font.Style := [fsBold];
    lblAbteilung3.HeightStyle := ssAuto;
    lblAbteilung3.HeightPercent := 100.00000000000000000;
    lblAbteilung3.ParentFont := False;
    lblAbteilung3.WordWrap := True;
    lblAbteilung3.WidthPercent := 100.00000000000000000;
    La1_Inst2.SetParentComponent(pnAusstattung);
    La1_Inst2.Name := 'La1_Inst2';
    La1_Inst2.Left := 600;
    La1_Inst2.Top := 462;
    La1_Inst2.Width := 143;
    La1_Inst2.Height := 29;
    La1_Inst2.Caption := 'Zentral - OP';
    La1_Inst2.ElementFont := efCSS;
    La1_Inst2.Font.Charset := DEFAULT_CHARSET;
    La1_Inst2.Font.Color := clWindowText;
    La1_Inst2.Font.Height := -24;
    La1_Inst2.Font.Name := 'Tahoma';
    La1_Inst2.Font.Style := [fsBold];
    La1_Inst2.HeightStyle := ssAuto;
    La1_Inst2.HeightPercent := 100.00000000000000000;
    La1_Inst2.ParentFont := False;
    La1_Inst2.WidthPercent := 100.00000000000000000;
    La1_Inst3.SetParentComponent(pnAusstattung);
    La1_Inst3.Name := 'La1_Inst3';
    La1_Inst3.Left := 600;
    La1_Inst3.Top := 507;
    La1_Inst3.Width := 129;
    La1_Inst3.Height := 29;
    La1_Inst3.Caption := 'An'#228'sthesie';
    La1_Inst3.ElementFont := efCSS;
    La1_Inst3.Font.Charset := DEFAULT_CHARSET;
    La1_Inst3.Font.Color := clWindowText;
    La1_Inst3.Font.Height := -24;
    La1_Inst3.Font.Name := 'Tahoma';
    La1_Inst3.Font.Style := [fsBold];
    La1_Inst3.HeightStyle := ssAuto;
    La1_Inst3.HeightPercent := 100.00000000000000000;
    La1_Inst3.ParentFont := False;
    La1_Inst3.WidthPercent := 100.00000000000000000;
    La1_Inst4.SetParentComponent(pnAusstattung);
    La1_Inst4.Name := 'La1_Inst4';
    La1_Inst4.Left := 600;
    La1_Inst4.Top := 552;
    La1_Inst4.Width := 126;
    La1_Inst4.Height := 29;
    La1_Inst4.Caption := 'Radiologie';
    La1_Inst4.ElementFont := efCSS;
    La1_Inst4.Font.Charset := DEFAULT_CHARSET;
    La1_Inst4.Font.Color := clWindowText;
    La1_Inst4.Font.Height := -24;
    La1_Inst4.Font.Name := 'Tahoma';
    La1_Inst4.Font.Style := [fsBold];
    La1_Inst4.HeightStyle := ssAuto;
    La1_Inst4.HeightPercent := 100.00000000000000000;
    La1_Inst4.ParentFont := False;
    La1_Inst4.WidthPercent := 100.00000000000000000;
    La1_Inst5.SetParentComponent(pnAusstattung);
    La1_Inst5.Name := 'La1_Inst5';
    La1_Inst5.Left := 600;
    La1_Inst5.Top := 597;
    La1_Inst5.Width := 68;
    La1_Inst5.Height := 29;
    La1_Inst5.Caption := 'Labor';
    La1_Inst5.ElementFont := efCSS;
    La1_Inst5.Font.Charset := DEFAULT_CHARSET;
    La1_Inst5.Font.Color := clWindowText;
    La1_Inst5.Font.Height := -24;
    La1_Inst5.Font.Name := 'Tahoma';
    La1_Inst5.Font.Style := [fsBold];
    La1_Inst5.HeightStyle := ssAuto;
    La1_Inst5.HeightPercent := 100.00000000000000000;
    La1_Inst5.ParentFont := False;
    La1_Inst5.WidthPercent := 100.00000000000000000;
    La1_Inst6.SetParentComponent(pnAusstattung);
    La1_Inst6.Name := 'La1_Inst6';
    La1_Inst6.Left := 600;
    La1_Inst6.Top := 642;
    La1_Inst6.Width := 124;
    La1_Inst6.Height := 29;
    La1_Inst6.Caption := 'W'#228'scherei';
    La1_Inst6.ElementFont := efCSS;
    La1_Inst6.Font.Charset := DEFAULT_CHARSET;
    La1_Inst6.Font.Color := clWindowText;
    La1_Inst6.Font.Height := -24;
    La1_Inst6.Font.Name := 'Tahoma';
    La1_Inst6.Font.Style := [fsBold];
    La1_Inst6.HeightStyle := ssAuto;
    La1_Inst6.HeightPercent := 100.00000000000000000;
    La1_Inst6.ParentFont := False;
    La1_Inst6.WordWrap := True;
    La1_Inst6.WidthPercent := 100.00000000000000000;
    WebLabel29.SetParentComponent(pnAusstattung);
    WebLabel29.Name := 'WebLabel29';
    WebLabel29.Left := 136;
    WebLabel29.Top := 715;
    WebLabel29.Width := 250;
    WebLabel29.Height := 29;
    WebLabel29.Caption := 'Diverse Start Indizes';
    WebLabel29.ElementFont := efCSS;
    WebLabel29.Font.Charset := DEFAULT_CHARSET;
    WebLabel29.Font.Color := clWindowText;
    WebLabel29.Font.Height := -24;
    WebLabel29.Font.Name := 'Tahoma';
    WebLabel29.Font.Style := [fsBold];
    WebLabel29.HeightStyle := ssAuto;
    WebLabel29.HeightPercent := 100.00000000000000000;
    WebLabel29.ParentFont := False;
    WebLabel29.WordWrap := True;
    WebLabel29.WidthPercent := 100.00000000000000000;
    WebLabel1.SetParentComponent(pnAusstattung);
    WebLabel1.Name := 'WebLabel1';
    WebLabel1.Left := 136;
    WebLabel1.Top := 126;
    WebLabel1.Width := 259;
    WebLabel1.Height := 29;
    WebLabel1.Caption := 'Zimmer der Abteilung';
    WebLabel1.ElementFont := efCSS;
    WebLabel1.Font.Charset := DEFAULT_CHARSET;
    WebLabel1.Font.Color := clWindowText;
    WebLabel1.Font.Height := -24;
    WebLabel1.Font.Name := 'Tahoma';
    WebLabel1.Font.Style := [fsBold];
    WebLabel1.HeightStyle := ssAuto;
    WebLabel1.HeightPercent := 100.00000000000000000;
    WebLabel1.ParentFont := False;
    WebLabel1.WordWrap := True;
    WebLabel1.WidthPercent := 100.00000000000000000;
    WebLabel2.SetParentComponent(pnAusstattung);
    WebLabel2.Name := 'WebLabel2';
    WebLabel2.Left := 136;
    WebLabel2.Top := 295;
    WebLabel2.Width := 270;
    WebLabel2.Height := 29;
    WebLabel2.Caption := 'Personal der Abteilung';
    WebLabel2.ElementFont := efCSS;
    WebLabel2.Font.Charset := DEFAULT_CHARSET;
    WebLabel2.Font.Color := clWindowText;
    WebLabel2.Font.Height := -24;
    WebLabel2.Font.Name := 'Tahoma';
    WebLabel2.Font.Style := [fsBold];
    WebLabel2.HeightStyle := ssAuto;
    WebLabel2.HeightPercent := 100.00000000000000000;
    WebLabel2.ParentFont := False;
    WebLabel2.WordWrap := True;
    WebLabel2.WidthPercent := 100.00000000000000000;
    WebLabel3.SetParentComponent(pnAusstattung);
    WebLabel3.Name := 'WebLabel3';
    WebLabel3.Left := 136;
    WebLabel3.Top := 417;
    WebLabel3.Width := 261;
    WebLabel3.Height := 29;
    WebLabel3.Caption := 'Personal der Institute';
    WebLabel3.ElementFont := efCSS;
    WebLabel3.Font.Charset := DEFAULT_CHARSET;
    WebLabel3.Font.Color := clWindowText;
    WebLabel3.Font.Height := -24;
    WebLabel3.Font.Name := 'Tahoma';
    WebLabel3.Font.Style := [fsBold];
    WebLabel3.HeightStyle := ssAuto;
    WebLabel3.HeightPercent := 100.00000000000000000;
    WebLabel3.ParentFont := False;
    WebLabel3.WordWrap := True;
    WebLabel3.WidthPercent := 100.00000000000000000;
    WebLabel5.SetParentComponent(pnAusstattung);
    WebLabel5.Name := 'WebLabel5';
    WebLabel5.Left := 136;
    WebLabel5.Top := 785;
    WebLabel5.Width := 256;
    WebLabel5.Height := 29;
    WebLabel5.Caption := 'ArztD, PflegeD, Instit';
    WebLabel5.ElementFont := efCSS;
    WebLabel5.Font.Charset := DEFAULT_CHARSET;
    WebLabel5.Font.Color := clWindowText;
    WebLabel5.Font.Height := -24;
    WebLabel5.Font.Name := 'Tahoma';
    WebLabel5.Font.Style := [fsBold];
    WebLabel5.HeightStyle := ssAuto;
    WebLabel5.HeightPercent := 100.00000000000000000;
    WebLabel5.ParentFont := False;
    WebLabel5.WordWrap := True;
    WebLabel5.WidthPercent := 100.00000000000000000;
    lblArztAbteilung1.SetParentComponent(pnAusstattung);
    lblArztAbteilung1.Name := 'lblArztAbteilung1';
    lblArztAbteilung1.Left := 896;
    lblArztAbteilung1.Top := 257;
    lblArztAbteilung1.Width := 15;
    lblArztAbteilung1.Height := 29;
    lblArztAbteilung1.Caption := '1';
    lblArztAbteilung1.ElementFont := efCSS;
    lblArztAbteilung1.Font.Charset := DEFAULT_CHARSET;
    lblArztAbteilung1.Font.Color := clWindowText;
    lblArztAbteilung1.Font.Height := -24;
    lblArztAbteilung1.Font.Name := 'Tahoma';
    lblArztAbteilung1.Font.Style := [fsBold];
    lblArztAbteilung1.HeightStyle := ssAuto;
    lblArztAbteilung1.HeightPercent := 100.00000000000000000;
    lblArztAbteilung1.ParentFont := False;
    lblArztAbteilung1.WordWrap := True;
    lblArztAbteilung1.WidthPercent := 100.00000000000000000;
    lblArztAbteilung2.SetParentComponent(pnAusstattung);
    lblArztAbteilung2.Name := 'lblArztAbteilung2';
    lblArztAbteilung2.Left := 1091;
    lblArztAbteilung2.Top := 264;
    lblArztAbteilung2.Width := 15;
    lblArztAbteilung2.Height := 29;
    lblArztAbteilung2.Caption := '2';
    lblArztAbteilung2.ElementFont := efCSS;
    lblArztAbteilung2.Font.Charset := DEFAULT_CHARSET;
    lblArztAbteilung2.Font.Color := clWindowText;
    lblArztAbteilung2.Font.Height := -24;
    lblArztAbteilung2.Font.Name := 'Tahoma';
    lblArztAbteilung2.Font.Style := [fsBold];
    lblArztAbteilung2.HeightStyle := ssAuto;
    lblArztAbteilung2.HeightPercent := 100.00000000000000000;
    lblArztAbteilung2.ParentFont := False;
    lblArztAbteilung2.WordWrap := True;
    lblArztAbteilung2.WidthPercent := 100.00000000000000000;
    lblArztAbteilung3.SetParentComponent(pnAusstattung);
    lblArztAbteilung3.Name := 'lblArztAbteilung3';
    lblArztAbteilung3.Left := 1296;
    lblArztAbteilung3.Top := 255;
    lblArztAbteilung3.Width := 15;
    lblArztAbteilung3.Height := 29;
    lblArztAbteilung3.Caption := '3';
    lblArztAbteilung3.ElementFont := efCSS;
    lblArztAbteilung3.Font.Charset := DEFAULT_CHARSET;
    lblArztAbteilung3.Font.Color := clWindowText;
    lblArztAbteilung3.Font.Height := -24;
    lblArztAbteilung3.Font.Name := 'Tahoma';
    lblArztAbteilung3.Font.Style := [fsBold];
    lblArztAbteilung3.HeightStyle := ssAuto;
    lblArztAbteilung3.HeightPercent := 100.00000000000000000;
    lblArztAbteilung3.ParentFont := False;
    lblArztAbteilung3.WordWrap := True;
    lblArztAbteilung3.WidthPercent := 100.00000000000000000;
    LF1_WahlLeistung1Abt1.SetParentComponent(pnAusstattung);
    LF1_WahlLeistung1Abt1.Name := 'LF1_WahlLeistung1Abt1';
    LF1_WahlLeistung1Abt1.Left := 832;
    LF1_WahlLeistung1Abt1.Top := 121;
    LF1_WahlLeistung1Abt1.Width := 150;
    LF1_WahlLeistung1Abt1.Height := 46;
    LF1_WahlLeistung1Abt1.ChildOrder := 19;
    LF1_WahlLeistung1Abt1.EditType := weNumeric;
    LF1_WahlLeistung1Abt1.ElementFont := efCSS;
    LF1_WahlLeistung1Abt1.Font.Charset := ANSI_CHARSET;
    LF1_WahlLeistung1Abt1.Font.Color := clWindowText;
    LF1_WahlLeistung1Abt1.Font.Height := -24;
    LF1_WahlLeistung1Abt1.Font.Name := 'Segoe UI';
    LF1_WahlLeistung1Abt1.Font.Style := [fsBold];
    LF1_WahlLeistung1Abt1.HeightStyle := ssAuto;
    LF1_WahlLeistung1Abt1.HeightPercent := 100.00000000000000000;
    LF1_WahlLeistung1Abt1.ParentFont := False;
    LF1_WahlLeistung1Abt1.Text := 'TMSFNCEdit1';
    LF1_WahlLeistung1Abt1.WidthPercent := 100.00000000000000000;
    LF1_WahlLeistung1Abt1.DataField := 'Hbss_Station1_Room_Selection1';
    LF1_WahlLeistung1Abt1.DataSource := StartingSolutionDataSource;
    LF1_WahlLeistung2Abt1.SetParentComponent(pnAusstattung);
    LF1_WahlLeistung2Abt1.Name := 'LF1_WahlLeistung2Abt1';
    LF1_WahlLeistung2Abt1.Left := 832;
    LF1_WahlLeistung2Abt1.Top := 167;
    LF1_WahlLeistung2Abt1.Width := 150;
    LF1_WahlLeistung2Abt1.Height := 46;
    LF1_WahlLeistung2Abt1.ChildOrder := 20;
    LF1_WahlLeistung2Abt1.EditType := weNumeric;
    LF1_WahlLeistung2Abt1.ElementFont := efCSS;
    LF1_WahlLeistung2Abt1.Font.Charset := ANSI_CHARSET;
    LF1_WahlLeistung2Abt1.Font.Color := clWindowText;
    LF1_WahlLeistung2Abt1.Font.Height := -24;
    LF1_WahlLeistung2Abt1.Font.Name := 'Segoe UI';
    LF1_WahlLeistung2Abt1.Font.Style := [fsBold];
    LF1_WahlLeistung2Abt1.HeightStyle := ssAuto;
    LF1_WahlLeistung2Abt1.HeightPercent := 100.00000000000000000;
    LF1_WahlLeistung2Abt1.ParentFont := False;
    LF1_WahlLeistung2Abt1.TabOrder := 1;
    LF1_WahlLeistung2Abt1.Text := 'TMSFNCEdit1';
    LF1_WahlLeistung2Abt1.WidthPercent := 100.00000000000000000;
    LF1_WahlLeistung2Abt1.DataField := 'Hbss_Station1_Room_Selection2';
    LF1_WahlLeistung2Abt1.DataSource := StartingSolutionDataSource;
    LF1_WahlLeistung3Abt1.SetParentComponent(pnAusstattung);
    LF1_WahlLeistung3Abt1.Name := 'LF1_WahlLeistung3Abt1';
    LF1_WahlLeistung3Abt1.Left := 832;
    LF1_WahlLeistung3Abt1.Top := 211;
    LF1_WahlLeistung3Abt1.Width := 150;
    LF1_WahlLeistung3Abt1.Height := 46;
    LF1_WahlLeistung3Abt1.ChildOrder := 21;
    LF1_WahlLeistung3Abt1.EditType := weNumeric;
    LF1_WahlLeistung3Abt1.ElementFont := efCSS;
    LF1_WahlLeistung3Abt1.Font.Charset := ANSI_CHARSET;
    LF1_WahlLeistung3Abt1.Font.Color := clWindowText;
    LF1_WahlLeistung3Abt1.Font.Height := -24;
    LF1_WahlLeistung3Abt1.Font.Name := 'Segoe UI';
    LF1_WahlLeistung3Abt1.Font.Style := [fsBold];
    LF1_WahlLeistung3Abt1.HeightStyle := ssAuto;
    LF1_WahlLeistung3Abt1.HeightPercent := 100.00000000000000000;
    LF1_WahlLeistung3Abt1.ParentFont := False;
    LF1_WahlLeistung3Abt1.TabOrder := 2;
    LF1_WahlLeistung3Abt1.Text := 'TMSFNCEdit1';
    LF1_WahlLeistung3Abt1.WidthPercent := 100.00000000000000000;
    LF1_WahlLeistung3Abt1.DataField := 'Hbss_Station1_Room_Normal';
    LF1_WahlLeistung3Abt1.DataSource := StartingSolutionDataSource;
    LF1_ArztAbt1.SetParentComponent(pnAusstattung);
    LF1_ArztAbt1.Name := 'LF1_ArztAbt1';
    LF1_ArztAbt1.Left := 832;
    LF1_ArztAbt1.Top := 290;
    LF1_ArztAbt1.Width := 150;
    LF1_ArztAbt1.Height := 46;
    LF1_ArztAbt1.ChildOrder := 22;
    LF1_ArztAbt1.EditType := weNumeric;
    LF1_ArztAbt1.ElementFont := efCSS;
    LF1_ArztAbt1.Font.Charset := ANSI_CHARSET;
    LF1_ArztAbt1.Font.Color := clWindowText;
    LF1_ArztAbt1.Font.Height := -24;
    LF1_ArztAbt1.Font.Name := 'Segoe UI';
    LF1_ArztAbt1.Font.Style := [fsBold];
    LF1_ArztAbt1.HeightStyle := ssAuto;
    LF1_ArztAbt1.HeightPercent := 100.00000000000000000;
    LF1_ArztAbt1.ParentFont := False;
    LF1_ArztAbt1.TabOrder := 3;
    LF1_ArztAbt1.Text := 'TMSFNCEdit1';
    LF1_ArztAbt1.WidthPercent := 100.00000000000000000;
    LF1_ArztAbt1.DataField := 'Hbss_Station1_Medical';
    LF1_ArztAbt1.DataSource := StartingSolutionDataSource;
    LF1_PflegeAbt1.SetParentComponent(pnAusstattung);
    LF1_PflegeAbt1.Name := 'LF1_PflegeAbt1';
    LF1_PflegeAbt1.Left := 832;
    LF1_PflegeAbt1.Top := 335;
    LF1_PflegeAbt1.Width := 150;
    LF1_PflegeAbt1.Height := 46;
    LF1_PflegeAbt1.ChildOrder := 23;
    LF1_PflegeAbt1.EditType := weNumeric;
    LF1_PflegeAbt1.ElementFont := efCSS;
    LF1_PflegeAbt1.Font.Charset := ANSI_CHARSET;
    LF1_PflegeAbt1.Font.Color := clWindowText;
    LF1_PflegeAbt1.Font.Height := -24;
    LF1_PflegeAbt1.Font.Name := 'Segoe UI';
    LF1_PflegeAbt1.Font.Style := [fsBold];
    LF1_PflegeAbt1.HeightStyle := ssAuto;
    LF1_PflegeAbt1.HeightPercent := 100.00000000000000000;
    LF1_PflegeAbt1.ParentFont := False;
    LF1_PflegeAbt1.TabOrder := 4;
    LF1_PflegeAbt1.Text := 'TMSFNCEdit1';
    LF1_PflegeAbt1.WidthPercent := 100.00000000000000000;
    LF1_PflegeAbt1.DataField := 'Hbss_Station1_Care';
    LF1_PflegeAbt1.DataSource := StartingSolutionDataSource;
    LF1_Inst1Pers.SetParentComponent(pnAusstattung);
    LF1_Inst1Pers.Name := 'LF1_Inst1Pers';
    LF1_Inst1Pers.Left := 832;
    LF1_Inst1Pers.Top := 412;
    LF1_Inst1Pers.Width := 150;
    LF1_Inst1Pers.Height := 46;
    LF1_Inst1Pers.ChildOrder := 24;
    LF1_Inst1Pers.EditType := weNumeric;
    LF1_Inst1Pers.ElementFont := efCSS;
    LF1_Inst1Pers.Font.Charset := ANSI_CHARSET;
    LF1_Inst1Pers.Font.Color := clWindowText;
    LF1_Inst1Pers.Font.Height := -24;
    LF1_Inst1Pers.Font.Name := 'Segoe UI';
    LF1_Inst1Pers.Font.Style := [fsBold];
    LF1_Inst1Pers.HeightStyle := ssAuto;
    LF1_Inst1Pers.HeightPercent := 100.00000000000000000;
    LF1_Inst1Pers.ParentFont := False;
    LF1_Inst1Pers.TabOrder := 5;
    LF1_Inst1Pers.Text := 'TMSFNCEdit1';
    LF1_Inst1Pers.WidthPercent := 100.00000000000000000;
    LF1_Inst1Pers.DataField := 'Hbss_Institutes_Intensiv';
    LF1_Inst1Pers.DataSource := StartingSolutionDataSource;
    LF1_WahlLeistung1Abt2.SetParentComponent(pnAusstattung);
    LF1_WahlLeistung1Abt2.Name := 'LF1_WahlLeistung1Abt2';
    LF1_WahlLeistung1Abt2.Left := 1032;
    LF1_WahlLeistung1Abt2.Top := 121;
    LF1_WahlLeistung1Abt2.Width := 150;
    LF1_WahlLeistung1Abt2.Height := 46;
    LF1_WahlLeistung1Abt2.ChildOrder := 25;
    LF1_WahlLeistung1Abt2.EditType := weNumeric;
    LF1_WahlLeistung1Abt2.ElementFont := efCSS;
    LF1_WahlLeistung1Abt2.Font.Charset := ANSI_CHARSET;
    LF1_WahlLeistung1Abt2.Font.Color := clWindowText;
    LF1_WahlLeistung1Abt2.Font.Height := -24;
    LF1_WahlLeistung1Abt2.Font.Name := 'Segoe UI';
    LF1_WahlLeistung1Abt2.Font.Style := [fsBold];
    LF1_WahlLeistung1Abt2.HeightStyle := ssAuto;
    LF1_WahlLeistung1Abt2.HeightPercent := 100.00000000000000000;
    LF1_WahlLeistung1Abt2.ParentFont := False;
    LF1_WahlLeistung1Abt2.TabOrder := 6;
    LF1_WahlLeistung1Abt2.Text := 'TMSFNCEdit1';
    LF1_WahlLeistung1Abt2.WidthPercent := 100.00000000000000000;
    LF1_WahlLeistung1Abt2.DataField := 'Hbss_Station2_Room_Selection1';
    LF1_WahlLeistung1Abt2.DataSource := StartingSolutionDataSource;
    LF1_WahlLeistung2Abt2.SetParentComponent(pnAusstattung);
    LF1_WahlLeistung2Abt2.Name := 'LF1_WahlLeistung2Abt2';
    LF1_WahlLeistung2Abt2.Left := 1032;
    LF1_WahlLeistung2Abt2.Top := 167;
    LF1_WahlLeistung2Abt2.Width := 150;
    LF1_WahlLeistung2Abt2.Height := 46;
    LF1_WahlLeistung2Abt2.ChildOrder := 26;
    LF1_WahlLeistung2Abt2.EditType := weNumeric;
    LF1_WahlLeistung2Abt2.ElementFont := efCSS;
    LF1_WahlLeistung2Abt2.Font.Charset := ANSI_CHARSET;
    LF1_WahlLeistung2Abt2.Font.Color := clWindowText;
    LF1_WahlLeistung2Abt2.Font.Height := -24;
    LF1_WahlLeistung2Abt2.Font.Name := 'Segoe UI';
    LF1_WahlLeistung2Abt2.Font.Style := [fsBold];
    LF1_WahlLeistung2Abt2.HeightStyle := ssAuto;
    LF1_WahlLeistung2Abt2.HeightPercent := 100.00000000000000000;
    LF1_WahlLeistung2Abt2.ParentFont := False;
    LF1_WahlLeistung2Abt2.TabOrder := 7;
    LF1_WahlLeistung2Abt2.Text := 'TMSFNCEdit1';
    LF1_WahlLeistung2Abt2.WidthPercent := 100.00000000000000000;
    LF1_WahlLeistung2Abt2.DataField := 'Hbss_Station2_Room_Selection2';
    LF1_WahlLeistung2Abt2.DataSource := StartingSolutionDataSource;
    LF1_WahlLeistung3Abt2.SetParentComponent(pnAusstattung);
    LF1_WahlLeistung3Abt2.Name := 'LF1_WahlLeistung3Abt2';
    LF1_WahlLeistung3Abt2.Left := 1032;
    LF1_WahlLeistung3Abt2.Top := 212;
    LF1_WahlLeistung3Abt2.Width := 150;
    LF1_WahlLeistung3Abt2.Height := 46;
    LF1_WahlLeistung3Abt2.ChildOrder := 27;
    LF1_WahlLeistung3Abt2.EditType := weNumeric;
    LF1_WahlLeistung3Abt2.ElementFont := efCSS;
    LF1_WahlLeistung3Abt2.Font.Charset := ANSI_CHARSET;
    LF1_WahlLeistung3Abt2.Font.Color := clWindowText;
    LF1_WahlLeistung3Abt2.Font.Height := -24;
    LF1_WahlLeistung3Abt2.Font.Name := 'Segoe UI';
    LF1_WahlLeistung3Abt2.Font.Style := [fsBold];
    LF1_WahlLeistung3Abt2.HeightStyle := ssAuto;
    LF1_WahlLeistung3Abt2.HeightPercent := 100.00000000000000000;
    LF1_WahlLeistung3Abt2.ParentFont := False;
    LF1_WahlLeistung3Abt2.TabOrder := 8;
    LF1_WahlLeistung3Abt2.Text := 'TMSFNCEdit1';
    LF1_WahlLeistung3Abt2.WidthPercent := 100.00000000000000000;
    LF1_WahlLeistung3Abt2.DataField := 'Hbss_Station2_Room_Normal';
    LF1_WahlLeistung3Abt2.DataSource := StartingSolutionDataSource;
    LF1_ArztAbt2.SetParentComponent(pnAusstattung);
    LF1_ArztAbt2.Name := 'LF1_ArztAbt2';
    LF1_ArztAbt2.Left := 1032;
    LF1_ArztAbt2.Top := 290;
    LF1_ArztAbt2.Width := 150;
    LF1_ArztAbt2.Height := 46;
    LF1_ArztAbt2.ChildOrder := 28;
    LF1_ArztAbt2.EditType := weNumeric;
    LF1_ArztAbt2.ElementFont := efCSS;
    LF1_ArztAbt2.Font.Charset := ANSI_CHARSET;
    LF1_ArztAbt2.Font.Color := clWindowText;
    LF1_ArztAbt2.Font.Height := -24;
    LF1_ArztAbt2.Font.Name := 'Segoe UI';
    LF1_ArztAbt2.Font.Style := [fsBold];
    LF1_ArztAbt2.HeightStyle := ssAuto;
    LF1_ArztAbt2.HeightPercent := 100.00000000000000000;
    LF1_ArztAbt2.ParentFont := False;
    LF1_ArztAbt2.TabOrder := 9;
    LF1_ArztAbt2.Text := 'TMSFNCEdit1';
    LF1_ArztAbt2.WidthPercent := 100.00000000000000000;
    LF1_ArztAbt2.DataField := 'Hbss_Station2_Medical';
    LF1_ArztAbt2.DataSource := StartingSolutionDataSource;
    LF1_PflegeAbt2.SetParentComponent(pnAusstattung);
    LF1_PflegeAbt2.Name := 'LF1_PflegeAbt2';
    LF1_PflegeAbt2.Left := 1032;
    LF1_PflegeAbt2.Top := 335;
    LF1_PflegeAbt2.Width := 150;
    LF1_PflegeAbt2.Height := 46;
    LF1_PflegeAbt2.ChildOrder := 29;
    LF1_PflegeAbt2.EditType := weNumeric;
    LF1_PflegeAbt2.ElementFont := efCSS;
    LF1_PflegeAbt2.Font.Charset := ANSI_CHARSET;
    LF1_PflegeAbt2.Font.Color := clWindowText;
    LF1_PflegeAbt2.Font.Height := -24;
    LF1_PflegeAbt2.Font.Name := 'Segoe UI';
    LF1_PflegeAbt2.Font.Style := [fsBold];
    LF1_PflegeAbt2.HeightStyle := ssAuto;
    LF1_PflegeAbt2.HeightPercent := 100.00000000000000000;
    LF1_PflegeAbt2.ParentFont := False;
    LF1_PflegeAbt2.TabOrder := 10;
    LF1_PflegeAbt2.Text := 'TMSFNCEdit1';
    LF1_PflegeAbt2.WidthPercent := 100.00000000000000000;
    LF1_PflegeAbt2.DataField := 'Hbss_Station2_Care';
    LF1_PflegeAbt2.DataSource := StartingSolutionDataSource;
    LF1_WahlLeistung1Abt3.SetParentComponent(pnAusstattung);
    LF1_WahlLeistung1Abt3.Name := 'LF1_WahlLeistung1Abt3';
    LF1_WahlLeistung1Abt3.Left := 1224;
    LF1_WahlLeistung1Abt3.Top := 121;
    LF1_WahlLeistung1Abt3.Width := 150;
    LF1_WahlLeistung1Abt3.Height := 46;
    LF1_WahlLeistung1Abt3.ChildOrder := 30;
    LF1_WahlLeistung1Abt3.EditType := weNumeric;
    LF1_WahlLeistung1Abt3.ElementFont := efCSS;
    LF1_WahlLeistung1Abt3.Font.Charset := ANSI_CHARSET;
    LF1_WahlLeistung1Abt3.Font.Color := clWindowText;
    LF1_WahlLeistung1Abt3.Font.Height := -24;
    LF1_WahlLeistung1Abt3.Font.Name := 'Segoe UI';
    LF1_WahlLeistung1Abt3.Font.Style := [fsBold];
    LF1_WahlLeistung1Abt3.HeightStyle := ssAuto;
    LF1_WahlLeistung1Abt3.HeightPercent := 100.00000000000000000;
    LF1_WahlLeistung1Abt3.ParentFont := False;
    LF1_WahlLeistung1Abt3.TabOrder := 11;
    LF1_WahlLeistung1Abt3.Text := 'TMSFNCEdit1';
    LF1_WahlLeistung1Abt3.WidthPercent := 100.00000000000000000;
    LF1_WahlLeistung1Abt3.DataField := 'Hbss_Station3_Room_Selection1';
    LF1_WahlLeistung1Abt3.DataSource := StartingSolutionDataSource;
    LF1_WahlLeistung2Abt3.SetParentComponent(pnAusstattung);
    LF1_WahlLeistung2Abt3.Name := 'LF1_WahlLeistung2Abt3';
    LF1_WahlLeistung2Abt3.Left := 1224;
    LF1_WahlLeistung2Abt3.Top := 167;
    LF1_WahlLeistung2Abt3.Width := 150;
    LF1_WahlLeistung2Abt3.Height := 46;
    LF1_WahlLeistung2Abt3.ChildOrder := 31;
    LF1_WahlLeistung2Abt3.EditType := weNumeric;
    LF1_WahlLeistung2Abt3.ElementFont := efCSS;
    LF1_WahlLeistung2Abt3.Font.Charset := ANSI_CHARSET;
    LF1_WahlLeistung2Abt3.Font.Color := clWindowText;
    LF1_WahlLeistung2Abt3.Font.Height := -24;
    LF1_WahlLeistung2Abt3.Font.Name := 'Segoe UI';
    LF1_WahlLeistung2Abt3.Font.Style := [fsBold];
    LF1_WahlLeistung2Abt3.HeightStyle := ssAuto;
    LF1_WahlLeistung2Abt3.HeightPercent := 100.00000000000000000;
    LF1_WahlLeistung2Abt3.ParentFont := False;
    LF1_WahlLeistung2Abt3.TabOrder := 12;
    LF1_WahlLeistung2Abt3.Text := 'TMSFNCEdit1';
    LF1_WahlLeistung2Abt3.WidthPercent := 100.00000000000000000;
    LF1_WahlLeistung2Abt3.DataField := 'Hbss_Station3_Room_Selection2';
    LF1_WahlLeistung2Abt3.DataSource := StartingSolutionDataSource;
    LF1_WahlLeistung3Abt3.SetParentComponent(pnAusstattung);
    LF1_WahlLeistung3Abt3.Name := 'LF1_WahlLeistung3Abt3';
    LF1_WahlLeistung3Abt3.Left := 1224;
    LF1_WahlLeistung3Abt3.Top := 212;
    LF1_WahlLeistung3Abt3.Width := 150;
    LF1_WahlLeistung3Abt3.Height := 46;
    LF1_WahlLeistung3Abt3.ChildOrder := 32;
    LF1_WahlLeistung3Abt3.EditType := weNumeric;
    LF1_WahlLeistung3Abt3.ElementFont := efCSS;
    LF1_WahlLeistung3Abt3.Font.Charset := ANSI_CHARSET;
    LF1_WahlLeistung3Abt3.Font.Color := clWindowText;
    LF1_WahlLeistung3Abt3.Font.Height := -24;
    LF1_WahlLeistung3Abt3.Font.Name := 'Segoe UI';
    LF1_WahlLeistung3Abt3.Font.Style := [fsBold];
    LF1_WahlLeistung3Abt3.HeightStyle := ssAuto;
    LF1_WahlLeistung3Abt3.HeightPercent := 100.00000000000000000;
    LF1_WahlLeistung3Abt3.ParentFont := False;
    LF1_WahlLeistung3Abt3.TabOrder := 13;
    LF1_WahlLeistung3Abt3.Text := 'TMSFNCEdit1';
    LF1_WahlLeistung3Abt3.WidthPercent := 100.00000000000000000;
    LF1_WahlLeistung3Abt3.DataField := 'Hbss_Station3_Room_Normal';
    LF1_WahlLeistung3Abt3.DataSource := StartingSolutionDataSource;
    LF1_ArztAbt3.SetParentComponent(pnAusstattung);
    LF1_ArztAbt3.Name := 'LF1_ArztAbt3';
    LF1_ArztAbt3.Left := 1224;
    LF1_ArztAbt3.Top := 290;
    LF1_ArztAbt3.Width := 150;
    LF1_ArztAbt3.Height := 46;
    LF1_ArztAbt3.ChildOrder := 33;
    LF1_ArztAbt3.EditType := weNumeric;
    LF1_ArztAbt3.ElementFont := efCSS;
    LF1_ArztAbt3.Font.Charset := ANSI_CHARSET;
    LF1_ArztAbt3.Font.Color := clWindowText;
    LF1_ArztAbt3.Font.Height := -24;
    LF1_ArztAbt3.Font.Name := 'Segoe UI';
    LF1_ArztAbt3.Font.Style := [fsBold];
    LF1_ArztAbt3.HeightStyle := ssAuto;
    LF1_ArztAbt3.HeightPercent := 100.00000000000000000;
    LF1_ArztAbt3.ParentFont := False;
    LF1_ArztAbt3.TabOrder := 14;
    LF1_ArztAbt3.Text := 'TMSFNCEdit1';
    LF1_ArztAbt3.WidthPercent := 100.00000000000000000;
    LF1_ArztAbt3.DataField := 'Hbss_Station3_Medical';
    LF1_ArztAbt3.DataSource := StartingSolutionDataSource;
    LF1_PflegeAbt3.SetParentComponent(pnAusstattung);
    LF1_PflegeAbt3.Name := 'LF1_PflegeAbt3';
    LF1_PflegeAbt3.Left := 1224;
    LF1_PflegeAbt3.Top := 335;
    LF1_PflegeAbt3.Width := 150;
    LF1_PflegeAbt3.Height := 46;
    LF1_PflegeAbt3.ChildOrder := 34;
    LF1_PflegeAbt3.EditType := weNumeric;
    LF1_PflegeAbt3.ElementFont := efCSS;
    LF1_PflegeAbt3.Font.Charset := ANSI_CHARSET;
    LF1_PflegeAbt3.Font.Color := clWindowText;
    LF1_PflegeAbt3.Font.Height := -24;
    LF1_PflegeAbt3.Font.Name := 'Segoe UI';
    LF1_PflegeAbt3.Font.Style := [fsBold];
    LF1_PflegeAbt3.HeightStyle := ssAuto;
    LF1_PflegeAbt3.HeightPercent := 100.00000000000000000;
    LF1_PflegeAbt3.ParentFont := False;
    LF1_PflegeAbt3.TabOrder := 15;
    LF1_PflegeAbt3.Text := 'TMSFNCEdit1';
    LF1_PflegeAbt3.WidthPercent := 100.00000000000000000;
    LF1_PflegeAbt3.DataField := 'Hbss_Station3_Care';
    LF1_PflegeAbt3.DataSource := StartingSolutionDataSource;
    LF1_Inst2Pers.SetParentComponent(pnAusstattung);
    LF1_Inst2Pers.Name := 'LF1_Inst2Pers';
    LF1_Inst2Pers.Left := 832;
    LF1_Inst2Pers.Top := 457;
    LF1_Inst2Pers.Width := 150;
    LF1_Inst2Pers.Height := 46;
    LF1_Inst2Pers.ChildOrder := 35;
    LF1_Inst2Pers.EditType := weNumeric;
    LF1_Inst2Pers.ElementFont := efCSS;
    LF1_Inst2Pers.Font.Charset := ANSI_CHARSET;
    LF1_Inst2Pers.Font.Color := clWindowText;
    LF1_Inst2Pers.Font.Height := -24;
    LF1_Inst2Pers.Font.Name := 'Segoe UI';
    LF1_Inst2Pers.Font.Style := [fsBold];
    LF1_Inst2Pers.HeightStyle := ssAuto;
    LF1_Inst2Pers.HeightPercent := 100.00000000000000000;
    LF1_Inst2Pers.ParentFont := False;
    LF1_Inst2Pers.TabOrder := 16;
    LF1_Inst2Pers.Text := 'TMSFNCEdit1';
    LF1_Inst2Pers.WidthPercent := 100.00000000000000000;
    LF1_Inst2Pers.DataField := 'Hbss_Institutes_Central_Op';
    LF1_Inst2Pers.DataSource := StartingSolutionDataSource;
    LF1_Inst3Pers.SetParentComponent(pnAusstattung);
    LF1_Inst3Pers.Name := 'LF1_Inst3Pers';
    LF1_Inst3Pers.Left := 832;
    LF1_Inst3Pers.Top := 502;
    LF1_Inst3Pers.Width := 150;
    LF1_Inst3Pers.Height := 46;
    LF1_Inst3Pers.ChildOrder := 36;
    LF1_Inst3Pers.EditType := weNumeric;
    LF1_Inst3Pers.ElementFont := efCSS;
    LF1_Inst3Pers.Font.Charset := ANSI_CHARSET;
    LF1_Inst3Pers.Font.Color := clWindowText;
    LF1_Inst3Pers.Font.Height := -24;
    LF1_Inst3Pers.Font.Name := 'Segoe UI';
    LF1_Inst3Pers.Font.Style := [fsBold];
    LF1_Inst3Pers.HeightStyle := ssAuto;
    LF1_Inst3Pers.HeightPercent := 100.00000000000000000;
    LF1_Inst3Pers.ParentFont := False;
    LF1_Inst3Pers.TabOrder := 17;
    LF1_Inst3Pers.Text := 'TMSFNCEdit1';
    LF1_Inst3Pers.WidthPercent := 100.00000000000000000;
    LF1_Inst3Pers.DataField := 'Hbss_Institutes_Anaesthesia';
    LF1_Inst3Pers.DataSource := StartingSolutionDataSource;
    LF1_Inst4Pers.SetParentComponent(pnAusstattung);
    LF1_Inst4Pers.Name := 'LF1_Inst4Pers';
    LF1_Inst4Pers.Left := 832;
    LF1_Inst4Pers.Top := 547;
    LF1_Inst4Pers.Width := 150;
    LF1_Inst4Pers.Height := 46;
    LF1_Inst4Pers.ChildOrder := 37;
    LF1_Inst4Pers.EditType := weNumeric;
    LF1_Inst4Pers.ElementFont := efCSS;
    LF1_Inst4Pers.Font.Charset := ANSI_CHARSET;
    LF1_Inst4Pers.Font.Color := clWindowText;
    LF1_Inst4Pers.Font.Height := -24;
    LF1_Inst4Pers.Font.Name := 'Segoe UI';
    LF1_Inst4Pers.Font.Style := [fsBold];
    LF1_Inst4Pers.HeightStyle := ssAuto;
    LF1_Inst4Pers.HeightPercent := 100.00000000000000000;
    LF1_Inst4Pers.ParentFont := False;
    LF1_Inst4Pers.TabOrder := 18;
    LF1_Inst4Pers.Text := 'TMSFNCEdit1';
    LF1_Inst4Pers.WidthPercent := 100.00000000000000000;
    LF1_Inst4Pers.DataField := 'Hbss_Institutes_Radiologie';
    LF1_Inst4Pers.DataSource := StartingSolutionDataSource;
    LF1_Inst5Pers.SetParentComponent(pnAusstattung);
    LF1_Inst5Pers.Name := 'LF1_Inst5Pers';
    LF1_Inst5Pers.Left := 832;
    LF1_Inst5Pers.Top := 592;
    LF1_Inst5Pers.Width := 150;
    LF1_Inst5Pers.Height := 46;
    LF1_Inst5Pers.ChildOrder := 38;
    LF1_Inst5Pers.EditType := weNumeric;
    LF1_Inst5Pers.ElementFont := efCSS;
    LF1_Inst5Pers.Font.Charset := ANSI_CHARSET;
    LF1_Inst5Pers.Font.Color := clWindowText;
    LF1_Inst5Pers.Font.Height := -24;
    LF1_Inst5Pers.Font.Name := 'Segoe UI';
    LF1_Inst5Pers.Font.Style := [fsBold];
    LF1_Inst5Pers.HeightStyle := ssAuto;
    LF1_Inst5Pers.HeightPercent := 100.00000000000000000;
    LF1_Inst5Pers.ParentFont := False;
    LF1_Inst5Pers.TabOrder := 19;
    LF1_Inst5Pers.Text := 'TMSFNCEdit1';
    LF1_Inst5Pers.WidthPercent := 100.00000000000000000;
    LF1_Inst5Pers.DataField := 'Hbss_Institutes_Laboratory';
    LF1_Inst5Pers.DataSource := StartingSolutionDataSource;
    LF1_Inst6Pers.SetParentComponent(pnAusstattung);
    LF1_Inst6Pers.Name := 'LF1_Inst6Pers';
    LF1_Inst6Pers.Left := 832;
    LF1_Inst6Pers.Top := 637;
    LF1_Inst6Pers.Width := 150;
    LF1_Inst6Pers.Height := 46;
    LF1_Inst6Pers.ChildOrder := 39;
    LF1_Inst6Pers.EditType := weNumeric;
    LF1_Inst6Pers.ElementFont := efCSS;
    LF1_Inst6Pers.Font.Charset := ANSI_CHARSET;
    LF1_Inst6Pers.Font.Color := clWindowText;
    LF1_Inst6Pers.Font.Height := -24;
    LF1_Inst6Pers.Font.Name := 'Segoe UI';
    LF1_Inst6Pers.Font.Style := [fsBold];
    LF1_Inst6Pers.HeightStyle := ssAuto;
    LF1_Inst6Pers.HeightPercent := 100.00000000000000000;
    LF1_Inst6Pers.ParentFont := False;
    LF1_Inst6Pers.TabOrder := 20;
    LF1_Inst6Pers.Text := 'TMSFNCEdit1';
    LF1_Inst6Pers.WidthPercent := 100.00000000000000000;
    LF1_Inst6Pers.DataField := 'Hbss_Institutes_Cleaning';
    LF1_Inst6Pers.DataSource := StartingSolutionDataSource;
    LF1_StartInd.SetParentComponent(pnAusstattung);
    LF1_StartInd.Name := 'LF1_StartInd';
    LF1_StartInd.Left := 832;
    LF1_StartInd.Top := 710;
    LF1_StartInd.Width := 150;
    LF1_StartInd.Height := 46;
    LF1_StartInd.ChildOrder := 40;
    LF1_StartInd.EditType := weNumeric;
    LF1_StartInd.ElementFont := efCSS;
    LF1_StartInd.Font.Charset := ANSI_CHARSET;
    LF1_StartInd.Font.Color := clWindowText;
    LF1_StartInd.Font.Height := -24;
    LF1_StartInd.Font.Name := 'Segoe UI';
    LF1_StartInd.Font.Style := [fsBold];
    LF1_StartInd.HeightStyle := ssAuto;
    LF1_StartInd.HeightPercent := 100.00000000000000000;
    LF1_StartInd.ParentFont := False;
    LF1_StartInd.TabOrder := 21;
    LF1_StartInd.Text := 'TMSFNCEdit1';
    LF1_StartInd.WidthPercent := 100.00000000000000000;
    LF1_StartInd.DataField := 'Hbss_Institutes_Start_Indexes';
    LF1_StartInd.DataSource := StartingSolutionDataSource;
    pgPageBilanz.SetParentComponent(PageControl);
    pgPageBilanz.Name := 'pgPageBilanz';
    pgPageBilanz.Left := 0;
    pgPageBilanz.Top := 20;
    pgPageBilanz.Width := 1937;
    pgPageBilanz.Height := 991;
    pgPageBilanz.ElementClassName := 'h-full w-full overflow-auto flex flex-col p-4 gap-4';
    pgPageBilanz.Caption := 'Bilanz';
    pgPageBilanz.ChildOrder := 2;
    pgPageBilanz.ElementFont := efCSS;
    pnBilanz.SetParentComponent(pgPageBilanz);
    pnBilanz.Name := 'pnBilanz';
    pnBilanz.Left := 0;
    pnBilanz.Top := 0;
    pnBilanz.Width := 1937;
    pnBilanz.Height := 833;
    pnBilanz.Align := alTop;
    pnBilanz.TabOrder := 0;
    pnAktiva.SetParentComponent(pnBilanz);
    pnAktiva.Name := 'pnAktiva';
    pnAktiva.Left := 0;
    pnAktiva.Top := 0;
    pnAktiva.Width := 700;
    pnAktiva.Height := 833;
    pnAktiva.Align := alLeft;
    pnAktiva.TabOrder := 0;
    WebLabel6.SetParentComponent(pnAktiva);
    WebLabel6.Name := 'WebLabel6';
    WebLabel6.Left := 50;
    WebLabel6.Top := 738;
    WebLabel6.Width := 182;
    WebLabel6.Height := 29;
    WebLabel6.Caption := 'BILANZSUMME';
    WebLabel6.ElementFont := efCSS;
    WebLabel6.Font.Charset := DEFAULT_CHARSET;
    WebLabel6.Font.Color := clWindowText;
    WebLabel6.Font.Height := -24;
    WebLabel6.Font.Name := 'Tahoma';
    WebLabel6.Font.Style := [fsBold];
    WebLabel6.HeightStyle := ssAuto;
    WebLabel6.HeightPercent := 100.00000000000000000;
    WebLabel6.ParentFont := False;
    WebLabel6.WidthPercent := 100.00000000000000000;
    WebLabel12.SetParentComponent(pnAktiva);
    WebLabel12.Name := 'WebLabel12';
    WebLabel12.Left := 50;
    WebLabel12.Top := 330;
    WebLabel12.Width := 240;
    WebLabel12.Height := 29;
    WebLabel12.Caption := 'UMLAUFVERM'#214'GEN';
    WebLabel12.ElementFont := efCSS;
    WebLabel12.Font.Charset := DEFAULT_CHARSET;
    WebLabel12.Font.Color := clWindowText;
    WebLabel12.Font.Height := -24;
    WebLabel12.Font.Name := 'Tahoma';
    WebLabel12.Font.Style := [fsBold];
    WebLabel12.HeightStyle := ssAuto;
    WebLabel12.HeightPercent := 100.00000000000000000;
    WebLabel12.ParentFont := False;
    WebLabel12.WidthPercent := 100.00000000000000000;
    WebLabel31.SetParentComponent(pnAktiva);
    WebLabel31.Name := 'WebLabel31';
    WebLabel31.Left := 50;
    WebLabel31.Top := 618;
    WebLabel31.Width := 179;
    WebLabel31.Height := 29;
    WebLabel31.Caption := 'Kassenbestand';
    WebLabel31.ElementFont := efCSS;
    WebLabel31.Font.Charset := DEFAULT_CHARSET;
    WebLabel31.Font.Color := clWindowText;
    WebLabel31.Font.Height := -24;
    WebLabel31.Font.Name := 'Tahoma';
    WebLabel31.Font.Style := [fsBold];
    WebLabel31.HeightStyle := ssAuto;
    WebLabel31.HeightPercent := 100.00000000000000000;
    WebLabel31.ParentFont := False;
    WebLabel31.WidthPercent := 100.00000000000000000;
    WebLabel32.SetParentComponent(pnAktiva);
    WebLabel32.Name := 'WebLabel32';
    WebLabel32.Left := 98;
    WebLabel32.Top := 573;
    WebLabel32.Width := 186;
    WebLabel32.Height := 29;
    WebLabel32.Caption := 'Ford. nach KHG';
    WebLabel32.ElementFont := efCSS;
    WebLabel32.Font.Charset := DEFAULT_CHARSET;
    WebLabel32.Font.Color := clWindowText;
    WebLabel32.Font.Height := -24;
    WebLabel32.Font.Name := 'Tahoma';
    WebLabel32.Font.Style := [fsBold];
    WebLabel32.HeightStyle := ssAuto;
    WebLabel32.HeightPercent := 100.00000000000000000;
    WebLabel32.ParentFont := False;
    WebLabel32.WidthPercent := 100.00000000000000000;
    WebLabel33.SetParentComponent(pnAktiva);
    WebLabel33.Name := 'WebLabel33';
    WebLabel33.Left := 98;
    WebLabel33.Top := 528;
    WebLabel33.Width := 357;
    WebLabel33.Height := 29;
    WebLabel33.Caption := 'Forderungen aus Lief. && Leist.';
    WebLabel33.ElementFont := efCSS;
    WebLabel33.Font.Charset := DEFAULT_CHARSET;
    WebLabel33.Font.Color := clWindowText;
    WebLabel33.Font.Height := -24;
    WebLabel33.Font.Name := 'Tahoma';
    WebLabel33.Font.Style := [fsBold];
    WebLabel33.HeightStyle := ssAuto;
    WebLabel33.HeightPercent := 100.00000000000000000;
    WebLabel33.ParentFont := False;
    WebLabel33.WidthPercent := 100.00000000000000000;
    WebLabel34.SetParentComponent(pnAktiva);
    WebLabel34.Name := 'WebLabel34';
    WebLabel34.Left := 50;
    WebLabel34.Top := 493;
    WebLabel34.Width := 152;
    WebLabel34.Height := 29;
    WebLabel34.Caption := 'Forderungen';
    WebLabel34.ElementFont := efCSS;
    WebLabel34.Font.Charset := DEFAULT_CHARSET;
    WebLabel34.Font.Color := clWindowText;
    WebLabel34.Font.Height := -24;
    WebLabel34.Font.Name := 'Tahoma';
    WebLabel34.Font.Style := [fsBold];
    WebLabel34.HeightStyle := ssAuto;
    WebLabel34.HeightPercent := 100.00000000000000000;
    WebLabel34.ParentFont := False;
    WebLabel34.WidthPercent := 100.00000000000000000;
    WebLabel38.SetParentComponent(pnAktiva);
    WebLabel38.Name := 'WebLabel38';
    WebLabel38.Left := 98;
    WebLabel38.Top := 453;
    WebLabel38.Width := 359;
    WebLabel38.Height := 29;
    WebLabel38.Caption := 'Lebensmittel, Wirtschaftsbed.';
    WebLabel38.ElementFont := efCSS;
    WebLabel38.Font.Charset := DEFAULT_CHARSET;
    WebLabel38.Font.Color := clWindowText;
    WebLabel38.Font.Height := -24;
    WebLabel38.Font.Name := 'Tahoma';
    WebLabel38.Font.Style := [fsBold];
    WebLabel38.HeightStyle := ssAuto;
    WebLabel38.HeightPercent := 100.00000000000000000;
    WebLabel38.ParentFont := False;
    WebLabel38.WidthPercent := 100.00000000000000000;
    WebLabel39.SetParentComponent(pnAktiva);
    WebLabel39.Name := 'WebLabel39';
    WebLabel39.Left := 98;
    WebLabel39.Top := 408;
    WebLabel39.Width := 143;
    WebLabel39.Height := 29;
    WebLabel39.Caption := 'Med. Bedarf';
    WebLabel39.ElementFont := efCSS;
    WebLabel39.Font.Charset := DEFAULT_CHARSET;
    WebLabel39.Font.Color := clWindowText;
    WebLabel39.Font.Height := -24;
    WebLabel39.Font.Name := 'Tahoma';
    WebLabel39.Font.Style := [fsBold];
    WebLabel39.HeightStyle := ssAuto;
    WebLabel39.HeightPercent := 100.00000000000000000;
    WebLabel39.ParentFont := False;
    WebLabel39.WidthPercent := 100.00000000000000000;
    WebLabel40.SetParentComponent(pnAktiva);
    WebLabel40.Name := 'WebLabel40';
    WebLabel40.Left := 50;
    WebLabel40.Top := 373;
    WebLabel40.Width := 89;
    WebLabel40.Height := 29;
    WebLabel40.Caption := 'Vorr'#228'te';
    WebLabel40.ElementFont := efCSS;
    WebLabel40.Font.Charset := DEFAULT_CHARSET;
    WebLabel40.Font.Color := clWindowText;
    WebLabel40.Font.Height := -24;
    WebLabel40.Font.Name := 'Tahoma';
    WebLabel40.Font.Style := [fsBold];
    WebLabel40.HeightStyle := ssAuto;
    WebLabel40.HeightPercent := 100.00000000000000000;
    WebLabel40.ParentFont := False;
    WebLabel40.WidthPercent := 100.00000000000000000;
    WebLabel9.SetParentComponent(pnAktiva);
    WebLabel9.Name := 'WebLabel9';
    WebLabel9.Left := 98;
    WebLabel9.Top := 207;
    WebLabel9.Width := 260;
    WebLabel9.Height := 29;
    WebLabel9.Caption := 'Med. - techn. Anlagen';
    WebLabel9.ElementFont := efCSS;
    WebLabel9.Font.Charset := DEFAULT_CHARSET;
    WebLabel9.Font.Color := clWindowText;
    WebLabel9.Font.Height := -24;
    WebLabel9.Font.Name := 'Tahoma';
    WebLabel9.Font.Style := [fsBold];
    WebLabel9.HeightStyle := ssAuto;
    WebLabel9.HeightPercent := 100.00000000000000000;
    WebLabel9.ParentFont := False;
    WebLabel9.WidthPercent := 100.00000000000000000;
    WebLabel10.SetParentComponent(pnAktiva);
    WebLabel10.Name := 'WebLabel10';
    WebLabel10.Left := 98;
    WebLabel10.Top := 162;
    WebLabel10.Width := 294;
    WebLabel10.Height := 29;
    WebLabel10.Caption := 'Grundst'#252'cke und Bauten';
    WebLabel10.ElementFont := efCSS;
    WebLabel10.Font.Charset := DEFAULT_CHARSET;
    WebLabel10.Font.Color := clWindowText;
    WebLabel10.Font.Height := -24;
    WebLabel10.Font.Name := 'Tahoma';
    WebLabel10.Font.Style := [fsBold];
    WebLabel10.HeightStyle := ssAuto;
    WebLabel10.HeightPercent := 100.00000000000000000;
    WebLabel10.ParentFont := False;
    WebLabel10.WidthPercent := 100.00000000000000000;
    WebLabel11.SetParentComponent(pnAktiva);
    WebLabel11.Name := 'WebLabel11';
    WebLabel11.Left := 50;
    WebLabel11.Top := 127;
    WebLabel11.Width := 151;
    WebLabel11.Height := 29;
    WebLabel11.Caption := 'Sachanlagen';
    WebLabel11.ElementFont := efCSS;
    WebLabel11.Font.Charset := DEFAULT_CHARSET;
    WebLabel11.Font.Color := clWindowText;
    WebLabel11.Font.Height := -24;
    WebLabel11.Font.Name := 'Tahoma';
    WebLabel11.Font.Style := [fsBold];
    WebLabel11.HeightStyle := ssAuto;
    WebLabel11.HeightPercent := 100.00000000000000000;
    WebLabel11.ParentFont := False;
    WebLabel11.WidthPercent := 100.00000000000000000;
    WebLabel41.SetParentComponent(pnAktiva);
    WebLabel41.Name := 'WebLabel41';
    WebLabel41.Left := 98;
    WebLabel41.Top := 252;
    WebLabel41.Width := 343;
    WebLabel41.Height := 29;
    WebLabel41.Caption := 'Einrichtungen && Ausstattung';
    WebLabel41.ElementFont := efCSS;
    WebLabel41.Font.Charset := DEFAULT_CHARSET;
    WebLabel41.Font.Color := clWindowText;
    WebLabel41.Font.Height := -24;
    WebLabel41.Font.Name := 'Tahoma';
    WebLabel41.Font.Style := [fsBold];
    WebLabel41.HeightStyle := ssAuto;
    WebLabel41.HeightPercent := 100.00000000000000000;
    WebLabel41.ParentFont := False;
    WebLabel41.WidthPercent := 100.00000000000000000;
    WebLabel42.SetParentComponent(pnAktiva);
    WebLabel42.Name := 'WebLabel42';
    WebLabel42.Left := 50;
    WebLabel42.Top := 87;
    WebLabel42.Width := 237;
    WebLabel42.Height := 29;
    WebLabel42.Caption := 'ANLAGEVERM'#214'GEN';
    WebLabel42.ElementFont := efCSS;
    WebLabel42.Font.Charset := DEFAULT_CHARSET;
    WebLabel42.Font.Color := clWindowText;
    WebLabel42.Font.Height := -24;
    WebLabel42.Font.Name := 'Tahoma';
    WebLabel42.Font.Style := [fsBold];
    WebLabel42.HeightStyle := ssAuto;
    WebLabel42.HeightPercent := 100.00000000000000000;
    WebLabel42.ParentFont := False;
    WebLabel42.WidthPercent := 100.00000000000000000;
    RFE_UmlaufVer.SetParentComponent(pnAktiva);
    RFE_UmlaufVer.Name := 'RFE_UmlaufVer';
    RFE_UmlaufVer.Left := 482;
    RFE_UmlaufVer.Top := 325;
    RFE_UmlaufVer.Width := 150;
    RFE_UmlaufVer.Height := 46;
    RFE_UmlaufVer.TabStop := False;
    RFE_UmlaufVer.ChildOrder := 14;
    RFE_UmlaufVer.EditType := weNumeric;
    RFE_UmlaufVer.ElementFont := efCSS;
    RFE_UmlaufVer.Font.Charset := ANSI_CHARSET;
    RFE_UmlaufVer.Font.Color := clWindowText;
    RFE_UmlaufVer.Font.Height := -24;
    RFE_UmlaufVer.Font.Name := 'Segoe UI';
    RFE_UmlaufVer.Font.Style := [fsBold];
    RFE_UmlaufVer.HeightStyle := ssAuto;
    RFE_UmlaufVer.HeightPercent := 100.00000000000000000;
    RFE_UmlaufVer.ParentFont := False;
    RFE_UmlaufVer.ReadOnly := True;
    RFE_UmlaufVer.Text := 'RFE_UmlaufVer';
    RFE_UmlaufVer.WidthPercent := 100.00000000000000000;
    SetEvent(RFE_UmlaufVer, Self, 'OnExit', 'RFE_AnlageVerExit');
    RFE_UmlaufVer.DataField := 'Hbss_Curr_Assets';
    RFE_UmlaufVer.DataSource := StartingSolutionDataSource;
    RFE_ForderLuL.SetParentComponent(pnAktiva);
    RFE_ForderLuL.Name := 'RFE_ForderLuL';
    RFE_ForderLuL.Left := 482;
    RFE_ForderLuL.Top := 523;
    RFE_ForderLuL.Width := 150;
    RFE_ForderLuL.Height := 46;
    RFE_ForderLuL.ChildOrder := 15;
    RFE_ForderLuL.EditType := weNumeric;
    RFE_ForderLuL.ElementFont := efCSS;
    RFE_ForderLuL.Font.Charset := ANSI_CHARSET;
    RFE_ForderLuL.Font.Color := clWindowText;
    RFE_ForderLuL.Font.Height := -24;
    RFE_ForderLuL.Font.Name := 'Segoe UI';
    RFE_ForderLuL.Font.Style := [fsBold];
    RFE_ForderLuL.HeightStyle := ssAuto;
    RFE_ForderLuL.HeightPercent := 100.00000000000000000;
    RFE_ForderLuL.ParentFont := False;
    RFE_ForderLuL.TabOrder := 1;
    RFE_ForderLuL.Text := 'RFE_ForderLuL';
    RFE_ForderLuL.WidthPercent := 100.00000000000000000;
    SetEvent(RFE_ForderLuL, Self, 'OnExit', 'RFE_AnlageVerExit');
    RFE_ForderLuL.DataField := 'Hbss_Curr_Assets_Receivables';
    RFE_ForderLuL.DataSource := StartingSolutionDataSource;
    RFE_ForderKHG.SetParentComponent(pnAktiva);
    RFE_ForderKHG.Name := 'RFE_ForderKHG';
    RFE_ForderKHG.Left := 482;
    RFE_ForderKHG.Top := 568;
    RFE_ForderKHG.Width := 150;
    RFE_ForderKHG.Height := 46;
    RFE_ForderKHG.ChildOrder := 16;
    RFE_ForderKHG.EditType := weNumeric;
    RFE_ForderKHG.ElementFont := efCSS;
    RFE_ForderKHG.Font.Charset := ANSI_CHARSET;
    RFE_ForderKHG.Font.Color := clWindowText;
    RFE_ForderKHG.Font.Height := -24;
    RFE_ForderKHG.Font.Name := 'Segoe UI';
    RFE_ForderKHG.Font.Style := [fsBold];
    RFE_ForderKHG.HeightStyle := ssAuto;
    RFE_ForderKHG.HeightPercent := 100.00000000000000000;
    RFE_ForderKHG.ParentFont := False;
    RFE_ForderKHG.TabOrder := 2;
    RFE_ForderKHG.Text := 'RFE_ForderKHG';
    RFE_ForderKHG.WidthPercent := 100.00000000000000000;
    SetEvent(RFE_ForderKHG, Self, 'OnExit', 'RFE_AnlageVerExit');
    RFE_ForderKHG.DataField := 'Hbss_Curr_Assets_Receivables_Khg';
    RFE_ForderKHG.DataSource := StartingSolutionDataSource;
    RFE_KassenBes.SetParentComponent(pnAktiva);
    RFE_KassenBes.Name := 'RFE_KassenBes';
    RFE_KassenBes.Left := 482;
    RFE_KassenBes.Top := 613;
    RFE_KassenBes.Width := 150;
    RFE_KassenBes.Height := 46;
    RFE_KassenBes.ChildOrder := 17;
    RFE_KassenBes.EditType := weNumeric;
    RFE_KassenBes.ElementFont := efCSS;
    RFE_KassenBes.Font.Charset := ANSI_CHARSET;
    RFE_KassenBes.Font.Color := clWindowText;
    RFE_KassenBes.Font.Height := -24;
    RFE_KassenBes.Font.Name := 'Segoe UI';
    RFE_KassenBes.Font.Style := [fsBold];
    RFE_KassenBes.HeightStyle := ssAuto;
    RFE_KassenBes.HeightPercent := 100.00000000000000000;
    RFE_KassenBes.ParentFont := False;
    RFE_KassenBes.TabOrder := 3;
    RFE_KassenBes.Text := 'RFE_KassenBes';
    RFE_KassenBes.WidthPercent := 100.00000000000000000;
    SetEvent(RFE_KassenBes, Self, 'OnExit', 'RFE_AnlageVerExit');
    RFE_KassenBes.DataField := 'Hbss_Curr_Assets_Cash_Balance';
    RFE_KassenBes.DataSource := StartingSolutionDataSource;
    RFE_MedBedarf.SetParentComponent(pnAktiva);
    RFE_MedBedarf.Name := 'RFE_MedBedarf';
    RFE_MedBedarf.Left := 482;
    RFE_MedBedarf.Top := 403;
    RFE_MedBedarf.Width := 150;
    RFE_MedBedarf.Height := 46;
    RFE_MedBedarf.ChildOrder := 19;
    RFE_MedBedarf.EditType := weNumeric;
    RFE_MedBedarf.ElementFont := efCSS;
    RFE_MedBedarf.Font.Charset := ANSI_CHARSET;
    RFE_MedBedarf.Font.Color := clWindowText;
    RFE_MedBedarf.Font.Height := -24;
    RFE_MedBedarf.Font.Name := 'Segoe UI';
    RFE_MedBedarf.Font.Style := [fsBold];
    RFE_MedBedarf.HeightStyle := ssAuto;
    RFE_MedBedarf.HeightPercent := 100.00000000000000000;
    RFE_MedBedarf.ParentFont := False;
    RFE_MedBedarf.TabOrder := 5;
    RFE_MedBedarf.Text := 'RFE_MedBedarf';
    RFE_MedBedarf.WidthPercent := 100.00000000000000000;
    SetEvent(RFE_MedBedarf, Self, 'OnExit', 'RFE_AnlageVerExit');
    RFE_MedBedarf.DataField := 'Hbss_Curr_Assets_Med_Needs';
    RFE_MedBedarf.DataSource := StartingSolutionDataSource;
    RFE_Lebensmtl.SetParentComponent(pnAktiva);
    RFE_Lebensmtl.Name := 'RFE_Lebensmtl';
    RFE_Lebensmtl.Left := 482;
    RFE_Lebensmtl.Top := 448;
    RFE_Lebensmtl.Width := 150;
    RFE_Lebensmtl.Height := 46;
    RFE_Lebensmtl.ChildOrder := 20;
    RFE_Lebensmtl.EditType := weNumeric;
    RFE_Lebensmtl.ElementFont := efCSS;
    RFE_Lebensmtl.Font.Charset := ANSI_CHARSET;
    RFE_Lebensmtl.Font.Color := clWindowText;
    RFE_Lebensmtl.Font.Height := -24;
    RFE_Lebensmtl.Font.Name := 'Segoe UI';
    RFE_Lebensmtl.Font.Style := [fsBold];
    RFE_Lebensmtl.HeightStyle := ssAuto;
    RFE_Lebensmtl.HeightPercent := 100.00000000000000000;
    RFE_Lebensmtl.ParentFont := False;
    RFE_Lebensmtl.TabOrder := 6;
    RFE_Lebensmtl.Text := 'RFE_Lebensmtl';
    RFE_Lebensmtl.WidthPercent := 100.00000000000000000;
    SetEvent(RFE_Lebensmtl, Self, 'OnExit', 'RFE_AnlageVerExit');
    RFE_Lebensmtl.DataField := 'Hbss_Curr_Assets_Supplies';
    RFE_Lebensmtl.DataSource := StartingSolutionDataSource;
    RFE_Imobilien.SetParentComponent(pnAktiva);
    RFE_Imobilien.Name := 'RFE_Imobilien';
    RFE_Imobilien.Left := 482;
    RFE_Imobilien.Top := 157;
    RFE_Imobilien.Width := 150;
    RFE_Imobilien.Height := 46;
    RFE_Imobilien.ChildOrder := 21;
    RFE_Imobilien.EditType := weNumeric;
    RFE_Imobilien.ElementFont := efCSS;
    RFE_Imobilien.Font.Charset := ANSI_CHARSET;
    RFE_Imobilien.Font.Color := clWindowText;
    RFE_Imobilien.Font.Height := -24;
    RFE_Imobilien.Font.Name := 'Segoe UI';
    RFE_Imobilien.Font.Style := [fsBold];
    RFE_Imobilien.HeightStyle := ssAuto;
    RFE_Imobilien.HeightPercent := 100.00000000000000000;
    RFE_Imobilien.ParentFont := False;
    RFE_Imobilien.TabOrder := 7;
    RFE_Imobilien.Text := 'RFE_Imobilien';
    RFE_Imobilien.WidthPercent := 100.00000000000000000;
    SetEvent(RFE_Imobilien, Self, 'OnExit', 'RFE_AnlageVerExit');
    RFE_Imobilien.DataField := 'Hbss_Assets_Buildings';
    RFE_Imobilien.DataSource := StartingSolutionDataSource;
    RFE_MedtechAnl.SetParentComponent(pnAktiva);
    RFE_MedtechAnl.Name := 'RFE_MedtechAnl';
    RFE_MedtechAnl.Left := 482;
    RFE_MedtechAnl.Top := 200;
    RFE_MedtechAnl.Width := 150;
    RFE_MedtechAnl.Height := 46;
    RFE_MedtechAnl.ChildOrder := 22;
    RFE_MedtechAnl.EditType := weNumeric;
    RFE_MedtechAnl.ElementFont := efCSS;
    RFE_MedtechAnl.Font.Charset := ANSI_CHARSET;
    RFE_MedtechAnl.Font.Color := clWindowText;
    RFE_MedtechAnl.Font.Height := -24;
    RFE_MedtechAnl.Font.Name := 'Segoe UI';
    RFE_MedtechAnl.Font.Style := [fsBold];
    RFE_MedtechAnl.HeightStyle := ssAuto;
    RFE_MedtechAnl.HeightPercent := 100.00000000000000000;
    RFE_MedtechAnl.ParentFont := False;
    RFE_MedtechAnl.TabOrder := 8;
    RFE_MedtechAnl.Text := 'RFE_MedtechAnl';
    RFE_MedtechAnl.WidthPercent := 100.00000000000000000;
    SetEvent(RFE_MedtechAnl, Self, 'OnExit', 'RFE_AnlageVerExit');
    RFE_MedtechAnl.DataField := 'Hbss_Assets_Med_Systems';
    RFE_MedtechAnl.DataSource := StartingSolutionDataSource;
    RFE_Einrichtng.SetParentComponent(pnAktiva);
    RFE_Einrichtng.Name := 'RFE_Einrichtng';
    RFE_Einrichtng.Left := 482;
    RFE_Einrichtng.Top := 243;
    RFE_Einrichtng.Width := 150;
    RFE_Einrichtng.Height := 46;
    RFE_Einrichtng.ChildOrder := 23;
    RFE_Einrichtng.EditType := weNumeric;
    RFE_Einrichtng.ElementFont := efCSS;
    RFE_Einrichtng.Font.Charset := ANSI_CHARSET;
    RFE_Einrichtng.Font.Color := clWindowText;
    RFE_Einrichtng.Font.Height := -24;
    RFE_Einrichtng.Font.Name := 'Segoe UI';
    RFE_Einrichtng.Font.Style := [fsBold];
    RFE_Einrichtng.HeightStyle := ssAuto;
    RFE_Einrichtng.HeightPercent := 100.00000000000000000;
    RFE_Einrichtng.ParentFont := False;
    RFE_Einrichtng.TabOrder := 9;
    RFE_Einrichtng.Text := 'RFE_Einrichtng';
    RFE_Einrichtng.WidthPercent := 100.00000000000000000;
    SetEvent(RFE_Einrichtng, Self, 'OnExit', 'RFE_AnlageVerExit');
    RFE_Einrichtng.DataField := 'Hbss_Assets_Facilities';
    RFE_Einrichtng.DataSource := StartingSolutionDataSource;
    RFE_AnlageVer.SetParentComponent(pnAktiva);
    RFE_AnlageVer.Name := 'RFE_AnlageVer';
    RFE_AnlageVer.Left := 482;
    RFE_AnlageVer.Top := 82;
    RFE_AnlageVer.Width := 150;
    RFE_AnlageVer.Height := 46;
    RFE_AnlageVer.TabStop := False;
    RFE_AnlageVer.ChildOrder := 24;
    RFE_AnlageVer.EditType := weNumeric;
    RFE_AnlageVer.ElementFont := efCSS;
    RFE_AnlageVer.Font.Charset := ANSI_CHARSET;
    RFE_AnlageVer.Font.Color := clWindowText;
    RFE_AnlageVer.Font.Height := -24;
    RFE_AnlageVer.Font.Name := 'Segoe UI';
    RFE_AnlageVer.Font.Style := [fsBold];
    RFE_AnlageVer.HeightStyle := ssAuto;
    RFE_AnlageVer.HeightPercent := 100.00000000000000000;
    RFE_AnlageVer.ParentFont := False;
    RFE_AnlageVer.ReadOnly := True;
    RFE_AnlageVer.TabOrder := 10;
    RFE_AnlageVer.Text := 'RFE_AnlageVer';
    RFE_AnlageVer.WidthPercent := 100.00000000000000000;
    SetEvent(RFE_AnlageVer, Self, 'OnExit', 'RFE_AnlageVerExit');
    RFE_AnlageVer.DataField := 'Hbss_Assets_Fixed';
    RFE_AnlageVer.DataSource := StartingSolutionDataSource;
    RFE_BilSumAkt.SetParentComponent(pnAktiva);
    RFE_BilSumAkt.Name := 'RFE_BilSumAkt';
    RFE_BilSumAkt.Left := 482;
    RFE_BilSumAkt.Top := 721;
    RFE_BilSumAkt.Width := 150;
    RFE_BilSumAkt.Height := 46;
    RFE_BilSumAkt.TabStop := False;
    RFE_BilSumAkt.ChildOrder := 25;
    RFE_BilSumAkt.EditType := weNumeric;
    RFE_BilSumAkt.ElementFont := efCSS;
    RFE_BilSumAkt.HeightPercent := 100.00000000000000000;
    RFE_BilSumAkt.ReadOnly := True;
    RFE_BilSumAkt.Text := 'RFE_BilSumAkt';
    RFE_BilSumAkt.WidthPercent := 100.00000000000000000;
    pnPassiva.SetParentComponent(pnBilanz);
    pnPassiva.Name := 'pnPassiva';
    pnPassiva.Left := 700;
    pnPassiva.Top := 0;
    pnPassiva.Width := 700;
    pnPassiva.Height := 833;
    pnPassiva.Align := alLeft;
    pnPassiva.TabOrder := 1;
    WebLabel43.SetParentComponent(pnPassiva);
    WebLabel43.Name := 'WebLabel43';
    WebLabel43.Left := 58;
    WebLabel43.Top := 738;
    WebLabel43.Width := 182;
    WebLabel43.Height := 29;
    WebLabel43.Caption := 'BILANZSUMME';
    WebLabel43.ElementFont := efCSS;
    WebLabel43.Font.Charset := DEFAULT_CHARSET;
    WebLabel43.Font.Color := clWindowText;
    WebLabel43.Font.Height := -24;
    WebLabel43.Font.Name := 'Tahoma';
    WebLabel43.Font.Style := [fsBold];
    WebLabel43.HeightStyle := ssAuto;
    WebLabel43.HeightPercent := 100.00000000000000000;
    WebLabel43.ParentFont := False;
    WebLabel43.WidthPercent := 100.00000000000000000;
    WebLabel44.SetParentComponent(pnPassiva);
    WebLabel44.Name := 'WebLabel44';
    WebLabel44.Left := 58;
    WebLabel44.Top := 330;
    WebLabel44.Width := 230;
    WebLabel44.Height := 29;
    WebLabel44.Caption := 'R'#220'CKSTELLUNGEN';
    WebLabel44.ElementFont := efCSS;
    WebLabel44.Font.Charset := DEFAULT_CHARSET;
    WebLabel44.Font.Color := clWindowText;
    WebLabel44.Font.Height := -24;
    WebLabel44.Font.Name := 'Tahoma';
    WebLabel44.Font.Style := [fsBold];
    WebLabel44.HeightStyle := ssAuto;
    WebLabel44.HeightPercent := 100.00000000000000000;
    WebLabel44.ParentFont := False;
    WebLabel44.WidthPercent := 100.00000000000000000;
    WebLabel48.SetParentComponent(pnPassiva);
    WebLabel48.Name := 'WebLabel48';
    WebLabel48.Left := 106;
    WebLabel48.Top := 618;
    WebLabel48.Width := 296;
    WebLabel48.Height := 29;
    WebLabel48.Caption := 'mittelfristig (1 - 5 Jahre)';
    WebLabel48.ElementFont := efCSS;
    WebLabel48.Font.Charset := DEFAULT_CHARSET;
    WebLabel48.Font.Color := clWindowText;
    WebLabel48.Font.Height := -24;
    WebLabel48.Font.Name := 'Tahoma';
    WebLabel48.Font.Style := [fsBold];
    WebLabel48.HeightStyle := ssAuto;
    WebLabel48.HeightPercent := 100.00000000000000000;
    WebLabel48.ParentFont := False;
    WebLabel48.WidthPercent := 100.00000000000000000;
    WebLabel49.SetParentComponent(pnPassiva);
    WebLabel49.Name := 'WebLabel49';
    WebLabel49.Left := 106;
    WebLabel49.Top := 573;
    WebLabel49.Width := 300;
    WebLabel49.Height := 29;
    WebLabel49.Caption := 'kurzfristig (bis zu 1 Jahr)';
    WebLabel49.ElementFont := efCSS;
    WebLabel49.Font.Charset := DEFAULT_CHARSET;
    WebLabel49.Font.Color := clWindowText;
    WebLabel49.Font.Height := -24;
    WebLabel49.Font.Name := 'Tahoma';
    WebLabel49.Font.Style := [fsBold];
    WebLabel49.HeightStyle := ssAuto;
    WebLabel49.HeightPercent := 100.00000000000000000;
    WebLabel49.ParentFont := False;
    WebLabel49.WidthPercent := 100.00000000000000000;
    WebLabel50.SetParentComponent(pnPassiva);
    WebLabel50.Name := 'WebLabel50';
    WebLabel50.Left := 106;
    WebLabel50.Top := 528;
    WebLabel50.Width := 233;
    WebLabel50.Height := 29;
    WebLabel50.Caption := #220'berziehungskredit';
    WebLabel50.ElementFont := efCSS;
    WebLabel50.Font.Charset := DEFAULT_CHARSET;
    WebLabel50.Font.Color := clWindowText;
    WebLabel50.Font.Height := -24;
    WebLabel50.Font.Name := 'Tahoma';
    WebLabel50.Font.Style := [fsBold];
    WebLabel50.HeightStyle := ssAuto;
    WebLabel50.HeightPercent := 100.00000000000000000;
    WebLabel50.ParentFont := False;
    WebLabel50.WidthPercent := 100.00000000000000000;
    WebLabel51.SetParentComponent(pnPassiva);
    WebLabel51.Name := 'WebLabel51';
    WebLabel51.Left := 58;
    WebLabel51.Top := 493;
    WebLabel51.Width := 400;
    WebLabel51.Height := 29;
    WebLabel51.Caption := 'Verbindlichkeiten gg'#252'. Kreditinst.';
    WebLabel51.ElementFont := efCSS;
    WebLabel51.Font.Charset := DEFAULT_CHARSET;
    WebLabel51.Font.Color := clWindowText;
    WebLabel51.Font.Height := -24;
    WebLabel51.Font.Name := 'Tahoma';
    WebLabel51.Font.Style := [fsBold];
    WebLabel51.HeightStyle := ssAuto;
    WebLabel51.HeightPercent := 100.00000000000000000;
    WebLabel51.ParentFont := False;
    WebLabel51.WidthPercent := 100.00000000000000000;
    WebLabel55.SetParentComponent(pnPassiva);
    WebLabel55.Name := 'WebLabel55';
    WebLabel55.Left := 58;
    WebLabel55.Top := 453;
    WebLabel55.Width := 266;
    WebLabel55.Height := 29;
    WebLabel55.Caption := 'VERBINDLICHKEITEN';
    WebLabel55.ElementFont := efCSS;
    WebLabel55.Font.Charset := DEFAULT_CHARSET;
    WebLabel55.Font.Color := clWindowText;
    WebLabel55.Font.Height := -24;
    WebLabel55.Font.Name := 'Tahoma';
    WebLabel55.Font.Style := [fsBold];
    WebLabel55.HeightStyle := ssAuto;
    WebLabel55.HeightPercent := 100.00000000000000000;
    WebLabel55.ParentFont := False;
    WebLabel55.WidthPercent := 100.00000000000000000;
    WebLabel56.SetParentComponent(pnPassiva);
    WebLabel56.Name := 'WebLabel56';
    WebLabel56.Left := 106;
    WebLabel56.Top := 375;
    WebLabel56.Width := 354;
    WebLabel56.Height := 29;
    WebLabel56.Caption := 'R'#252'ckstellungen f'#252'r Pensionen';
    WebLabel56.ElementFont := efCSS;
    WebLabel56.Font.Charset := DEFAULT_CHARSET;
    WebLabel56.Font.Color := clWindowText;
    WebLabel56.Font.Height := -24;
    WebLabel56.Font.Name := 'Tahoma';
    WebLabel56.Font.Style := [fsBold];
    WebLabel56.HeightStyle := ssAuto;
    WebLabel56.HeightPercent := 100.00000000000000000;
    WebLabel56.ParentFont := False;
    WebLabel56.WidthPercent := 100.00000000000000000;
    WebLabel61.SetParentComponent(pnPassiva);
    WebLabel61.Name := 'WebLabel61';
    WebLabel61.Left := 106;
    WebLabel61.Top := 222;
    WebLabel61.Width := 221;
    WebLabel61.Height := 29;
    WebLabel61.Caption := 'Gewinn R'#252'cklagen';
    WebLabel61.ElementFont := efCSS;
    WebLabel61.Font.Charset := DEFAULT_CHARSET;
    WebLabel61.Font.Color := clWindowText;
    WebLabel61.Font.Height := -24;
    WebLabel61.Font.Name := 'Tahoma';
    WebLabel61.Font.Style := [fsBold];
    WebLabel61.HeightStyle := ssAuto;
    WebLabel61.HeightPercent := 100.00000000000000000;
    WebLabel61.ParentFont := False;
    WebLabel61.WidthPercent := 100.00000000000000000;
    WebLabel62.SetParentComponent(pnPassiva);
    WebLabel62.Name := 'WebLabel62';
    WebLabel62.Left := 106;
    WebLabel62.Top := 177;
    WebLabel62.Width := 215;
    WebLabel62.Height := 29;
    WebLabel62.Caption := 'Kapital R'#252'cklagen';
    WebLabel62.ElementFont := efCSS;
    WebLabel62.Font.Charset := DEFAULT_CHARSET;
    WebLabel62.Font.Color := clWindowText;
    WebLabel62.Font.Height := -24;
    WebLabel62.Font.Name := 'Tahoma';
    WebLabel62.Font.Style := [fsBold];
    WebLabel62.HeightStyle := ssAuto;
    WebLabel62.HeightPercent := 100.00000000000000000;
    WebLabel62.ParentFont := False;
    WebLabel62.WidthPercent := 100.00000000000000000;
    WebLabel63.SetParentComponent(pnPassiva);
    WebLabel63.Name := 'WebLabel63';
    WebLabel63.Left := 106;
    WebLabel63.Top := 132;
    WebLabel63.Width := 250;
    WebLabel63.Height := 29;
    WebLabel63.Caption := 'Gezeichnetes Kapital';
    WebLabel63.ElementFont := efCSS;
    WebLabel63.Font.Charset := DEFAULT_CHARSET;
    WebLabel63.Font.Color := clWindowText;
    WebLabel63.Font.Height := -24;
    WebLabel63.Font.Name := 'Tahoma';
    WebLabel63.Font.Style := [fsBold];
    WebLabel63.HeightStyle := ssAuto;
    WebLabel63.HeightPercent := 100.00000000000000000;
    WebLabel63.ParentFont := False;
    WebLabel63.WidthPercent := 100.00000000000000000;
    WebLabel64.SetParentComponent(pnPassiva);
    WebLabel64.Name := 'WebLabel64';
    WebLabel64.Left := 106;
    WebLabel64.Top := 267;
    WebLabel64.Width := 279;
    WebLabel64.Height := 29;
    WebLabel64.Caption := 'Bilanzgewinn / -verlust';
    WebLabel64.ElementFont := efCSS;
    WebLabel64.Font.Charset := DEFAULT_CHARSET;
    WebLabel64.Font.Color := clWindowText;
    WebLabel64.Font.Height := -24;
    WebLabel64.Font.Name := 'Tahoma';
    WebLabel64.Font.Style := [fsBold];
    WebLabel64.HeightStyle := ssAuto;
    WebLabel64.HeightPercent := 100.00000000000000000;
    WebLabel64.ParentFont := False;
    WebLabel64.WidthPercent := 100.00000000000000000;
    WebLabel65.SetParentComponent(pnPassiva);
    WebLabel65.Name := 'WebLabel65';
    WebLabel65.Left := 58;
    WebLabel65.Top := 87;
    WebLabel65.Width := 185;
    WebLabel65.Height := 29;
    WebLabel65.Caption := 'EIGENKAPITAL';
    WebLabel65.ElementFont := efCSS;
    WebLabel65.Font.Charset := DEFAULT_CHARSET;
    WebLabel65.Font.Color := clWindowText;
    WebLabel65.Font.Height := -24;
    WebLabel65.Font.Name := 'Tahoma';
    WebLabel65.Font.Style := [fsBold];
    WebLabel65.HeightStyle := ssAuto;
    WebLabel65.HeightPercent := 100.00000000000000000;
    WebLabel65.ParentFont := False;
    WebLabel65.WidthPercent := 100.00000000000000000;
    WebLabel57.SetParentComponent(pnPassiva);
    WebLabel57.Name := 'WebLabel57';
    WebLabel57.Left := 106;
    WebLabel57.Top := 663;
    WebLabel57.Width := 332;
    WebLabel57.Height := 29;
    WebLabel57.Caption := 'Verbindlichkeiten nach KHG';
    WebLabel57.ElementFont := efCSS;
    WebLabel57.Font.Charset := DEFAULT_CHARSET;
    WebLabel57.Font.Color := clWindowText;
    WebLabel57.Font.Height := -24;
    WebLabel57.Font.Name := 'Tahoma';
    WebLabel57.Font.Style := [fsBold];
    WebLabel57.HeightStyle := ssAuto;
    WebLabel57.HeightPercent := 100.00000000000000000;
    WebLabel57.ParentFont := False;
    WebLabel57.WidthPercent := 100.00000000000000000;
    RFE_Rueckstell.SetParentComponent(pnPassiva);
    RFE_Rueckstell.Name := 'RFE_Rueckstell';
    RFE_Rueckstell.Left := 521;
    RFE_Rueckstell.Top := 325;
    RFE_Rueckstell.Width := 150;
    RFE_Rueckstell.Height := 46;
    RFE_Rueckstell.TabStop := False;
    RFE_Rueckstell.ChildOrder := 14;
    RFE_Rueckstell.EditType := weNumeric;
    RFE_Rueckstell.ElementFont := efCSS;
    RFE_Rueckstell.Font.Charset := ANSI_CHARSET;
    RFE_Rueckstell.Font.Color := clWindowText;
    RFE_Rueckstell.Font.Height := -24;
    RFE_Rueckstell.Font.Name := 'Segoe UI';
    RFE_Rueckstell.Font.Style := [fsBold];
    RFE_Rueckstell.HeightStyle := ssAuto;
    RFE_Rueckstell.HeightPercent := 100.00000000000000000;
    RFE_Rueckstell.ParentFont := False;
    RFE_Rueckstell.ReadOnly := True;
    RFE_Rueckstell.Text := 'RFE_Rueckstell';
    RFE_Rueckstell.WidthPercent := 100.00000000000000000;
    SetEvent(RFE_Rueckstell, Self, 'OnExit', 'RFE_AnlageVerExit');
    RFE_Rueckstell.DataField := 'Hbss_Accruals';
    RFE_Rueckstell.DataSource := StartingSolutionDataSource;
    RFE_UeberzKrd.SetParentComponent(pnPassiva);
    RFE_UeberzKrd.Name := 'RFE_UeberzKrd';
    RFE_UeberzKrd.Left := 521;
    RFE_UeberzKrd.Top := 523;
    RFE_UeberzKrd.Width := 150;
    RFE_UeberzKrd.Height := 46;
    RFE_UeberzKrd.ChildOrder := 15;
    RFE_UeberzKrd.EditType := weNumeric;
    RFE_UeberzKrd.ElementFont := efCSS;
    RFE_UeberzKrd.Font.Charset := ANSI_CHARSET;
    RFE_UeberzKrd.Font.Color := clWindowText;
    RFE_UeberzKrd.Font.Height := -24;
    RFE_UeberzKrd.Font.Name := 'Segoe UI';
    RFE_UeberzKrd.Font.Style := [fsBold];
    RFE_UeberzKrd.HeightStyle := ssAuto;
    RFE_UeberzKrd.HeightPercent := 100.00000000000000000;
    RFE_UeberzKrd.ParentFont := False;
    RFE_UeberzKrd.TabOrder := 1;
    RFE_UeberzKrd.Text := 'RFE_UeberzKrd';
    RFE_UeberzKrd.WidthPercent := 100.00000000000000000;
    SetEvent(RFE_UeberzKrd, Self, 'OnExit', 'RFE_AnlageVerExit');
    RFE_UeberzKrd.DataField := 'Hbss_Accounts_Payable_Overdrft_Credit';
    RFE_UeberzKrd.DataSource := StartingSolutionDataSource;
    RFE_KurzfrKrd.SetParentComponent(pnPassiva);
    RFE_KurzfrKrd.Name := 'RFE_KurzfrKrd';
    RFE_KurzfrKrd.Left := 521;
    RFE_KurzfrKrd.Top := 568;
    RFE_KurzfrKrd.Width := 150;
    RFE_KurzfrKrd.Height := 46;
    RFE_KurzfrKrd.ChildOrder := 16;
    RFE_KurzfrKrd.EditType := weNumeric;
    RFE_KurzfrKrd.ElementFont := efCSS;
    RFE_KurzfrKrd.Font.Charset := ANSI_CHARSET;
    RFE_KurzfrKrd.Font.Color := clWindowText;
    RFE_KurzfrKrd.Font.Height := -24;
    RFE_KurzfrKrd.Font.Name := 'Segoe UI';
    RFE_KurzfrKrd.Font.Style := [fsBold];
    RFE_KurzfrKrd.HeightStyle := ssAuto;
    RFE_KurzfrKrd.HeightPercent := 100.00000000000000000;
    RFE_KurzfrKrd.ParentFont := False;
    RFE_KurzfrKrd.TabOrder := 2;
    RFE_KurzfrKrd.Text := 'RFE_KurzfrKrd';
    RFE_KurzfrKrd.WidthPercent := 100.00000000000000000;
    SetEvent(RFE_KurzfrKrd, Self, 'OnExit', 'RFE_AnlageVerExit');
    RFE_KurzfrKrd.DataField := 'Hbss_Accounts_Payable_Short_Credit';
    RFE_KurzfrKrd.DataSource := StartingSolutionDataSource;
    RFE_LangfrKrd.SetParentComponent(pnPassiva);
    RFE_LangfrKrd.Name := 'RFE_LangfrKrd';
    RFE_LangfrKrd.Left := 521;
    RFE_LangfrKrd.Top := 613;
    RFE_LangfrKrd.Width := 150;
    RFE_LangfrKrd.Height := 46;
    RFE_LangfrKrd.ChildOrder := 17;
    RFE_LangfrKrd.EditType := weNumeric;
    RFE_LangfrKrd.ElementFont := efCSS;
    RFE_LangfrKrd.Font.Charset := ANSI_CHARSET;
    RFE_LangfrKrd.Font.Color := clWindowText;
    RFE_LangfrKrd.Font.Height := -24;
    RFE_LangfrKrd.Font.Name := 'Segoe UI';
    RFE_LangfrKrd.Font.Style := [fsBold];
    RFE_LangfrKrd.HeightStyle := ssAuto;
    RFE_LangfrKrd.HeightPercent := 100.00000000000000000;
    RFE_LangfrKrd.ParentFont := False;
    RFE_LangfrKrd.TabOrder := 3;
    RFE_LangfrKrd.Text := 'RFE_LangfrKrd';
    RFE_LangfrKrd.WidthPercent := 100.00000000000000000;
    SetEvent(RFE_LangfrKrd, Self, 'OnExit', 'RFE_AnlageVerExit');
    RFE_LangfrKrd.DataField := 'Hbss_Accounts_Payable_Medium_Credit';
    RFE_LangfrKrd.DataSource := StartingSolutionDataSource;
    RFE_PensRuckst.SetParentComponent(pnPassiva);
    RFE_PensRuckst.Name := 'RFE_PensRuckst';
    RFE_PensRuckst.Left := 521;
    RFE_PensRuckst.Top := 370;
    RFE_PensRuckst.Width := 150;
    RFE_PensRuckst.Height := 46;
    RFE_PensRuckst.ChildOrder := 19;
    RFE_PensRuckst.EditType := weNumeric;
    RFE_PensRuckst.ElementFont := efCSS;
    RFE_PensRuckst.Font.Charset := ANSI_CHARSET;
    RFE_PensRuckst.Font.Color := clWindowText;
    RFE_PensRuckst.Font.Height := -24;
    RFE_PensRuckst.Font.Name := 'Segoe UI';
    RFE_PensRuckst.Font.Style := [fsBold];
    RFE_PensRuckst.HeightStyle := ssAuto;
    RFE_PensRuckst.HeightPercent := 100.00000000000000000;
    RFE_PensRuckst.ParentFont := False;
    RFE_PensRuckst.TabOrder := 5;
    RFE_PensRuckst.Text := 'RFE_PensRuckst';
    RFE_PensRuckst.WidthPercent := 100.00000000000000000;
    SetEvent(RFE_PensRuckst, Self, 'OnExit', 'RFE_AnlageVerExit');
    RFE_PensRuckst.DataField := 'HBSS_ACCRUALS_PENSION';
    RFE_PensRuckst.DataSource := StartingSolutionDataSource;
    RFE_Verbindli.SetParentComponent(pnPassiva);
    RFE_Verbindli.Name := 'RFE_Verbindli';
    RFE_Verbindli.Left := 521;
    RFE_Verbindli.Top := 448;
    RFE_Verbindli.Width := 150;
    RFE_Verbindli.Height := 46;
    RFE_Verbindli.TabStop := False;
    RFE_Verbindli.ChildOrder := 20;
    RFE_Verbindli.EditType := weNumeric;
    RFE_Verbindli.ElementFont := efCSS;
    RFE_Verbindli.Font.Charset := ANSI_CHARSET;
    RFE_Verbindli.Font.Color := clWindowText;
    RFE_Verbindli.Font.Height := -24;
    RFE_Verbindli.Font.Name := 'Segoe UI';
    RFE_Verbindli.Font.Style := [fsBold];
    RFE_Verbindli.HeightStyle := ssAuto;
    RFE_Verbindli.HeightPercent := 100.00000000000000000;
    RFE_Verbindli.ParentFont := False;
    RFE_Verbindli.ReadOnly := True;
    RFE_Verbindli.TabOrder := 6;
    RFE_Verbindli.Text := 'RFE_Verbindli';
    RFE_Verbindli.WidthPercent := 100.00000000000000000;
    SetEvent(RFE_Verbindli, Self, 'OnExit', 'RFE_AnlageVerExit');
    RFE_Verbindli.DataField := 'Hbss_Accounts_Payable';
    RFE_Verbindli.DataSource := StartingSolutionDataSource;
    RFE_KapRueck.SetParentComponent(pnPassiva);
    RFE_KapRueck.Name := 'RFE_KapRueck';
    RFE_KapRueck.Left := 521;
    RFE_KapRueck.Top := 173;
    RFE_KapRueck.Width := 150;
    RFE_KapRueck.Height := 46;
    RFE_KapRueck.ChildOrder := 21;
    RFE_KapRueck.EditType := weNumeric;
    RFE_KapRueck.ElementFont := efCSS;
    RFE_KapRueck.Font.Charset := ANSI_CHARSET;
    RFE_KapRueck.Font.Color := clWindowText;
    RFE_KapRueck.Font.Height := -24;
    RFE_KapRueck.Font.Name := 'Segoe UI';
    RFE_KapRueck.Font.Style := [fsBold];
    RFE_KapRueck.HeightStyle := ssAuto;
    RFE_KapRueck.HeightPercent := 100.00000000000000000;
    RFE_KapRueck.ParentFont := False;
    RFE_KapRueck.TabOrder := 7;
    RFE_KapRueck.Text := 'RFE_KapRueck';
    RFE_KapRueck.WidthPercent := 100.00000000000000000;
    SetEvent(RFE_KapRueck, Self, 'OnExit', 'RFE_AnlageVerExit');
    RFE_KapRueck.DataField := 'Hbss_Curr_Equity_Capital_Reserves';
    RFE_KapRueck.DataSource := StartingSolutionDataSource;
    RFE_GewRueck.SetParentComponent(pnPassiva);
    RFE_GewRueck.Name := 'RFE_GewRueck';
    RFE_GewRueck.Left := 521;
    RFE_GewRueck.Top := 217;
    RFE_GewRueck.Width := 150;
    RFE_GewRueck.Height := 46;
    RFE_GewRueck.ChildOrder := 22;
    RFE_GewRueck.EditType := weNumeric;
    RFE_GewRueck.ElementFont := efCSS;
    RFE_GewRueck.Font.Charset := ANSI_CHARSET;
    RFE_GewRueck.Font.Color := clWindowText;
    RFE_GewRueck.Font.Height := -24;
    RFE_GewRueck.Font.Name := 'Segoe UI';
    RFE_GewRueck.Font.Style := [fsBold];
    RFE_GewRueck.HeightStyle := ssAuto;
    RFE_GewRueck.HeightPercent := 100.00000000000000000;
    RFE_GewRueck.ParentFont := False;
    RFE_GewRueck.TabOrder := 8;
    RFE_GewRueck.Text := 'RFE_GewRueck';
    RFE_GewRueck.WidthPercent := 100.00000000000000000;
    SetEvent(RFE_GewRueck, Self, 'OnExit', 'RFE_AnlageVerExit');
    RFE_GewRueck.DataField := 'Hbss_Curr_Equity_Provit_Reserves';
    RFE_GewRueck.DataSource := StartingSolutionDataSource;
    RFE_GewinnVort.SetParentComponent(pnPassiva);
    RFE_GewinnVort.Name := 'RFE_GewinnVort';
    RFE_GewinnVort.Left := 521;
    RFE_GewinnVort.Top := 262;
    RFE_GewinnVort.Width := 150;
    RFE_GewinnVort.Height := 46;
    RFE_GewinnVort.ChildOrder := 23;
    RFE_GewinnVort.EditType := weNumeric;
    RFE_GewinnVort.ElementFont := efCSS;
    RFE_GewinnVort.Font.Charset := ANSI_CHARSET;
    RFE_GewinnVort.Font.Color := clWindowText;
    RFE_GewinnVort.Font.Height := -24;
    RFE_GewinnVort.Font.Name := 'Segoe UI';
    RFE_GewinnVort.Font.Style := [fsBold];
    RFE_GewinnVort.HeightStyle := ssAuto;
    RFE_GewinnVort.HeightPercent := 100.00000000000000000;
    RFE_GewinnVort.ParentFont := False;
    RFE_GewinnVort.TabOrder := 9;
    RFE_GewinnVort.Text := 'RFE_GewinnVort';
    RFE_GewinnVort.WidthPercent := 100.00000000000000000;
    SetEvent(RFE_GewinnVort, Self, 'OnExit', 'RFE_AnlageVerExit');
    RFE_GewinnVort.DataField := 'Hbss_Curr_Equity_Retain_Earnings';
    RFE_GewinnVort.DataSource := StartingSolutionDataSource;
    RFE_EigenKap.SetParentComponent(pnPassiva);
    RFE_EigenKap.Name := 'RFE_EigenKap';
    RFE_EigenKap.Left := 521;
    RFE_EigenKap.Top := 82;
    RFE_EigenKap.Width := 150;
    RFE_EigenKap.Height := 46;
    RFE_EigenKap.TabStop := False;
    RFE_EigenKap.ChildOrder := 24;
    RFE_EigenKap.EditType := weNumeric;
    RFE_EigenKap.ElementFont := efCSS;
    RFE_EigenKap.Font.Charset := ANSI_CHARSET;
    RFE_EigenKap.Font.Color := clWindowText;
    RFE_EigenKap.Font.Height := -24;
    RFE_EigenKap.Font.Name := 'Segoe UI';
    RFE_EigenKap.Font.Style := [fsBold];
    RFE_EigenKap.HeightStyle := ssAuto;
    RFE_EigenKap.HeightPercent := 100.00000000000000000;
    RFE_EigenKap.ParentFont := False;
    RFE_EigenKap.ReadOnly := True;
    RFE_EigenKap.TabOrder := 10;
    RFE_EigenKap.Text := 'RFE_EigenKap';
    RFE_EigenKap.WidthPercent := 100.00000000000000000;
    SetEvent(RFE_EigenKap, Self, 'OnExit', 'RFE_AnlageVerExit');
    RFE_EigenKap.DataField := 'Hbss_Curr_Equity';
    RFE_EigenKap.DataSource := StartingSolutionDataSource;
    RFE_GezeichKap.SetParentComponent(pnPassiva);
    RFE_GezeichKap.Name := 'RFE_GezeichKap';
    RFE_GezeichKap.Left := 521;
    RFE_GezeichKap.Top := 127;
    RFE_GezeichKap.Width := 150;
    RFE_GezeichKap.Height := 46;
    RFE_GezeichKap.ChildOrder := 25;
    RFE_GezeichKap.EditType := weNumeric;
    RFE_GezeichKap.ElementFont := efCSS;
    RFE_GezeichKap.Font.Charset := ANSI_CHARSET;
    RFE_GezeichKap.Font.Color := clWindowText;
    RFE_GezeichKap.Font.Height := -24;
    RFE_GezeichKap.Font.Name := 'Segoe UI';
    RFE_GezeichKap.Font.Style := [fsBold];
    RFE_GezeichKap.HeightStyle := ssAuto;
    RFE_GezeichKap.HeightPercent := 100.00000000000000000;
    RFE_GezeichKap.ParentFont := False;
    RFE_GezeichKap.TabOrder := 11;
    RFE_GezeichKap.Text := 'RFE_GezeichKap';
    RFE_GezeichKap.WidthPercent := 100.00000000000000000;
    SetEvent(RFE_GezeichKap, Self, 'OnExit', 'RFE_AnlageVerExit');
    RFE_GezeichKap.DataField := 'Hbss_Curr_Equity_Signed_Capital';
    RFE_GezeichKap.DataSource := StartingSolutionDataSource;
    RFE_VerbndlKHG.SetParentComponent(pnPassiva);
    RFE_VerbndlKHG.Name := 'RFE_VerbndlKHG';
    RFE_VerbndlKHG.Left := 521;
    RFE_VerbndlKHG.Top := 658;
    RFE_VerbndlKHG.Width := 150;
    RFE_VerbndlKHG.Height := 46;
    RFE_VerbndlKHG.ChildOrder := 26;
    RFE_VerbndlKHG.EditType := weNumeric;
    RFE_VerbndlKHG.ElementFont := efCSS;
    RFE_VerbndlKHG.Font.Charset := ANSI_CHARSET;
    RFE_VerbndlKHG.Font.Color := clWindowText;
    RFE_VerbndlKHG.Font.Height := -24;
    RFE_VerbndlKHG.Font.Name := 'Segoe UI';
    RFE_VerbndlKHG.Font.Style := [fsBold];
    RFE_VerbndlKHG.HeightStyle := ssAuto;
    RFE_VerbndlKHG.HeightPercent := 100.00000000000000000;
    RFE_VerbndlKHG.ParentFont := False;
    RFE_VerbndlKHG.TabOrder := 12;
    RFE_VerbndlKHG.Text := 'RFE_VerbndlKHG';
    RFE_VerbndlKHG.WidthPercent := 100.00000000000000000;
    SetEvent(RFE_VerbndlKHG, Self, 'OnExit', 'RFE_AnlageVerExit');
    RFE_VerbndlKHG.DataField := 'Hbss_Accounts_Payable_Khg';
    RFE_VerbndlKHG.DataSource := StartingSolutionDataSource;
    RFE_BilSumPas.SetParentComponent(pnPassiva);
    RFE_BilSumPas.Name := 'RFE_BilSumPas';
    RFE_BilSumPas.Left := 522;
    RFE_BilSumPas.Top := 721;
    RFE_BilSumPas.Width := 150;
    RFE_BilSumPas.Height := 46;
    RFE_BilSumPas.TabStop := False;
    RFE_BilSumPas.ChildOrder := 25;
    RFE_BilSumPas.EditType := weNumeric;
    RFE_BilSumPas.ElementFont := efCSS;
    RFE_BilSumPas.HeightPercent := 100.00000000000000000;
    RFE_BilSumPas.ReadOnly := True;
    RFE_BilSumPas.Text := 'RFE_BilSumPas';
    RFE_BilSumPas.WidthPercent := 100.00000000000000000;
    pgDefaultData.SetParentComponent(PageControl);
    pgDefaultData.Name := 'pgDefaultData';
    pgDefaultData.Left := 0;
    pgDefaultData.Top := 20;
    pgDefaultData.Width := 1937;
    pgDefaultData.Height := 991;
    pgDefaultData.ElementClassName := 'h-full w-full overflow-auto flex flex-col p-4 gap-4';
    pgDefaultData.Caption := 'Vorgaben';
    pgDefaultData.ChildOrder := 3;
    pnStartingDefaults.SetParentComponent(pgDefaultData);
    pnStartingDefaults.Name := 'pnStartingDefaults';
    pnStartingDefaults.Left := 72;
    pnStartingDefaults.Top := 64;
    pnStartingDefaults.Width := 1161;
    pnStartingDefaults.Height := 607;
    pnStartingDefaults.Caption := 'pnStartingDefaults';
    pnStartingDefaults.ShowCaption := False;
    pnStartingDefaults.TabOrder := 0;
    WebLabel4.SetParentComponent(pnStartingDefaults);
    WebLabel4.Name := 'WebLabel4';
    WebLabel4.Left := 50;
    WebLabel4.Top := 68;
    WebLabel4.Width := 345;
    WebLabel4.Height := 29;
    WebLabel4.Caption := 'Verwaltung Abteilungen (%)';
    WebLabel4.ElementFont := efCSS;
    WebLabel4.Font.Charset := DEFAULT_CHARSET;
    WebLabel4.Font.Color := clWindowText;
    WebLabel4.Font.Height := -24;
    WebLabel4.Font.Name := 'Tahoma';
    WebLabel4.Font.Style := [fsBold];
    WebLabel4.HeightStyle := ssAuto;
    WebLabel4.HeightPercent := 100.00000000000000000;
    WebLabel4.ParentFont := False;
    WebLabel4.WidthPercent := 100.00000000000000000;
    WebLabel7.SetParentComponent(pnStartingDefaults);
    WebLabel7.Name := 'WebLabel7';
    WebLabel7.Left := 50;
    WebLabel7.Top := 133;
    WebLabel7.Width := 307;
    WebLabel7.Height := 29;
    WebLabel7.Caption := 'Verwaltung Institute (%)';
    WebLabel7.ElementFont := efCSS;
    WebLabel7.Font.Charset := DEFAULT_CHARSET;
    WebLabel7.Font.Color := clWindowText;
    WebLabel7.Font.Height := -24;
    WebLabel7.Font.Name := 'Tahoma';
    WebLabel7.Font.Style := [fsBold];
    WebLabel7.HeightStyle := ssAuto;
    WebLabel7.HeightPercent := 100.00000000000000000;
    WebLabel7.ParentFont := False;
    WebLabel7.WidthPercent := 100.00000000000000000;
    WebLabel8.SetParentComponent(pnStartingDefaults);
    WebLabel8.Name := 'WebLabel8';
    WebLabel8.Left := 50;
    WebLabel8.Top := 188;
    WebLabel8.Width := 485;
    WebLabel8.Height := 29;
    WebLabel8.Caption := 'Patienten Management Abteilungen (%)';
    WebLabel8.ElementFont := efCSS;
    WebLabel8.Font.Charset := DEFAULT_CHARSET;
    WebLabel8.Font.Color := clWindowText;
    WebLabel8.Font.Height := -24;
    WebLabel8.Font.Name := 'Tahoma';
    WebLabel8.Font.Style := [fsBold];
    WebLabel8.HeightStyle := ssAuto;
    WebLabel8.HeightPercent := 100.00000000000000000;
    WebLabel8.ParentFont := False;
    WebLabel8.WidthPercent := 100.00000000000000000;
    WebLabel13.SetParentComponent(pnStartingDefaults);
    WebLabel13.Name := 'WebLabel13';
    WebLabel13.Left := 50;
    WebLabel13.Top := 253;
    WebLabel13.Width := 402;
    WebLabel13.Height := 29;
    WebLabel13.Caption := 'Rationalisierung Abteilungen (%)';
    WebLabel13.ElementFont := efCSS;
    WebLabel13.Font.Charset := DEFAULT_CHARSET;
    WebLabel13.Font.Color := clWindowText;
    WebLabel13.Font.Height := -24;
    WebLabel13.Font.Name := 'Tahoma';
    WebLabel13.Font.Style := [fsBold];
    WebLabel13.HeightStyle := ssAuto;
    WebLabel13.HeightPercent := 100.00000000000000000;
    WebLabel13.ParentFont := False;
    WebLabel13.WidthPercent := 100.00000000000000000;
    WebLabel14.SetParentComponent(pnStartingDefaults);
    WebLabel14.Name := 'WebLabel14';
    WebLabel14.Left := 50;
    WebLabel14.Top := 313;
    WebLabel14.Width := 447;
    WebLabel14.Height := 29;
    WebLabel14.Caption := 'Patienten Management Institute (%)';
    WebLabel14.ElementFont := efCSS;
    WebLabel14.Font.Charset := DEFAULT_CHARSET;
    WebLabel14.Font.Color := clWindowText;
    WebLabel14.Font.Height := -24;
    WebLabel14.Font.Name := 'Tahoma';
    WebLabel14.Font.Style := [fsBold];
    WebLabel14.HeightStyle := ssAuto;
    WebLabel14.HeightPercent := 100.00000000000000000;
    WebLabel14.ParentFont := False;
    WebLabel14.WidthPercent := 100.00000000000000000;
    WebLabel15.SetParentComponent(pnStartingDefaults);
    WebLabel15.Name := 'WebLabel15';
    WebLabel15.Left := 50;
    WebLabel15.Top := 372;
    WebLabel15.Width := 364;
    WebLabel15.Height := 29;
    WebLabel15.Caption := 'Rationalisierung Institute (%)';
    WebLabel15.ElementFont := efCSS;
    WebLabel15.Font.Charset := DEFAULT_CHARSET;
    WebLabel15.Font.Color := clWindowText;
    WebLabel15.Font.Height := -24;
    WebLabel15.Font.Name := 'Tahoma';
    WebLabel15.Font.Style := [fsBold];
    WebLabel15.HeightStyle := ssAuto;
    WebLabel15.HeightPercent := 100.00000000000000000;
    WebLabel15.ParentFont := False;
    WebLabel15.WidthPercent := 100.00000000000000000;
    WebLabel16.SetParentComponent(pnStartingDefaults);
    WebLabel16.Name := 'WebLabel16';
    WebLabel16.Left := 120;
    WebLabel16.Top := 24;
    WebLabel16.Width := 62;
    WebLabel16.Height := 18;
    WebLabel16.Caption := 'Vorgaben';
    WebLabel16.HeightPercent := 100.00000000000000000;
    WebLabel16.HTMLType := tH3;
    WebLabel16.WidthPercent := 100.00000000000000000;
    WebDBEdit1.SetParentComponent(pnStartingDefaults);
    WebDBEdit1.Name := 'WebDBEdit1';
    WebDBEdit1.Left := 578;
    WebDBEdit1.Top := 58;
    WebDBEdit1.Width := 150;
    WebDBEdit1.Height := 46;
    WebDBEdit1.ChildOrder := 21;
    WebDBEdit1.EditType := weNumeric;
    WebDBEdit1.ElementFont := efCSS;
    WebDBEdit1.Font.Charset := ANSI_CHARSET;
    WebDBEdit1.Font.Color := clWindowText;
    WebDBEdit1.Font.Height := -24;
    WebDBEdit1.Font.Name := 'Segoe UI';
    WebDBEdit1.Font.Style := [fsBold];
    WebDBEdit1.HeightStyle := ssAuto;
    WebDBEdit1.HeightPercent := 100.00000000000000000;
    WebDBEdit1.ParentFont := False;
    WebDBEdit1.TabOrder := 7;
    WebDBEdit1.Text := 'RFE_Imobilien';
    WebDBEdit1.WidthPercent := 100.00000000000000000;
    SetEvent(WebDBEdit1, Self, 'OnExit', 'RFE_AnlageVerExit');
    WebDBEdit1.DataField := 'Hbdf_Administration_Department';
    WebDBEdit1.DataSource := StartingDefaultsDataSource;
    WebDBEdit2.SetParentComponent(pnStartingDefaults);
    WebDBEdit2.Name := 'WebDBEdit2';
    WebDBEdit2.Left := 578;
    WebDBEdit2.Top := 123;
    WebDBEdit2.Width := 150;
    WebDBEdit2.Height := 46;
    WebDBEdit2.ChildOrder := 21;
    WebDBEdit2.EditType := weNumeric;
    WebDBEdit2.ElementFont := efCSS;
    WebDBEdit2.Font.Charset := ANSI_CHARSET;
    WebDBEdit2.Font.Color := clWindowText;
    WebDBEdit2.Font.Height := -24;
    WebDBEdit2.Font.Name := 'Segoe UI';
    WebDBEdit2.Font.Style := [fsBold];
    WebDBEdit2.HeightStyle := ssAuto;
    WebDBEdit2.HeightPercent := 100.00000000000000000;
    WebDBEdit2.ParentFont := False;
    WebDBEdit2.TabOrder := 7;
    WebDBEdit2.Text := 'RFE_Imobilien';
    WebDBEdit2.WidthPercent := 100.00000000000000000;
    SetEvent(WebDBEdit2, Self, 'OnExit', 'RFE_AnlageVerExit');
    WebDBEdit2.DataField := 'Hbdf_Administration_Institute';
    WebDBEdit2.DataSource := StartingDefaultsDataSource;
    WebDBEdit3.SetParentComponent(pnStartingDefaults);
    WebDBEdit3.Name := 'WebDBEdit3';
    WebDBEdit3.Left := 578;
    WebDBEdit3.Top := 182;
    WebDBEdit3.Width := 150;
    WebDBEdit3.Height := 46;
    WebDBEdit3.ChildOrder := 21;
    WebDBEdit3.EditType := weNumeric;
    WebDBEdit3.ElementFont := efCSS;
    WebDBEdit3.Font.Charset := ANSI_CHARSET;
    WebDBEdit3.Font.Color := clWindowText;
    WebDBEdit3.Font.Height := -24;
    WebDBEdit3.Font.Name := 'Segoe UI';
    WebDBEdit3.Font.Style := [fsBold];
    WebDBEdit3.HeightStyle := ssAuto;
    WebDBEdit3.HeightPercent := 100.00000000000000000;
    WebDBEdit3.ParentFont := False;
    WebDBEdit3.TabOrder := 7;
    WebDBEdit3.Text := 'RFE_Imobilien';
    WebDBEdit3.WidthPercent := 100.00000000000000000;
    SetEvent(WebDBEdit3, Self, 'OnExit', 'RFE_AnlageVerExit');
    WebDBEdit3.DataField := 'Hbdf_Management_Department';
    WebDBEdit3.DataSource := StartingDefaultsDataSource;
    WebDBEdit4.SetParentComponent(pnStartingDefaults);
    WebDBEdit4.Name := 'WebDBEdit4';
    WebDBEdit4.Left := 578;
    WebDBEdit4.Top := 243;
    WebDBEdit4.Width := 150;
    WebDBEdit4.Height := 46;
    WebDBEdit4.ChildOrder := 21;
    WebDBEdit4.EditType := weNumeric;
    WebDBEdit4.ElementFont := efCSS;
    WebDBEdit4.Font.Charset := ANSI_CHARSET;
    WebDBEdit4.Font.Color := clWindowText;
    WebDBEdit4.Font.Height := -24;
    WebDBEdit4.Font.Name := 'Segoe UI';
    WebDBEdit4.Font.Style := [fsBold];
    WebDBEdit4.HeightStyle := ssAuto;
    WebDBEdit4.HeightPercent := 100.00000000000000000;
    WebDBEdit4.ParentFont := False;
    WebDBEdit4.TabOrder := 7;
    WebDBEdit4.Text := 'RFE_Imobilien';
    WebDBEdit4.WidthPercent := 100.00000000000000000;
    SetEvent(WebDBEdit4, Self, 'OnExit', 'RFE_AnlageVerExit');
    WebDBEdit4.DataField := 'Hbdf_Rationalize_Department';
    WebDBEdit4.DataSource := StartingDefaultsDataSource;
    WebDBEdit5.SetParentComponent(pnStartingDefaults);
    WebDBEdit5.Name := 'WebDBEdit5';
    WebDBEdit5.Left := 578;
    WebDBEdit5.Top := 303;
    WebDBEdit5.Width := 150;
    WebDBEdit5.Height := 46;
    WebDBEdit5.ChildOrder := 21;
    WebDBEdit5.EditType := weNumeric;
    WebDBEdit5.ElementFont := efCSS;
    WebDBEdit5.Font.Charset := ANSI_CHARSET;
    WebDBEdit5.Font.Color := clWindowText;
    WebDBEdit5.Font.Height := -24;
    WebDBEdit5.Font.Name := 'Segoe UI';
    WebDBEdit5.Font.Style := [fsBold];
    WebDBEdit5.HeightStyle := ssAuto;
    WebDBEdit5.HeightPercent := 100.00000000000000000;
    WebDBEdit5.ParentFont := False;
    WebDBEdit5.TabOrder := 7;
    WebDBEdit5.Text := 'RFE_Imobilien';
    WebDBEdit5.WidthPercent := 100.00000000000000000;
    SetEvent(WebDBEdit5, Self, 'OnExit', 'RFE_AnlageVerExit');
    WebDBEdit5.DataField := 'Hbdf_Management_Institute';
    WebDBEdit5.DataSource := StartingDefaultsDataSource;
    WebDBEdit6.SetParentComponent(pnStartingDefaults);
    WebDBEdit6.Name := 'WebDBEdit6';
    WebDBEdit6.Left := 578;
    WebDBEdit6.Top := 362;
    WebDBEdit6.Width := 150;
    WebDBEdit6.Height := 46;
    WebDBEdit6.ChildOrder := 21;
    WebDBEdit6.EditType := weNumeric;
    WebDBEdit6.ElementFont := efCSS;
    WebDBEdit6.Font.Charset := ANSI_CHARSET;
    WebDBEdit6.Font.Color := clWindowText;
    WebDBEdit6.Font.Height := -24;
    WebDBEdit6.Font.Name := 'Segoe UI';
    WebDBEdit6.Font.Style := [fsBold];
    WebDBEdit6.HeightStyle := ssAuto;
    WebDBEdit6.HeightPercent := 100.00000000000000000;
    WebDBEdit6.ParentFont := False;
    WebDBEdit6.TabOrder := 7;
    WebDBEdit6.Text := 'RFE_Imobilien';
    WebDBEdit6.WidthPercent := 100.00000000000000000;
    SetEvent(WebDBEdit6, Self, 'OnExit', 'RFE_AnlageVerExit');
    WebDBEdit6.DataField := 'Hbdf_Rationalize_Institute';
    WebDBEdit6.DataSource := StartingDefaultsDataSource;
    pnLeftNavigation.SetParentComponent(Self);
    pnLeftNavigation.Name := 'pnLeftNavigation';
    pnLeftNavigation.Left := 1621;
    pnLeftNavigation.Top := -69;
    pnLeftNavigation.Width := 272;
    pnLeftNavigation.Height := 1080;
    pnLeftNavigation.HeightStyle := ssAuto;
    pnLeftNavigation.WidthStyle := ssAuto;
    pnLeftNavigation.Alignment := taLeftJustify;
    pnLeftNavigation.Anchors := [];
    pnLeftNavigation.Caption := 'pnLeftNavigation';
    pnLeftNavigation.ChildOrder := 2;
    pnLeftNavigation.ElementFont := efCSS;
    pnLeftNavigation.ElementPosition := epRelative;
    pnLeftNavigation.ShowCaption := False;
    pnLeftNavigation.TabOrder := 2;
    lblPeriode.SetParentComponent(pnLeftNavigation);
    lblPeriode.Name := 'lblPeriode';
    lblPeriode.Left := 16;
    lblPeriode.Top := 365;
    lblPeriode.Width := 165;
    lblPeriode.Height := 29;
    lblPeriode.Caption := 'Gesch'#228'ftsjahr';
    lblPeriode.ElementFont := efCSS;
    lblPeriode.ElementPosition := epRelative;
    lblPeriode.Font.Charset := DEFAULT_CHARSET;
    lblPeriode.Font.Color := clWindowText;
    lblPeriode.Font.Height := -24;
    lblPeriode.Font.Name := 'Tahoma';
    lblPeriode.Font.Style := [fsBold];
    lblPeriode.HeightStyle := ssAuto;
    lblPeriode.HeightPercent := 100.00000000000000000;
    lblPeriode.ParentFont := False;
    lblPeriode.WidthStyle := ssAuto;
    lblPeriode.WidthPercent := 100.00000000000000000;
    lblAbteilung.SetParentComponent(pnLeftNavigation);
    lblAbteilung.Name := 'lblAbteilung';
    lblAbteilung.Left := 12;
    lblAbteilung.Top := 467;
    lblAbteilung.Width := 114;
    lblAbteilung.Height := 29;
    lblAbteilung.Caption := 'Abteilung';
    lblAbteilung.ElementFont := efCSS;
    lblAbteilung.ElementPosition := epRelative;
    lblAbteilung.Font.Charset := DEFAULT_CHARSET;
    lblAbteilung.Font.Color := clWindowText;
    lblAbteilung.Font.Height := -24;
    lblAbteilung.Font.Name := 'Tahoma';
    lblAbteilung.Font.Style := [fsBold];
    lblAbteilung.HeightStyle := ssAuto;
    lblAbteilung.HeightPercent := 100.00000000000000000;
    lblAbteilung.ParentFont := False;
    lblAbteilung.WidthStyle := ssAuto;
    lblAbteilung.WidthPercent := 100.00000000000000000;
    lblKrankenhaus.SetParentComponent(pnLeftNavigation);
    lblKrankenhaus.Name := 'lblKrankenhaus';
    lblKrankenhaus.Left := 12;
    lblKrankenhaus.Top := 570;
    lblKrankenhaus.Width := 155;
    lblKrankenhaus.Height := 29;
    lblKrankenhaus.Caption := 'Krankenhaus';
    lblKrankenhaus.ElementFont := efCSS;
    lblKrankenhaus.ElementPosition := epRelative;
    lblKrankenhaus.Font.Charset := DEFAULT_CHARSET;
    lblKrankenhaus.Font.Color := clWindowText;
    lblKrankenhaus.Font.Height := -24;
    lblKrankenhaus.Font.Name := 'Tahoma';
    lblKrankenhaus.Font.Style := [fsBold];
    lblKrankenhaus.HeightStyle := ssAuto;
    lblKrankenhaus.HeightPercent := 100.00000000000000000;
    lblKrankenhaus.ParentFont := False;
    lblKrankenhaus.WidthPercent := 100.00000000000000000;
    btnClose.SetParentComponent(pnLeftNavigation);
    btnClose.Name := 'btnClose';
    btnClose.Left := 10;
    btnClose.Top := 48;
    btnClose.Width := 250;
    btnClose.Height := 55;
    btnClose.Caption := 'Zur'#252'ck';
    btnClose.ChildOrder := 7;
    btnClose.ElementClassName := 'btn btn-outline';
    btnClose.ElementFont := efCSS;
    btnClose.ElementPosition := epRelative;
    btnClose.HeightStyle := ssAuto;
    btnClose.HeightPercent := 100.00000000000000000;
    btnClose.WidthStyle := ssAuto;
    btnClose.WidthPercent := 100.00000000000000000;
    SetEvent(btnClose, Self, 'OnClick', 'btnCloseClick');
    btnSave.SetParentComponent(pnLeftNavigation);
    btnSave.Name := 'btnSave';
    btnSave.Left := 10;
    btnSave.Top := 129;
    btnSave.Width := 250;
    btnSave.Height := 55;
    btnSave.Caption := 'Speichern';
    btnSave.ChildOrder := 7;
    btnSave.ElementClassName := 'btn btn-success btn-outline';
    btnSave.ElementFont := efCSS;
    btnSave.ElementPosition := epRelative;
    btnSave.HeightStyle := ssAuto;
    btnSave.HeightPercent := 100.00000000000000000;
    btnSave.WidthStyle := ssAuto;
    btnSave.WidthPercent := 100.00000000000000000;
    SetEvent(btnSave, Self, 'OnClick', 'btnSaveClick');
    spedPeriode.SetParentComponent(pnLeftNavigation);
    spedPeriode.Name := 'spedPeriode';
    spedPeriode.Left := 10;
    spedPeriode.Top := 400;
    spedPeriode.Width := 250;
    spedPeriode.Height := 57;
    spedPeriode.ElementClassName := 'input input-bordered';
    spedPeriode.HeightStyle := ssAuto;
    spedPeriode.WidthStyle := ssAuto;
    spedPeriode.AutoSize := False;
    spedPeriode.BorderStyle := bsSingle;
    spedPeriode.ChildOrder := 7;
    spedPeriode.Color := clWhite;
    spedPeriode.ElementFont := efCSS;
    spedPeriode.ElementPosition := epRelative;
    spedPeriode.Enabled := False;
    spedPeriode.Increment := 1;
    spedPeriode.MaxValue := 100;
    spedPeriode.MinValue := 0;
    spedPeriode.Role := '';
    spedPeriode.Value := 0;
    btnPrint.SetParentComponent(pnLeftNavigation);
    btnPrint.Name := 'btnPrint';
    btnPrint.Left := 3;
    btnPrint.Top := 744;
    btnPrint.Width := 250;
    btnPrint.Height := 55;
    btnPrint.Caption := 'Drucken';
    btnPrint.ChildOrder := 7;
    btnPrint.ElementClassName := 'btn border btn-outline btn-accent';
    btnPrint.ElementFont := efCSS;
    btnPrint.ElementPosition := epRelative;
    btnPrint.HeightStyle := ssAuto;
    btnPrint.HeightPercent := 100.00000000000000000;
    btnPrint.Visible := False;
    btnPrint.WidthStyle := ssAuto;
    btnPrint.WidthPercent := 100.00000000000000000;
    btnCancel.SetParentComponent(pnLeftNavigation);
    btnCancel.Name := 'btnCancel';
    btnCancel.Left := 10;
    btnCancel.Top := 815;
    btnCancel.Width := 250;
    btnCancel.Height := 55;
    btnCancel.Caption := 'Abbruch';
    btnCancel.ChildOrder := 7;
    btnCancel.ElementClassName := 'btn btn-error';
    btnCancel.ElementFont := efCSS;
    btnCancel.ElementPosition := epRelative;
    btnCancel.HeightStyle := ssAuto;
    btnCancel.HeightPercent := 100.00000000000000000;
    btnCancel.WidthStyle := ssAuto;
    btnCancel.WidthPercent := 100.00000000000000000;
    SetEvent(btnCancel, Self, 'OnClick', 'btnCancelClick');
    brnHelp.SetParentComponent(pnLeftNavigation);
    brnHelp.Name := 'brnHelp';
    brnHelp.Left := 19;
    brnHelp.Top := 929;
    brnHelp.Width := 250;
    brnHelp.Height := 55;
    brnHelp.Caption := 'Hilfe';
    brnHelp.ChildOrder := 7;
    brnHelp.ElementClassName := 'btn btn-info';
    brnHelp.ElementFont := efCSS;
    brnHelp.ElementPosition := epRelative;
    brnHelp.HeightStyle := ssAuto;
    brnHelp.HeightPercent := 100.00000000000000000;
    brnHelp.WidthStyle := ssAuto;
    brnHelp.WidthPercent := 100.00000000000000000;
    spedAbteilung.SetParentComponent(pnLeftNavigation);
    spedAbteilung.Name := 'spedAbteilung';
    spedAbteilung.Left := 6;
    spedAbteilung.Top := 502;
    spedAbteilung.Width := 250;
    spedAbteilung.Height := 57;
    spedAbteilung.ElementClassName := 'input input-bordered';
    spedAbteilung.HeightStyle := ssAuto;
    spedAbteilung.WidthStyle := ssAuto;
    spedAbteilung.AutoSize := False;
    spedAbteilung.BorderStyle := bsSingle;
    spedAbteilung.ChildOrder := 7;
    spedAbteilung.Color := clWhite;
    spedAbteilung.ElementFont := efCSS;
    spedAbteilung.ElementPosition := epRelative;
    spedAbteilung.Enabled := False;
    spedAbteilung.Increment := 1;
    spedAbteilung.MaxValue := 100;
    spedAbteilung.MinValue := 0;
    spedAbteilung.Role := '';
    spedAbteilung.Value := 0;
    spedKrankenhaus.SetParentComponent(pnLeftNavigation);
    spedKrankenhaus.Name := 'spedKrankenhaus';
    spedKrankenhaus.Left := 6;
    spedKrankenhaus.Top := 605;
    spedKrankenhaus.Width := 250;
    spedKrankenhaus.Height := 57;
    spedKrankenhaus.ElementClassName := 'input input-bordered';
    spedKrankenhaus.HeightStyle := ssAuto;
    spedKrankenhaus.WidthStyle := ssAuto;
    spedKrankenhaus.AutoSize := False;
    spedKrankenhaus.BorderStyle := bsSingle;
    spedKrankenhaus.ChildOrder := 7;
    spedKrankenhaus.Color := clWhite;
    spedKrankenhaus.ElementFont := efCSS;
    spedKrankenhaus.ElementPosition := epRelative;
    spedKrankenhaus.Enabled := False;
    spedKrankenhaus.Increment := 1;
    spedKrankenhaus.MaxValue := 100;
    spedKrankenhaus.MinValue := 0;
    spedKrankenhaus.Role := '';
    spedKrankenhaus.Value := 0;
    XDataWebConnection1.SetParentComponent(Self);
    XDataWebConnection1.Name := 'XDataWebConnection1';
    XDataWebConnection1.URL := 'https://hbm-online.eu/MFCWebServices/';
    XDataWebConnection1.Connected := True;
    XDataWebConnection1.Left := 1498;
    XDataWebConnection1.Top := 111;
    XDataWebDataSetStartingSolution.SetParentComponent(Self);
    XDataWebDataSetStartingSolution.Name := 'XDataWebDataSetStartingSolution';
    XDataWebDataSetStartingSolution.AfterOpen := XDataWebDataSetStartingSolutionAfterOpen;
    XDataWebDataSetStartingSolution.EntitySetName := 'Tblhbm_Starting_Solutions';
    XDataWebDataSetStartingSolution.Connection := XDataWebConnection1;
    XDataWebDataSetStartingSolution.Left := 1498;
    XDataWebDataSetStartingSolution.Top := 504;
    StartingSolutionDataSource.SetParentComponent(Self);
    StartingSolutionDataSource.Name := 'StartingSolutionDataSource';
    StartingSolutionDataSource.DataSet := XDataWebDataSetStartingSolution;
    SetEvent(StartingSolutionDataSource, Self, 'OnDataChange', 'StartingSolutionDataSourceDataChange');
    StartingSolutionDataSource.Left := 1290;
    StartingSolutionDataSource.Top := 504;
    StartingInvestmentWebDataSource.SetParentComponent(Self);
    StartingInvestmentWebDataSource.Name := 'StartingInvestmentWebDataSource';
    StartingInvestmentWebDataSource.DataSet := XDataWebDataSetStartingInvestment;
    SetEvent(StartingInvestmentWebDataSource, Self, 'OnDataChange', 'StartingInvestmentWebDataSourceDataChange');
    StartingInvestmentWebDataSource.Left := 1290;
    StartingInvestmentWebDataSource.Top := 440;
    XDataWebDataSetStartingInvestment.SetParentComponent(Self);
    XDataWebDataSetStartingInvestment.Name := 'XDataWebDataSetStartingInvestment';
    XDataWebDataSetStartingInvestment.AfterOpen := XDataWebDataSetStartingInvestmentAfterOpen;
    XDataWebDataSetStartingInvestment.EntitySetName := 'Tblhbm_Starting_Solution_Investments';
    XDataWebDataSetStartingInvestment.Connection := XDataWebConnection1;
    XDataWebDataSetStartingInvestment.Left := 1498;
    XDataWebDataSetStartingInvestment.Top := 440;
    StartingDefaultsDataSource.SetParentComponent(Self);
    StartingDefaultsDataSource.Name := 'StartingDefaultsDataSource';
    StartingDefaultsDataSource.DataSet := XDataWebDataSetStartingDefaults;
    SetEvent(StartingDefaultsDataSource, Self, 'OnDataChange', 'StartingInvestmentWebDataSourceDataChange');
    StartingDefaultsDataSource.Left := 1290;
    StartingDefaultsDataSource.Top := 568;
    XDataWebDataSetStartingDefaults.SetParentComponent(Self);
    XDataWebDataSetStartingDefaults.Name := 'XDataWebDataSetStartingDefaults';
    XDataWebDataSetStartingDefaults.AfterOpen := XDataWebDataSetStartingDefaultsAfterOpen;
    XDataWebDataSetStartingDefaults.EntitySetName := 'Tblhbm_Starting_Solution_Defaults';
    XDataWebDataSetStartingDefaults.Connection := XDataWebConnection1;
    XDataWebDataSetStartingDefaults.Left := 1498;
    XDataWebDataSetStartingDefaults.Top := 568;
  finally
    WaitMessage.AfterLoadDFMValues;
    PageControl.AfterLoadDFMValues;
    pgPageInvestition.AfterLoadDFMValues;
    pnInvestitionsgueter.AfterLoadDFMValues;
    strGridInvestGueter.AfterLoadDFMValues;
    pgPageAusstattung.AfterLoadDFMValues;
    pnAusstattung.AfterLoadDFMValues;
    La1_Stat1.AfterLoadDFMValues;
    La1_Stat2.AfterLoadDFMValues;
    La1_Stat3.AfterLoadDFMValues;
    WebLabel18.AfterLoadDFMValues;
    WebLabel19.AfterLoadDFMValues;
    La1_Inst1.AfterLoadDFMValues;
    lblAbteilung1.AfterLoadDFMValues;
    lblAbteilung2.AfterLoadDFMValues;
    lblAbteilung3.AfterLoadDFMValues;
    La1_Inst2.AfterLoadDFMValues;
    La1_Inst3.AfterLoadDFMValues;
    La1_Inst4.AfterLoadDFMValues;
    La1_Inst5.AfterLoadDFMValues;
    La1_Inst6.AfterLoadDFMValues;
    WebLabel29.AfterLoadDFMValues;
    WebLabel1.AfterLoadDFMValues;
    WebLabel2.AfterLoadDFMValues;
    WebLabel3.AfterLoadDFMValues;
    WebLabel5.AfterLoadDFMValues;
    lblArztAbteilung1.AfterLoadDFMValues;
    lblArztAbteilung2.AfterLoadDFMValues;
    lblArztAbteilung3.AfterLoadDFMValues;
    LF1_WahlLeistung1Abt1.AfterLoadDFMValues;
    LF1_WahlLeistung2Abt1.AfterLoadDFMValues;
    LF1_WahlLeistung3Abt1.AfterLoadDFMValues;
    LF1_ArztAbt1.AfterLoadDFMValues;
    LF1_PflegeAbt1.AfterLoadDFMValues;
    LF1_Inst1Pers.AfterLoadDFMValues;
    LF1_WahlLeistung1Abt2.AfterLoadDFMValues;
    LF1_WahlLeistung2Abt2.AfterLoadDFMValues;
    LF1_WahlLeistung3Abt2.AfterLoadDFMValues;
    LF1_ArztAbt2.AfterLoadDFMValues;
    LF1_PflegeAbt2.AfterLoadDFMValues;
    LF1_WahlLeistung1Abt3.AfterLoadDFMValues;
    LF1_WahlLeistung2Abt3.AfterLoadDFMValues;
    LF1_WahlLeistung3Abt3.AfterLoadDFMValues;
    LF1_ArztAbt3.AfterLoadDFMValues;
    LF1_PflegeAbt3.AfterLoadDFMValues;
    LF1_Inst2Pers.AfterLoadDFMValues;
    LF1_Inst3Pers.AfterLoadDFMValues;
    LF1_Inst4Pers.AfterLoadDFMValues;
    LF1_Inst5Pers.AfterLoadDFMValues;
    LF1_Inst6Pers.AfterLoadDFMValues;
    LF1_StartInd.AfterLoadDFMValues;
    pgPageBilanz.AfterLoadDFMValues;
    pnBilanz.AfterLoadDFMValues;
    pnAktiva.AfterLoadDFMValues;
    WebLabel6.AfterLoadDFMValues;
    WebLabel12.AfterLoadDFMValues;
    WebLabel31.AfterLoadDFMValues;
    WebLabel32.AfterLoadDFMValues;
    WebLabel33.AfterLoadDFMValues;
    WebLabel34.AfterLoadDFMValues;
    WebLabel38.AfterLoadDFMValues;
    WebLabel39.AfterLoadDFMValues;
    WebLabel40.AfterLoadDFMValues;
    WebLabel9.AfterLoadDFMValues;
    WebLabel10.AfterLoadDFMValues;
    WebLabel11.AfterLoadDFMValues;
    WebLabel41.AfterLoadDFMValues;
    WebLabel42.AfterLoadDFMValues;
    RFE_UmlaufVer.AfterLoadDFMValues;
    RFE_ForderLuL.AfterLoadDFMValues;
    RFE_ForderKHG.AfterLoadDFMValues;
    RFE_KassenBes.AfterLoadDFMValues;
    RFE_MedBedarf.AfterLoadDFMValues;
    RFE_Lebensmtl.AfterLoadDFMValues;
    RFE_Imobilien.AfterLoadDFMValues;
    RFE_MedtechAnl.AfterLoadDFMValues;
    RFE_Einrichtng.AfterLoadDFMValues;
    RFE_AnlageVer.AfterLoadDFMValues;
    RFE_BilSumAkt.AfterLoadDFMValues;
    pnPassiva.AfterLoadDFMValues;
    WebLabel43.AfterLoadDFMValues;
    WebLabel44.AfterLoadDFMValues;
    WebLabel48.AfterLoadDFMValues;
    WebLabel49.AfterLoadDFMValues;
    WebLabel50.AfterLoadDFMValues;
    WebLabel51.AfterLoadDFMValues;
    WebLabel55.AfterLoadDFMValues;
    WebLabel56.AfterLoadDFMValues;
    WebLabel61.AfterLoadDFMValues;
    WebLabel62.AfterLoadDFMValues;
    WebLabel63.AfterLoadDFMValues;
    WebLabel64.AfterLoadDFMValues;
    WebLabel65.AfterLoadDFMValues;
    WebLabel57.AfterLoadDFMValues;
    RFE_Rueckstell.AfterLoadDFMValues;
    RFE_UeberzKrd.AfterLoadDFMValues;
    RFE_KurzfrKrd.AfterLoadDFMValues;
    RFE_LangfrKrd.AfterLoadDFMValues;
    RFE_PensRuckst.AfterLoadDFMValues;
    RFE_Verbindli.AfterLoadDFMValues;
    RFE_KapRueck.AfterLoadDFMValues;
    RFE_GewRueck.AfterLoadDFMValues;
    RFE_GewinnVort.AfterLoadDFMValues;
    RFE_EigenKap.AfterLoadDFMValues;
    RFE_GezeichKap.AfterLoadDFMValues;
    RFE_VerbndlKHG.AfterLoadDFMValues;
    RFE_BilSumPas.AfterLoadDFMValues;
    pgDefaultData.AfterLoadDFMValues;
    pnStartingDefaults.AfterLoadDFMValues;
    WebLabel4.AfterLoadDFMValues;
    WebLabel7.AfterLoadDFMValues;
    WebLabel8.AfterLoadDFMValues;
    WebLabel13.AfterLoadDFMValues;
    WebLabel14.AfterLoadDFMValues;
    WebLabel15.AfterLoadDFMValues;
    WebLabel16.AfterLoadDFMValues;
    WebDBEdit1.AfterLoadDFMValues;
    WebDBEdit2.AfterLoadDFMValues;
    WebDBEdit3.AfterLoadDFMValues;
    WebDBEdit4.AfterLoadDFMValues;
    WebDBEdit5.AfterLoadDFMValues;
    WebDBEdit6.AfterLoadDFMValues;
    pnLeftNavigation.AfterLoadDFMValues;
    lblPeriode.AfterLoadDFMValues;
    lblAbteilung.AfterLoadDFMValues;
    lblKrankenhaus.AfterLoadDFMValues;
    btnClose.AfterLoadDFMValues;
    btnSave.AfterLoadDFMValues;
    spedPeriode.AfterLoadDFMValues;
    btnPrint.AfterLoadDFMValues;
    btnCancel.AfterLoadDFMValues;
    brnHelp.AfterLoadDFMValues;
    spedAbteilung.AfterLoadDFMValues;
    spedKrankenhaus.AfterLoadDFMValues;
    XDataWebConnection1.AfterLoadDFMValues;
    XDataWebDataSetStartingSolution.AfterLoadDFMValues;
    StartingSolutionDataSource.AfterLoadDFMValues;
    StartingInvestmentWebDataSource.AfterLoadDFMValues;
    XDataWebDataSetStartingInvestment.AfterLoadDFMValues;
    StartingDefaultsDataSource.AfterLoadDFMValues;
    XDataWebDataSetStartingDefaults.AfterLoadDFMValues;
  end;
end;

end.


